(function () {

    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);

    // Inicializa o modulo angular
    angular
        .module('trh', [
            'ngAnimate',
            'ngCookies',
            'ngTouch',
            'ngSanitize',
            'ngMessages',
            'ngAria',
            'ngResource',
            'oc.lazyLoad',
            'ui.router',
            'ui.bootstrap',
            'firebase',
            'ja.qr',
            'pdf',
            'uiCropper'
        ]);
})();

(function () {

    'use strict';

    angular.module('trh')
        .controller('MainController', MainController);

    MainController.$inject = ['$rootScope', '$scope', "Auth", '$firebaseObject', 'AtualizaNotificacao', '$state', 'FirebaseService', '$timeout'];

    /**
     * Controller principal
     *
     * @param {*} $scope
     * @param {*} Auth
     * @param {*} $firebaseObject
     * @param {*} AtualizaNotificacao
     * @param {*} $state
     * @param {*} FirebaseService
     */
    function MainController($rootScope, $scope, Auth, $firebaseObject, AtualizaNotificacao, $state, FirebaseService, $timeout) {
        // View Model
        var vm = this;
        mixpanel.track("/main");
        /***************************************************
         *** Attributes
         ***************************************************/
        vm.userId = null;
        vm.auth = null;
        vm.rootRef = null;
        vm.objUsuario = {};
        vm.objEmpresa = {};
        vm.objParametro = {};
        vm.concluidos = 0;
        vm.total = 0;
        vm.porcentagem = 0;
        vm.banners = [];
        vm.myCroppedImage = "";
        vm.myImage = "";
        vm.nomePerfil = "";
        vm.cargoPerfil = "";
        vm.areaPerfil = "";

        // Recupera o userId

        /***************************************************
         *** Functions
         ***************************************************/
        vm.getUserId = getUserId;
        vm.getUsuariosConteudo = getUsuariosConteudo;
        vm.incluirUsuariosConteudos = incluirUsuariosConteudos;
        vm.grafico = grafico;
        vm.getDataBanners = getDataBanners;
        vm.IrParaNotificacoes = IrParaNotificacoes;
        vm.IrParaConteudos = IrParaConteudos;
        vm.LogOut = LogOut;
        vm.updateSenha = updateSenha;
        vm.lstAllTemas = [];
        vm.idArea = null;
        vm.idPerfil = null;
        vm.setTemas = setTemas;
        vm.alterarFoto = alterarFoto;
        vm.removeUpload = removeUpload;
        vm.updatePerfil = updatePerfil;
        vm.fecharModal = fecharModal;

        /***************************************************
         *** Initialize
         ***************************************************/
        init();

        /**
         * Inicialização
         *
         */
        function init() {
            vm.auth = Auth;
            vm.getUserId();
            verifyAuth();
            atualizaNotificacao();

            vm.rootRef = firebase.database().ref();
            vm.getUsuariosConteudo();
            vm.getDataBanners();
            vm.grafico();
            angular.element("body").click(function () {
                angular.element(".dropdown").removeClass("open");
            });

            if (!$scope.$$phase)
                $scope.$apply();
        }

        $rootScope.$on('$stateChangeStart',
            function (event, toState, toParams, fromState, fromParams) {
                setTimeout(function () {
                    vm.grafico();
                }, 2000)
                mixpanel.track(toState["url"]);
            })

        /***************************************************
         *** Public Methods
         ***************************************************/

        /**
         * Obtém o userId
         *
         * @returns
         */
        function getUserId() {
            if (sessionStorage.getItem("codUsuarioLogado") != undefined)
                vm.userId = sessionStorage.getItem("codUsuarioLogado");

            if (!vm.userId) {
                document.location.href = "#/login";
                return;
            }

        }

        /**
         *
         *
         */
        function getUsuariosConteudo() {

            $firebaseObject(vm.rootRef.child('usuarios').child(vm.userId)).$loaded(function (snap) {

                /*Pegar logomarca */

                vm.objUsuario = snap;

                vm.nomePerfil = vm.objUsuario.name;
                if (firebaseConfig.clientName == "abaris") {
                    mixpanel.identify(vm.objUsuario.name);
                } else {
                    mixpanel.identify(vm.userId);
                }

                if ($state.current.name == 'index.main') {
                    try {
                        vm.incluirUsuariosConteudos(vm.userId, snap.temas);
                    } catch (error) {
                        console.log("Usuario sem tema cadastrado");
                    }

                } else {
                    var inicial = initial();
                    inicial.then(function (result) {
                        vm.grafico();
                    });
                }

                try {
                    vm.rootRef.child('areas').child(vm.objUsuario.area).on("value", function (snp) {
                        if (snp && snp.val()) {
                            vm.objUsuario["areaName"] = snp.val().nome;
                            vm.areaPerfil = snp.val().nome;

                        }
                    });
                    vm.rootRef.child('cargos').child(vm.objUsuario.cargo).on("value", function (snp) {
                        if (snp && snp.val()) {
                            vm.objUsuario["cargoName"] = snp.val().nome;
                            vm.cargoPerfil = snp.val().nome;
                        }
                    });
                    mixpanel.people.set({
                        "$email": vm.objUsuario.email, // only special properties need the $
                        "$last_login": new Date(), // properties can be dates...
                        "nome": vm.objUsuario.name,
                        "cargo": vm.objUsuario["cargoName"], // feel free to define your own properties
                        "area": vm.objUsuario["areaName"] // feel free to define your own properties
                    });

                } catch (error) {
                    console.log("Usuario sem área e perfil cadastrado");
                }
                try {
                    //debugger;
                    FirebaseService.getRecord('empresas', vm.objUsuario.empresa,

                        function (objEmpresa) {
                            vm.objEmpresa = objEmpresa;
                        });

                } catch (error) {
                    vm.objEmpresa = null;
                    console.log("Usuario sem empresa cadastrado");
                }


                //Teste parâmetro
                FirebaseService.getRecord('parametros', vm.objParametro.empresa,

                    function (objParametro) {
                        vm.objParametro = objParametro;
                    });

                $timeout(function () {
                    angular.element("#side-menu").slimScroll({
                        height: angular.element("body").innerHeight() - angular.element(".nav-header").innerHeight() - 60 + "px"
                    });
                }, 2000);

            });
        }

        /**
         *
         *
         * @param {*} key
         * @param {*} temas
         */
        function incluirUsuariosConteudos(key, temas) {

            var promises = [];
            promises.push(vm.rootRef.child('areas').child(vm.objUsuario.area).once("value"));
            promises.push(vm.rootRef.child('cargos').child(vm.objUsuario.cargo).once("value"));

            Promise.all(promises)
                .then(function (objResponseList) {
                    if (objResponseList[0]) {
                        vm.idArea = objResponseList[0].val();
                    }
                    if (objResponseList[1]) {
                        vm.idPerfil = objResponseList[1].val();
                    }
                    vm.lstAllTemas = [];
                    if (!vm.idArea) {
                        vm.idArea["temas"] = [];
                    }
                    if (!vm.idPerfil) {
                        vm.idPerfil["temas"] = [];
                    }

                    //vm.lstAllTemas.concat(vm.idArea.temas).concat(vm.idPerfil.temas);
                    if (temas) {
                        temas = temas.concat(vm.idArea.temas ? vm.idArea.temas : null).concat(vm.idPerfil.temas ? vm.idPerfil.temas : null);
                    } else {
                        temas = [];
                        temas = temas.concat(vm.idArea.temas ? vm.idArea.temas : null).concat(vm.idPerfil.temas ? vm.idPerfil.temas : null);
                    }

                    vm.objUsuario["temas"] = temas.filter(function (v, i, a) {
                        return a.indexOf(v) === i
                    });

                    var contentUsu = {
                        name: vm.objUsuario.name,
                        email: vm.objUsuario.email,
                        login: vm.objUsuario.login.toLowerCase(),
                        password: vm.objUsuario.password,
                        area: vm.objUsuario.area ? vm.objUsuario.area : '',
                        cargo: vm.objUsuario.cargo ? vm.objUsuario.cargo : '',
                        empresa: vm.objUsuario.empresa ? vm.objUsuario.empresa : '',
                        admin: vm.objUsuario.admin,
                        foto: vm.objUsuario.foto,
                        temas: vm.objUsuario["temas"]
                    }
                    vm.rootRef.child("usuarios").child(key).update(contentUsu);
                    //FirebaseService.update('usuarios', vm.objUsuario);

                    if (temas.length > 0) {
                        try {
                            var count = 0;
                            vm.rootRef.child('conteudos').on('child_added', function (snap) {
                                count++;

                                vm.rootRef.child("usuarios-conteudos").child(key).child(snap.key).once("value", function (snp) {

                                    if (snp.val() != null) {

                                        if (temas.indexOf(snp.val().temaId) == -1) {
                                            vm.rootRef.child("usuarios-conteudos").child(key).child(snap.key).remove();
                                        } else {
                                            var content = {};
                                            if (snap.val().temas == snp.val().temaId) {
                                                content[snap.key] = {
                                                    status: snp.val().status,
                                                    temaId: snap.val().temas,
                                                    comentario: snp.val().comentario != undefined ? snp.val().comentario : null,
                                                    curtiuConteudo: snp.val().curtiuConteudo != undefined ? snp.val().curtiuConteudo : null
                                                };

                                                vm.rootRef.child("usuarios-conteudos").child(key).update(content).then(function () {});
                                            }
                                        }

                                    } else {
                                        var content = {};
                                        if (temas.indexOf(snap.val().temas) != -1) {
                                            content[snap.key] = {
                                                status: "novo",
                                                temaId: snap.val().temas
                                            };
                                            vm.rootRef.child("usuarios-conteudos").child(key).update(content).then(function () {});
                                        }
                                    }

                                }).then(function () {
                                    count--;
                                    if (count <= 0) {
                                        var inicial = initial();
                                        inicial.then(function (result) {
                                            vm.grafico();
                                            try {
                                                atualizaNotificacao();
                                            } catch (error) {

                                            }

                                        });
                                    }
                                });
                            });
                        } catch (error) {
                            console.log("Usuario sem tema cadastrado");
                        }
                    }




                });





        }

        function setTemas(value) {
            var temas;
            if (value) {
                if (vm.lstAllTemas) {
                    temas = vm.lstAllTemas.concat(value);
                } else {
                    temas = value;
                }
            } else {
                if (vm.lstAllTemas) {
                    temas = vm.lstAllTemas;
                } else {
                    temas = null;
                }
            }
            return temas;
        }

        /**
         *
         *
         */
        function grafico() {

            if (c3) {
                c3.generate({
                    bindto: '#grafico',
                    data: {
                        columns: [
                            ['concluídos', vm.porcentagem]
                        ],
                        type: 'gauge'
                    },
                    gauge: {
                        label: {
                            format: function (value, ratio) {
                                return value + "%";
                            },
                            show: true,
                        },
                        min: 0,
                        max: 100,
                        width: 39,
                        units: "concluídos"
                    },
                    color: {
                        pattern: ['#FF0000', '#F97600', '#F6C600', '#60B044'],
                        threshold: {
                            //unit: 'value', // percentage is default
                            //max: 200, // 100 is default
                            values: [30, 60, 90, 100]
                        }
                    }
                });
            }

        }

        /**
         *
         *
         * @returns
         */
        function getDataBanners() {

            var items = {};
            items["imagens"] = [];
            var promises = [];
            var promise_banners = firebase.database().ref("banners").once('value');
            promises.push(promise_banners);
            return Promise.all(promises).then(function (resp) {

                var banners = resp[0].val();
                for (var k in banners) {
                    items["imagens"].push(banners[k]);
                }
                vm.banners = items;
                angular.element(".carousel-inner .item:first").addClass("active")
            });

        }

        /**
         *
         *
         * @param {*} e
         */
        function IrParaNotificacoes(e) {
            e.stopPropagation();
            e.preventDefault();

            if (angular.element(".dropdown").hasClass("open")) {
                angular.element(".dropdown").removeClass("open");
            } else {
                angular.element("#btNotificacoes").dropdown('toggle');
            }

            //document.getElementById("btNotificacoes").click();
        }

        /**
         *
         *
         */
        function IrParaConteudos() {
            document.location.href = "#/index/temas";
        }

        /**
         *
         *
         */
        function LogOut() {
            // vm.auth.$signOut().then(function () {
            //     sessionStorage.removeItem("codUsuarioLogado");
            //     document.location.href = "#/login";

            // });
            sessionStorage.removeItem("codUsuarioLogado");
            document.location.href = "#/login";
        }

        /**
         *
         *
         * @param {*} value
         * @returns
         */
        function updateSenha(value) {
            var user = firebase.auth().currentUser;

            if (user != null) {
                if (value == undefined) {
                    alert("Os campos senha atual, nova senha e confirmar senha são de preenchimento obrigatório");
                    return;
                }
                if (value.novaSenha != value.confirmaSenha) {
                    alert("Os campos nova senha e confirmar senha devem possuir o mesmo valor");
                    return;
                }

                if (value.novaSenha.length < 6) {
                    alert("A senha deve conter no mínimo 6 caracteres");
                    return;
                }

                var credentials = firebase.auth.EmailAuthProvider.credential(
                    user.email,
                    value.senhaAtual
                );

                user.reauthenticateWithCredential(credentials).then(function () {
                    user.updatePassword(value.novaSenha).then(function () {
                        alert("Senha alterada com sucesso");
                    }).catch(function (error) {
                        alert("Um erro aconteceu durante a solicitação de alteração de senha, tente novamente. Se o erro persistir contate o suporte técnico.");
                    });
                }).catch(function (error) {
                    if (error.code == "auth/user-disabled") {
                        alert("Usuário desabilitado pelo administrador.");
                    } else {
                        alert("Senha atual incorreta. Por Favor, tente novamente.");
                    }
                });

            } else {
                document.location.href = "#/login";
            }
        }

        /***************************************************
         *** Private Methods
         ***************************************************/

        /**
         * Verifica usuário logado
         *
         */
        function verifyAuth() {
            vm.auth.$onAuthStateChanged(function (firebaseUser) {
                if (!firebaseUser && vm.userId == undefined) {
                    document.location.href = "#/login";
                }
            });
        }

        /**
         * Atualização notificação
         *
         */
        function atualizaNotificacao() {
            AtualizaNotificacao.notificacao();
        }

        /**
         *
         *
         * @returns
         */
        function initial() {
            return new Promise(function (resolve) {
                var usuariosConteudos = vm.rootRef.child('usuarios-conteudos');

                usuariosConteudos.child(vm.userId).on("child_added", function (snapshot) {
                    vm.rootRef.child('conteudos').child(snapshot.key).once("value").then(function (snapConteudo) {
                        if (snapConteudo.val() != null) {
                            $firebaseObject(vm.rootRef.child('temas').child(snapshot.val().temaId)).$loaded().then(function (snap) {
                                if (snap.$value != null) {
                                    vm.total++;
                                    if (snapshot.val().status === "concluído") {
                                        vm.concluidos++;
                                    }
                                    var porcentagem = Math.round(((vm.concluidos * 100) / vm.total)) + "%";
                                    vm.porcentagem = porcentagem.split("%")[0];
                                    resolve(vm.porcentagem);
                                } else {
                                    vm.rootRef.child("usuarios-conteudos").child(vm.userId).child(snapshot.key).remove();
                                }
                            }); //temas
                        } else {
                            vm.rootRef.child("usuarios-conteudos").child(vm.userId).child(snapshot.key).remove();
                        }
                    }); //conteudos
                }); //usuarios-temas
            });
        }

        /**
         * Upload de imagem
         *
         */
        function alterarFoto(input) {

            if (input.files && input.files[0]) {

                var reader = new FileReader();

                reader.onload = function (e) {
                    $('.image-upload-wrap').hide();

                    if (!$scope.$$phase) {
                        $scope.$apply(function ($scope) {
                            vm.myImage = e.target.result;
                        });
                    }


                    $('.file-upload-content').show();

                    $('.image-title').html(input.files[0].name);
                };

                reader.readAsDataURL(input.files[0]);
            }
        }

        function removeUpload() {
            //$('.file-upload-input').replaceWith($('.file-upload-input').clone());
            $('.file-upload-content').hide();
            $('.image-upload-wrap').show();
            vm.myImage = "";
            vm.myCroppedImage = "";
            if (!$scope.$$phase) {
                $scope.$apply(function ($scope) {
                    vm.myImage = "";
                    vm.myCroppedImage = "";
                });
            }
        }

        function updatePerfil() {
            if ($("#nomePerfil").val() == "") {
                alert("Você deve preencher corretamente todos os itens obrigatórios.");
                return false;
            }
            vm.rootRef.child('usuarios').child(vm.userId).once("value", function (snp) {

                if (snp && snp.val()) {

                    var user = snp.val();
                    if (vm.myCroppedImage) {
                        user["foto"] = vm.myCroppedImage;
                    }
                    user["name"] = vm.nomePerfil;


                    vm.rootRef.child("usuarios").child(vm.userId).update(user).then(function () {
                        alert("Ação realizada com sucesso");
                        removeUpload();
                        angular.element("#modalEditarPerfil").modal('hide');
                    });
                }
            });

        }

        function fecharModal() {
            var nome = vm.objUsuario.name;
            var image = vm.objUsuario.foto;

            var isImageDusty = (vm.myCroppedImage != "" ? (vm.myCroppedImage != image) : false);

            if (vm.nomePerfil != nome || isImageDusty) {
                if (confirm("Existem itens pendentes de salvamento. Deseja encerrar e perder os dados não salvos?")) {
                    angular.element('#modalEditarPerfil').modal('hide');
                }
            } else {
                angular.element('#modalEditarPerfil').modal('hide');
            }

            $('#modalEditarPerfil').on('shown.bs.modal', function () {
                vm.nomePerfil = vm.objUsuario.name;
                vm.removeUpload();
            });

        }
    }
})();

'use strict';

angular.module('trh')
  .controller('TemasController', ['$scope', '$http', 'Auth', '$firebaseObject', 'AtualizaNotificacao', function ($scope, $http, Auth, $firebaseObject, AtualizaNotificacao) {
    var userId = sessionStorage.getItem("codUsuarioLogado");
    if (!userId) {
      document.location.href = "#/login";
      return;
    }
    $scope.auth = Auth;
    // any time auth state changes, add the user data to scope
    $scope.auth.$onAuthStateChanged(function (firebaseUser) {
      if (!firebaseUser && userId != undefined) {
        document.location.href = "#/login";
      }
    });

    AtualizaNotificacao.notificacao();

    var rootRef = firebase.database().ref();
    var temas = rootRef.child('temas');
    var usuariosConteudos = rootRef.child('usuarios-conteudos');

    var promises = [];
    var retorno = [];
    $scope.temas = {};

    //temas.on('child_added', function (snapshot) {

    var promiseUsuariosConteudos = usuariosConteudos.child(userId).once('value') //no caso de pedidos, vai trazer varios
    var promiseTemas = temas.once('value') //no caso do author, vai trazer 1 só

    promises.push(promiseUsuariosConteudos, promiseTemas) //inserindo as promises na fila

    // Quando terminar todas as minhas promises, ai sim eu monto a resposta final

    Promise.all(promises).then(function (resp) {

      var conteudos = resp[0].val();
      var temas = resp[1].val();
      for (var key in temas) {
        var count = 0;
        var countConcluido = 0;
        var nome = temas[key];
        var temaId = key;
        for (var k in conteudos) {
          if (conteudos[k].temaId == temaId) {
            if (conteudos[k].status == 'concluído') {
              countConcluido++;
            }
            count++;
          }
        }
        if (count > 0) {
          retorno.push({
            nome: nome,
            cod: temaId,
            concluidos: countConcluido,
            total: count,
            porcentagem: Math.round(((countConcluido * 100) / count)) + "%",
            color: parseInt(Math.round((countConcluido * 100) / count)) > 50 ? "green" : "red"
          });
        }
      }

      $scope.$apply(function(){
        $scope.temas = retorno;
      });
    })

    //});

    // $firebaseObject(rootRef.child('usuarios').child(userId)).$loaded().then(function (usuario) {
    //   var temasUsuario = usuario.temas.split(',');

    //   temasUsuario.forEach(function (child) {
    //     $firebaseObject(temas.child(child)).$loaded(function (item) {
    //       var porcentagem = Math.round(((snapshot.val().concluidos * 100) / snapshot.val().total)) + "%";
    //           retorno.push({
    //             nome: item.$value,
    //             cod: item.$id,
    //             concluidos: snapshot.val().concluidos,
    //             total: snapshot.val().total,
    //             porcentagem: porcentagem,
    //             color: parseInt(porcentagem.split("%")[0]) > 50 ? "green" : "red"
    //           })
    //           $scope.temas = retorno;
    //           console.log(retorno);
    //     });
    //   });


    // });

    // usuariosTemas.child(userId).on("child_added", function (snapshot) {
    //   var temaObj = $firebaseObject(temas.child(snapshot.key));
    //   //console.log(snapshot.val().concluidos)
    //   temaObj.$loaded().then(function (item) {
    //     var porcentagem = Math.round(((snapshot.val().concluidos * 100) / snapshot.val().total)) + "%";
    //     retorno.push({
    //       nome: item.$value,
    //       cod: item.$id,
    //       concluidos: snapshot.val().concluidos,
    //       total: snapshot.val().total,
    //       porcentagem: porcentagem,
    //       color: parseInt(porcentagem.split("%")[0]) > 50 ? "green" : "red"
    //     })
    //     $scope.temas = retorno;
    //     console.log(retorno);
    //   });
    // })


    //getTemasConteudos(userId)

    // temas.on('child_added', function (snapshot) {
    //   var nome = snapshot.val();
    //   var temaId = snapshot.key;

    //   var promiseUsuariosTemas = usuariosTemas.child(userId).child(snapshot.key).once('value') //no caso do author, vai trazer 1 só
    //   //var promiseUsuariosConteudos = usuariosConteudos.child(userId).once('value') //no caso de pedidos, vai trazer varios

    //   promises.push(promiseUsuariosTemas) //inserindo as promises na fila

    //   // Quando terminar todas as minhas promises, ai sim eu monto a resposta final

    //   Promise.all(promises).then(function (resp) {

    //     //resp[0].val().map(function (item, ix) {
    //       console.log(resp[0])
    //       // if (temaId == item) {
    //       //   retorno.push({
    //       //     nome: snapshot.val(),
    //       //     temaId: item,

    //       //   });
    //       // }

    //     //});


    //     //console.log("conta " + count);
    //     // var thisUsuarioConteudos = resp[1].val().map(function (cont) {
    //     //   return cont.status
    //     // });

    //     //array.push(livro.nome + ' - ' + nomeAuthor + ' - ' + thisUsuarioConteudos.join('\n'))

    //     //console.log(array.join('\n'))
    //     //console.log(resp[1].val());
    //     console.log(retorno);

    //   })

    // })

    //console.log($firebaseObject(usuariosConteudos.child(userId)));
    /*function getConteudos(key) {
      var contador = 0;
      return usuariosConteudos.child(key).on('child_added', function (snap) {
        contador++;
        //console.log(snap.child("status").val());
        var conteudo = $firebaseObject(conteudos.child(snap.key));
        console.log(conteudo)
        //retorno.push(conteudos);
        $scope.qtd = contador;
        $scope.final = contador;

        $scope.porcentagem = Math.round((($scope.final * 100) / $scope.qtd)) + "%";
        $scope.color = parseInt($scope.porcentagem.split("%")[0]) > 50 ? "green" : "red";
        $scope.description = $scope.final + " de " + $scope.qtd + " cursos finalizados"


      })
    }*/

    //getTemas(userId);
    //getConteudos(userId);


    $scope.IrParaConteudo = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var cod = jQuery(e.currentTarget).attr("data-codigo");
      document.location.href = "#/index/conteudos?cod=" + cod;
    }

  }]);

'use strict';

angular.module('trh')
  .controller('EsqueceuSenhaController', ['$scope', '$firebaseAuth', '$firebaseArray', '$location', function ($scope, $firebaseAuth, $firebaseArray, $location) {
    var auth = firebase.auth();
    firebase.auth().useDeviceLanguage();
    $scope.enviaEmail = function () {
      var emailAddress = $scope.email;

      if (emailAddress != undefined) {
        auth.sendPasswordResetEmail(emailAddress).then(function () {
          alert("Uma mensagem com link para redefinir a senha foi enviado para o email solicitado");
        }).catch(function (error) {
          if (error.code == "auth/user-not-found") {
            alert("Usuário não cadastrado");
          } else {
            alert("Por favor, insira um email válido");
          }
        });
      } else {
        alert("Por favor, insira um email válido");
      }      
    }
    
  }]);

(function () {
    'use strict';

    angular.module('trh').controller('LoginController', LoginController);

    LoginController.$inject = ['$scope', 'utilsService', 'Auth', '$firebaseArray'];

    /**
     * Controller do login
     *
     * @param {object} $scope Objeto escopo angular
     * @param {object} objUtilsService Objeto utils
     * @param {object} Auth Firebase autenticação
     * @param {object} $firebaseArray Firebase Array
     */
    function LoginController($scope, objUtilsService, Auth, $firebaseArray) {
        var vm = this;

        /***************************************************
         *** Attributes
         ***************************************************/
        // Objeto de autenticação do firebase
        vm.loginObj = {};

        // Parâmetros
        vm.objParametros = {};

        // Objeto do usuário logado
        vm.objUserAuth = {};

        // Objeto de login
        vm.objLogin = {
            login: null,
            password: null
        };

        // Objeto para trocar senha
        vm.objTrocaSenha = {
            password: null,
            passwordConfirm: null
        };

        // Método para carregar os parâmetros
        vm.loadParametros = loadParametros;
        // Método de realizar o login
        vm.signIn = signIn;
        // Método de atualizar a senha
        vm.atualizaSenha = atualizaSenha;
        vm.temlogocliente = false

        /***************************************************
         *** Initialize
         ***************************************************/
        init();

        /**
         * Inicialização
         *
         */
        function init() {
            vm.loginObj = Auth;
            vm.loadParametros();
        }

        /***************************************************
         *** Public Methods
         ***************************************************/

        /**
         * Carregam os parâmetros
         *
         */
        function loadParametros() {

            $.get("../versao.json", function (data) {
                angular.element("#lblVersao").text(data.versao)
            }).fail(function () {
                angular.element("#lblVersao").text("erro ao recuperar a versão")
            });

            sessionStorage.removeItem("codUsuarioLogado");

            var nomeTabela = 'parametros';

            firebase.database().ref().child(nomeTabela).once('value', function (snap) {

                    if (snap && snap.val()) {
                        vm.temlogocliente = true


                        vm.objParametros = snap.val();
                        if (!vm.objParametros.logomarca) {
                            vm.objParametros.logomarca = '../../assets/images/logo-login.png';

                            vm.temlogocliente = false;
                        }
                    } else {
                        vm.temlogocliente = false;
                        vm.objParametros = {
                            logomarca: '../../assets/images/logo-login.png'
                        };
                    }
                    if (!$scope.$$phase)
                        $scope.$apply();
                },
                function (e) {
                    debugger;
                    console.log(e);
                });
        }

        /**
         * Realiza o login do usuário no firebase
         *
         * @param {*} event Login
         */
        function signIn(event) {
            event.preventDefault(); // To prevent form refresh

            // Se for um email válido realiza o login

            if (!vm.objLogin.login || !vm.objLogin.password) {
                alert('Você deve preencher corretamente todos os itens obrigatórios.')
            }

            if (objUtilsService.validateEmail(vm.objLogin.login.toLowerCase())) {
                login(vm.objLogin.login.toLowerCase(), vm.objLogin.password);

            } else {
                // Senão pega-se o email pelo login do usuário
                signInWithLogin();
            }
        }

        /**
         * Atualiza a senha do usuário
         */
        function atualizaSenha() {
            if (!vm.objTrocaSenha.password || !vm.objTrocaSenha.passwordConfirm) {
                alert('Os campos de Nova Senha e Confirmar Senha são obrigatórios.');
                return;
            }

            if (vm.objTrocaSenha.password !== vm.objTrocaSenha.passwordConfirm) {
                alert('Os campos nova senha e confirmar senha devem possuir o mesmo valor.');
                return;
            }

            if (vm.objTrocaSenha.password.length < 6) {
                alert('A senha deve conter no mínimo 6 caracteres.');
                return;
            }

            vm.objUserAuth.password = vm.objTrocaSenha.password;
            vm.objUserAuth.ultimoAcesso = new Date().toISOString();
            beforeUpdateUser(vm.objUserAuth, true);
        }

        /***************************************************
         *** Private Methods
         ***************************************************/

        /**
         * Chamado do serviço para fazer o login
         *
         * @param {string} email Email
         * @param {string} password Password
         */
        function login(email, password) {
            vm.loginObj
                .$signInWithEmailAndPassword(email, password)
                .then(logged)
                .catch(error);
        }

        /**
         * Logar com Login do usuário
         *
         */
        function signInWithLogin() {
            debugger;
            firebase
                .database()
                .ref()
                .child('usuarios-login')
                .orderByChild('login')
                .equalTo(vm.objLogin.login.toLowerCase())
                .once('value', function (objUserLogin) {


                    if (objUserLogin && objUserLogin.val()) {
                        for (var key in objUserLogin.val()) {
                            var value = objUserLogin.val()[key];
                            if (value && value.email) {
                                login(value.email, vm.objLogin.password);
                                break;
                            }
                        }
                    } else {
                        alert('Usuário e/ou senha inválido.');
                        throw new Error(
                            'Usuário e/ou senha inválido.'
                        );
                    }
                });
        }

        /**
         * Retorno da chamada do login
         *
         * @param {object} objFirebaseUser Usuário firebase
         */
        function logged(objFirebaseUser) {
            vm.objUserAuth = objFirebaseUser;

            firebase
                .database()
                .ref()
                .child('usuarios')
                .child(vm.objUserAuth.uid)
                .once('value')
                .then(function (objUser) {
                    if (!objUser.val().ultimoAcesso) {
                        angular.element('#modalTrocaSenha').modal('show');
                    } else {
                        if (!objUser.val().desabilitado) {
                            setSessionStorage(vm.objUserAuth.uid);

                            vm.objUserAuth.ultimoAcesso = new Date().toISOString();
                            beforeUpdateUser(vm.objUserAuth, false);
                        } else {
                            alert("Usuário desabilitado. Favor entrar em contato com o administrador do sistema")
                        }
                    }
                })
                .catch(function (objError) {
                    console.log(objError);
                });
        }

        /**
         * Atualiza a data de último acesso do usuário
         *
         * @param {object} objFirebaseUser Objeto usuário do firebase
         * @param {boolean} blnAtualizarSenha Atualizar a senha
         */
        function beforeUpdateUser(objFirebaseUser, blnAtualizarSenha) {
            var objUser = {
                uid: objFirebaseUser.uid
            };

            if (blnAtualizarSenha && objFirebaseUser.password) {
                objUser.password = objFirebaseUser.password;
            }

            if (objFirebaseUser.ultimoAcesso) {
                objUser.ultimoAcesso = objFirebaseUser.ultimoAcesso;
            }

            if (blnAtualizarSenha) {
                updatePassword(objFirebaseUser, objUser);
            } else {
                updateUser(objUser);
            }
        }

        /**
         * Atualiza um usuário
         *
         * @param {object} objUser Objeto de usuário
         */
        function updateUser(objUser) {
            var uid = objUser.uid;
            delete objUser.uid;

            firebase
                .database()
                .ref()
                .child('usuarios')
                .child(uid)
                .update(objUser)
                .then(redirectToMain)
                .catch(function (objError) {
                    console.log(objError);
                });
        }

        /**
         * Atualiza a senha do usuário no firebase
         *
         * @param {object} objFirebaseUser Usuário firebase
         * @param {object} objUser Objeto de usuário
         */
        function updatePassword(objFirebaseUser, objUser) {
            objFirebaseUser
                .updatePassword(objFirebaseUser.password)
                .then(function () {
                    // Realiza o login novamente com a nova credencial
                    var objCredentials = firebase.auth.EmailAuthProvider.credential(
                        objFirebaseUser.email,
                        objFirebaseUser.password
                    );

                    objFirebaseUser.reauthenticateWithCredential(objCredentials).then(function () {
                        setSessionStorage(objUser.uid);
                        updateUser(objUser);
                    });
                })
                .catch(function (error) {
                    alert(
                        'Um erro aconteceu durante a solicitação de alteração de senha, tente novamente. Se o erro persistir contate o suporte técnico.'
                    );
                });
        }

        /**
         * Seta a seção no storage
         *
         * @param {string} uid UID do usuário
         */
        function setSessionStorage(uid) {
            console.log('Signed in as:' + uid);
            sessionStorage.setItem('codUsuarioLogado', uid);
        }

        /**
         * Redireciona para a página principal
         *
         */
        function redirectToMain() {
            angular.element('#modalTrocaSenha').modal('hide');
            angular.element('.modal-backdrop').remove();
            document.location.href = '#/index/main';
        }

        /**
         * Exceção do firebase
         *
         * @param {object} objError Objecto da exceção
         */
        function error(objError) {
            console.log(objError);
            if (objError.code == 'auth/user-disabled') {
                alert('Usuário desabilitado pelo administrador.');
            } else if (objError.code == 'auth/wrong-password') {
                alert('Usuário e/ou senha inválido.');
            } else {
                alert('Usuário e/ou senha inválido.');
            }
            console.error('Authentication failed:', objError);
        }
    }
})();

'use strict';

angular.module('trh')
    .controller('DetalhesAudioController', ['$scope', '$http', 'Auth', '$location', '$firebaseObject', 'AtualizaNotificacao', function ($scope, $http, Auth, $location, $firebaseObject, AtualizaNotificacao) {
        var switchery;
        var queryString = $location.search();
        $scope.codigo = queryString.cod;

        var userId = sessionStorage.getItem("codUsuarioLogado");

        if (!userId) {
            document.location.href = "#/login";
            return;
        }

        $scope.auth = Auth;
        // any time auth state changes, add the user data to scope
        $scope.auth.$onAuthStateChanged(function (firebaseUser) {
            if (!firebaseUser || userId == undefined) {
                document.location.href = "#/login";
            }
        });
        AtualizaNotificacao.notificacao();
        var rootRef = firebase.database().ref();
        var usuariosConteudos = rootRef.child('usuarios-conteudos');
        var conteudos = rootRef.child('conteudos');
        var temas = rootRef.child('temas');

        $firebaseObject(conteudos.child(queryString.cod)).$loaded().then(function (snap) {
            $scope.titulo = snap.name;
            $scope.descricao = snap.description;
            $scope.audio = snap.audio;
            $scope.temaId = snap.temas;
            $firebaseObject(temas.child(snap.temas)).$loaded().then(function (snapshot) {
                $scope.tema = snapshot.$value;
            })
            $firebaseObject(usuariosConteudos.child(userId).child(snap.$id)).$loaded().then(function (snp) {
                $scope.status = snp.status;
                updateUsuarioConteudo(snp.status, false);
            })
            audioInit();
        });

        var player = document.getElementById('audioPlaceholder');;
        var time_update_interval;

        function audioInit(audio) {
            var audio = document.getElementById('audioPlaceholder');
            audio.onplay = function () {
                onPlayerStateChange(true);
            };
            audio.onended = function () {
                updateUsuarioConteudo("concluído", true);
            };
        }

        function onPlayerStateChange(atualizar) {
            var post = {};
            post["status"] = "Em andamento";
            console.log($scope.status);
            if (atualizar && $scope.status != "concluído")
                usuariosConteudos.child(userId).child(queryString.cod).update(post)
        }

        function updateUsuarioConteudo(estado, atualizar) {
            if (estado == 'concluído') {
                $scope.estado = true;
                document.querySelectorAll('.js-switch')[0].click()
                switchery.disable();
                var post = {};
                post["status"] = "concluído";
                if (atualizar && $scope.status != "concluído") {
                    $scope.status = "concluído"
                    usuariosConteudos.child(userId).child(queryString.cod).update(post);
                    // $firebaseObject(usuariosTemas.child(userId).child($scope.temaId)).$loaded().then(function (snp) {
                    //   var totalConcluidos = {};
                    //   totalConcluidos["concluidos"] = parseInt(snp.concluidos) + 1;
                    //   console.log(snp.concluidos);
                    //   usuariosTemas.child(userId).child($scope.temaId).update(totalConcluidos);
                    // });
                }
            } else {
                $scope.estado = false;
                switchery.enable();
            }
        }

        angular.element(document).ready(function () {
            console.log('ready');
            var elems = Array.prototype.slice.call(document.querySelectorAll('.js-switch'));
            elems.forEach(function (html) {
                switchery = new Switchery(html, {
                    size: 'small'
                });
            });
            angular.element('.switchery').click(function () {
                var checked = angular.element('.js-switch').prop('checked');
                var disabled = angular.element('.js-switch').prop('disabled');
                if (checked && !disabled) {
                    switchery.disable();
                    updateUsuarioConteudo("concluído", true);
                }
            })
        });

    }]);

'use strict';

angular.module('trh')
  .controller('DetalhesController', ['$scope', '$http', 'Auth', '$location', '$firebaseObject', 'AtualizaNotificacao', function ($scope, $http, Auth, $location, $firebaseObject, AtualizaNotificacao) {
    var switchery;
      var queryString = $location.search();
      $scope.codigo = queryString.cod;

    var userId = sessionStorage.getItem("codUsuarioLogado");

    if (!userId) {
      document.location.href = "#/login";
      return;
    }

    $scope.auth = Auth;
    // any time auth state changes, add the user data to scope
    $scope.auth.$onAuthStateChanged(function (firebaseUser) {
      if (!firebaseUser || userId == undefined) {
        document.location.href = "#/login";
      }
    });
    AtualizaNotificacao.notificacao();
    var rootRef = firebase.database().ref();
    var usuariosConteudos = rootRef.child('usuarios-conteudos');
    var conteudos = rootRef.child('conteudos');
    var temas = rootRef.child('temas');

    $firebaseObject(conteudos.child(queryString.cod)).$loaded().then(function (snap) {
      $scope.titulo = snap.name;
      $scope.descricao = snap.description;
      $scope.temaId = snap.temas;
      $firebaseObject(temas.child(snap.temas)).$loaded().then(function (snapshot) {
        $scope.tema = snapshot.$value;
      })
      $firebaseObject(usuariosConteudos.child(userId).child(snap.$id)).$loaded().then(function (snp) {
        $scope.status = snp.status;
        updateUsuarioConteudo(snp.status, false);
      })
      onYouTubeIframeAPIReady(snap.video);
    });

    var player;
    var time_update_interval;

    function onYouTubeIframeAPIReady(video) {
      player = new YT.Player('videoPlaceholder', {
        width: '100%',
        height: 335,
        videoId: video.replace('https://www.youtube.com/watch?v=', '').replace('https://www.youtube.com/embed/', ''),
        playerVars: {
          rel: 0,
          showinfo: 0
        },
        events: {
          'onReady': initialize,
          'onStateChange': function () {
            onPlayerStateChange(true)
          }
        }
      });
    }

    function onPlayerStateChange(atualizar) {
      // var iframe = document.getElementById('videoPlaceholder');
      // var innerDoc = iframe.contentDocument || iframe.contentWindow.document;
      // innerDoc.getElementsByClassName('ytp-chrome-top')[0].style.display = 'none';
      // innerDoc.getElementsByClassName('ytp-pause-overlay')[0].style.display = 'none';
      // innerDoc.getElementsByClassName('ytp-youtube-button')[0].style.display = 'none';
      var post = {};
      post["status"] = "Em andamento";
      var estadoVideo = player.getPlayerState();
      console.log($scope.status);
      if (atualizar && estadoVideo == 1 && $scope.status != "concluído")
        usuariosConteudos.child(userId).child(queryString.cod).update(post)
    }

    function updateUsuarioConteudo(estado, atualizar) {
      if (estado == 'concluído') {
        $scope.estado = true;
        document.querySelectorAll('.js-switch')[0].click()
        switchery.disable();
        var post = {};
        post["status"] = "concluído";
        if (atualizar && $scope.status != "concluído") {
          $scope.status = "concluído";
          console.log("passou");
          usuariosConteudos.child(userId).child(queryString.cod).update(post);
          // $firebaseObject(usuariosTemas.child(userId).child($scope.temaId)).$loaded().then(function (snp) {
          //   var totalConcluidos = {};
          //   totalConcluidos["concluidos"] = parseInt(snp.concluidos) + 1;
          //   console.log(snp.concluidos);
          //   usuariosTemas.child(userId).child($scope.temaId).update(totalConcluidos);
          // });
        }
      } else {
        $scope.estado = false;
        switchery.enable();
      }
    }

    function initialize() {
      onPlayerStateChange(false);
      clearInterval(time_update_interval);

      time_update_interval = setInterval(function () {
        if (Math.round(player.getCurrentTime()) == Math.round(player.getDuration())) {
          //player.stopVideo();
          updateUsuarioConteudo("concluído", true);
        }
      }, 1000)

    }

    angular.element(document).ready(function () {
      console.log('ready');
      var elems = Array.prototype.slice.call(document.querySelectorAll('.js-switch'));
      elems.forEach(function (html) {
        switchery = new Switchery(html, {
          size: 'small'
        });
      });
      angular.element('.switchery').click(function () {
        var checked = angular.element('.js-switch').prop('checked');
        if (checked) {
          switchery.disable();
          updateUsuarioConteudo("concluído", true);
        }
      })
    });

  }]);

'use strict';

angular.module('trh')
    .controller('DetalhesArquivoController', ['$scope', '$http', 'Auth', '$location', '$firebaseObject', 'AtualizaNotificacao', function ($scope, $http, Auth, $location, $firebaseObject, AtualizaNotificacao) {
        var queryString = $location.search();
        $scope.codigo = queryString.cod;

        var userId = sessionStorage.getItem("codUsuarioLogado");

        if (!userId) {
            document.location.href = "#/login";
            return;
        }

        $scope.auth = Auth;
        // any time auth state changes, add the user data to scope
        $scope.auth.$onAuthStateChanged(function (firebaseUser) {
            if (!firebaseUser || userId == undefined) {
                document.location.href = "#/login";
            }
        });
        AtualizaNotificacao.notificacao();
        var rootRef = firebase.database().ref();
        var usuariosConteudos = rootRef.child('usuarios-conteudos');
        var conteudos = rootRef.child('conteudos');
        var temas = rootRef.child('temas');

        $scope.pdfName = 'test';
        $scope.scroll = 0;
        $scope.loading = 'loading';
        angular.element('.loading').show();
        $scope.getNavStyle = function(scroll) {
            if(scroll > 100) return 'pdf-controls fixed';
            else return 'pdf-controls';
        }

        $scope.onError = function(error) {
            console.log(error);
        }

        $scope.onLoad = function () {
            angular.element('.loading').hide();
            $scope.loading = '';
        }

        $scope.onProgress = function (progressData) {
            console.log(progressData);
        };


        $firebaseObject(conteudos.child(queryString.cod)).$loaded().then(function (snap) {
            $scope.titulo = snap.name;
            $scope.descricao = snap.description;
            $scope.arquivo = encodeURIComponent(snap.arquivo);
            $scope.pdfUrl = snap.arquivo;
            $scope.temaId = snap.temas;
            $firebaseObject(usuariosConteudos.child(userId).child(snap.$id)).$loaded().then(function (snp) {
                $scope.status = 'concluído';
                if (snp.status != 'concluído')
                    updateUsuarioConteudo('concluído');
            })
        });


        function updateUsuarioConteudo(estado) {
            var post = {};
            post["status"] = "concluído";
            usuariosConteudos.child(userId).child(queryString.cod).update(post);
        }

    }]);

'use strict';

angular.module('trh')
    .controller('ConteudosController', ['$scope', '$http', 'Auth', '$location', '$firebaseObject', 'AtualizaNotificacao', function ($scope, $http, Auth, $location, $firebaseObject, AtualizaNotificacao) {

        var queryString = $location.search();

        var userId = sessionStorage.getItem("codUsuarioLogado");

        if (!userId) {
            document.location.href = "#/login";
            return;
        }

        $scope.auth = Auth;
        // any time auth state changes, add the user data to scope
        $scope.auth.$onAuthStateChanged(function (firebaseUser) {
            if (!firebaseUser && userId != undefined) {
                document.location.href = "#/login";
            }
        });
        AtualizaNotificacao.notificacao();
        var rootRef = firebase.database().ref();
        var temas = rootRef.child('temas');
        var usuariosConteudos = rootRef.child('usuarios-conteudos');
        var conteudos = rootRef.child('conteudos');

        $firebaseObject(temas.child(queryString.cod)).$loaded().then(function (snap) {
            $scope.titulo = snap.$value;
        })

        var retorno = [];

        usuariosConteudos.child(userId).on("child_added", function (snap) {
            console.log("snp", snap.val())
            var status = $firebaseObject(conteudos.child(snap.key));
            status.$loaded().then(function (snapshot) {
                console.log(snapshot)
                if (snap.key === snapshot.$id && snapshot.temas.toString() === queryString.cod.toString()) {

                    console.log(snap)

                    retorno.push({
                        cod: snapshot.$id,
                        nome: snapshot.name.substring(0, 73) + (snapshot.name.length > 70 ? '...' : ''),
                        descricao: snapshot.description.length > 50 ? snapshot.description.substring(0, 47) + '...' : snapshot.description,
                        imagem: snapshot.imagem,
                        video: snapshot.video,
                        arquivo: snapshot.arquivo,
                        tipo: snapshot.tipo,
                        status: snap.val().status,
                        isConcluido: snap.val().status == "concluído" ? true : false,
                        timestamp: snapshot.timestamp ? snapshot.timestamp : null
                    });
                    console.log(retorno);
                    debugger;
                    $scope.conteudos = retorno.sort(function (a, b) {
                        return a.timestamp - b.timestamp;
                    }).reverse();

                }
            })

        })

        function updateUsuarioConteudo(id) {
            var post = {};
            post["status"] = "concluído";
            usuariosConteudos.child(userId).child(id).update(post);
            // $firebaseObject(usuariosTemas.child(userId).child(queryString.cod)).$loaded().then(function (snp) {
            //   var totalConcluidos = {};
            //   totalConcluidos["concluidos"] = parseInt(snp.concluidos) + 1;
            //   console.log(snp.concluidos);
            //   usuariosTemas.child(userId).child(queryString.cod).update(totalConcluidos);
            // });
        }

        angular.element(document).ready(function () {
            var elems = Array.prototype.slice.call(document.querySelectorAll('.js-switch'));
            elems.forEach(function (html) {
                var switchery = new Switchery(html);
            });
        });

        $scope.IrParaConteudo = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var cod = jQuery(e.currentTarget).attr("data-codigo");
            var tipo = jQuery(e.currentTarget).attr("data-tipo");

            var html = '<i class="fa fa-check"></i><small>concluído</small>'

            if (tipo == "arquivo") {
                document.location.href = "#/index/detalhesArquivo?cod=" + cod;
                // $firebaseObject(conteudos.child(cod)).$loaded().then(function (snap) {
                //   window.open(snap.arquivo);
                //   $firebaseObject(usuariosConteudos.child(userId).child(snap.$id)).$loaded().then(function (snp) {
                //     if (snp.status != "concluído") {
                //       updateUsuarioConteudo(snap.$id);
                //       //atualiza botão
                //       jQuery(e.currentTarget).closest(".info-group").find(".text-navy").html(html);
                //     }
                //   })
                // })

            } else {
                if (tipo == "audio") {
                    document.location.href = "#/index/detalhesAudio?cod=" + cod;
                } else {
                    document.location.href = "#/index/detalhes?cod=" + cod;
                }
            }
        }

    }]);

'use strict';

angular.module('trh')
    .controller('ConfigAppController', ['$scope', '$http', 'Auth', '$location', '$firebaseObject', 'AtualizaNotificacao', function ($scope, $http, Auth, $location, $firebaseObject, AtualizaNotificacao) {
        var queryString = $location.search();

        var userId = sessionStorage.getItem("codUsuarioLogado");

        if (!userId) {
            document.location.href = "#/login";
            return;
        }

        $scope.auth = Auth;
        // any time auth state changes, add the user data to scope
        $scope.auth.$onAuthStateChanged(function (firebaseUser) {
            if (!firebaseUser || userId == undefined) {
                document.location.href = "#/login";
            }
        });
        AtualizaNotificacao.notificacao();

        $scope.valorQrCode = firebaseConfig.clientName;

    }]);

(function () {
    'use strict';

    angular.module('trh')
        .controller('CardControllerFeedback', CardControllerFeedback);

    CardControllerFeedback.$inject = ['$scope', '$firebaseObject', '$state', '$location'];

    function CardControllerFeedback($scope, $firebaseObject, $state, $location) {
        var vm = this;
        vm.file = [];
        vm.conteudo = {};
        vm.initial = initial;
        var userId = $location.search().id;
        var conteudoId = $location.search().id;

        var rootRef = firebase.database().ref();
        var usuariosConteudos = rootRef.child('usuarios-conteudos');
        var usuarios = rootRef.child('usuarios');

        init();
        function init() {
            rootRef.child('conteudos').child(conteudoId).on("value", function (snap) {
                vm.conteudo = snap.val();
                console.log(vm.conteudo);
                vm.initial();
            });
        }



        function initial() {


            return new Promise(function (resolve, reject) {

                var result = [];
                debugger;

                usuarios.on("child_added", function (snapshot) {
                    usuariosConteudos.child(snapshot.key).child(conteudoId).once("value", function (snap) {
                        if (snap && snap.val()) {
                            if (snap.val().curtiuConteudo != null || snap.val().comentario) {
                                result.push({
                                    codigo: snapshot.key,
                                    nome: snapshot.val().name,
                                    foto: snapshot.val().foto,
                                    curtiu: snap.val().curtiuConteudo != null || snap.val().curtiuConteudo != undefined ? snap.val().curtiuConteudo : null,
                                    comentario: snap.val().comentario ? snap.val().comentario : null
                                });
                                //resolve(result);
                                console.log(result);
                                $scope.$apply(function () {
                                vm.file = result;
                                });
                            }
                        }

                    }); //usuariosConteudos
                }); //usuarios

            });

        }
    }
})();

(function () {
    'use strict';

    angular.module('trh')
        .controller('CardControllerListaInsight', CardControllerListaInsight);

    CardControllerListaInsight.$inject = ['$scope', '$firebaseObject', '$state', '$location'];

    function CardControllerListaInsight($scope, $firebaseObject, $state, $location) {
        var vm = this;
        vm.file2 = [];
        vm.msgVazio = "";
        vm.conteudo = {};
        vm.initial = initial;
        vm.exportPDF = exportPDF;
        var conteudoId = $location.search().id;

        var rootRef = firebase.database().ref();
        var usuariosConteudos = rootRef.child('usuarios-conteudos');
        var usuarios = rootRef.child('usuarios');

        init();

        function init() {
            rootRef.child('conteudos').child(conteudoId).on("value", function (snap) {
                vm.conteudo = snap.val();
                console.log(vm.conteudo);
                vm.initial();
            });
        }

        function initial() {
            var promises = [];
            var promise_conteudos = firebase.database().ref().child("conteudos").once('value');
            var promise_temas = firebase.database().ref().child('temas').once('value');
            var promise_usuarios = firebase.database().ref().child('usuarios').once('value');
            var promise_usuarios_conteudo = firebase.database().ref().child('usuarios-conteudos').once('value');
            var promise_areas = rootRef.child('areas').once('value');
            var promise_cargos = rootRef.child('cargos').once('value');
            var promise_empresas = rootRef.child('empresas').once('value');


            promises.push(promise_conteudos, promise_temas, promise_usuarios, promise_usuarios_conteudo, promise_areas, promise_cargos, promise_empresas) //inserindo as promises na fila

            Promise.all(promises).then(function (resp) {
                var conteudo = resp[0].val();
                var temas = resp[1].val();
                var usuarios = resp[2].val();
                var usuariosConteudos = resp[3].val();
                var resAreas = resp[4].val();
                var resCargos = resp[5].val();
                var resEmpresas = resp[6].val();
                var items = [];


                for (var item in temas) {
                    if (conteudo[conteudoId].temas == item) {
                        for (var U in usuarios) {
                            if (usuarios[U].temas && usuarios[U].temas.indexOf(item) > -1) {
                                var status = "novo";
                                for (var Key in usuariosConteudos[U]) {
                                    if (conteudoId == Key)
                                        status = usuariosConteudos[U][Key] ? (usuariosConteudos[U][Key].status == "concluído" ? "<b>" + usuariosConteudos[U][Key].status + "</b>" : usuariosConteudos[U][Key].status) : "novo";

                                }
                                items.push({
                                    codigo: U,
                                    nome: usuarios[U].name,
                                    email: usuarios[U].email,
                                    empresa: resEmpresas[usuarios[U].empresa] ? resEmpresas[usuarios[U].empresa].nome : "-",
                                    foto: usuarios[U].foto,
                                    cargo: resCargos[usuarios[U].cargo] ? resCargos[usuarios[U].cargo].nome : "-",
                                    area: resAreas[usuarios[U].area] ? resAreas[usuarios[U].area].nome : "-",
                                    status: status
                                });
                            }
                        }
                    }
                }

                $scope.$apply(function () {
                    vm.file2 = items;
                    if (vm.file2.length == 0) {
                        vm.msgVazio = "Nenhum usuário com esse conteúdo"
                    }
                });
            });


        }

        function exportPDF(e) {
            e.preventDefault();
            e.stopPropagation();
            angular.element("#wrapper").css("overflow", "visible").css("height", "100%");
            angular.element("body").css("overflow", "visible").css("height", "100%");
            window.print();
            angular.element("#wrapper").css("overflow", "auto").css("height", "100%");
            angular.element("body").css("overflow", "hidden").css("height", "100%");
        }
    }
})();

'use strict';

angular.module('trh').controller('CadastroLogomarcas', [
    '$scope',
    'AtualizaNotificacao',
    '$state',
    function ($scope, AtualizaNotificacao, $state) {
        AtualizaNotificacao.notificacao();
        var nomeTabela = 'parametros';

        firebase
            .database()
            .ref()
            .child(nomeTabela)
            .on('value', function (snap) {
                if (snap && snap.val()) {
                    $scope.objParametro = snap.val().logomarca;
                } else {
                    $scope.objParametro = './assets/images/logo-login.png';
                }
            });

        $scope.update = function () {
            $scope.tipoAtualizacao = 'update';

            var file = document.querySelector('#imagemLogomarca').files[0];
            var tipoDeArquivo = file ? file.type : null;

            if (!tipoDeArquivo) {
                alert("Você deve preencher corretamente todos os itens obrigatórios.")
                return;
            }

            var arquivoEscolhido = $scope.verificaFormato(tipoDeArquivo);

            if (arquivoEscolhido == false) {
                alert("Escolha um arquivo no formato de imagem.")
                return;
            }

            var ref = firebase.storage().ref();
            var file = document.querySelector('#imagemLogomarca').files[0];

            var conteudo = {
                logomarca: './assets/images/logo-login.png'
            };


            if (file != undefined) {
                var name = +new Date() + file.name;
                var metadata = {
                    contentType: file.type
                };
                var task = ref.child(name).put(file, metadata);
                task.on(
                    firebase.storage.TaskEvent.STATE_CHANGED,
                    function (snapshot) {
                        var progress =
                            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        console.log('Upload is ' + progress + '% done');
                        switch (snapshot.state) {
                            case firebase.storage.TaskState.PAUSED: // or 'paused'
                                console.log('Upload is paused');
                                break;
                            case firebase.storage.TaskState.RUNNING: // or 'running'
                                console.log('Upload is running');
                                break;
                        }
                    },
                    function (error) {
                        // A full list of error codes is available at
                        // https://firebase.google.com/docs/storage/web/handle-errors
                        switch (error.code) {
                            case 'storage/unauthorized':
                                // User doesn't have permission to access the object
                                alert(
                                    'O upload não foi concluído porque o seu usuário não está logado no sistema'
                                );
                                break;

                            case 'storage/canceled':
                                // User canceled the upload
                                alert('O usuário cancelou o upload');
                                break;

                            case 'storage/unknown':
                                // Unknown error occurred, inspect error.serverResponse
                                alert(
                                    'Um erro desconhecido aconteceu durante o upload, tente novamente. Se persistir contate o administrador do sistema'
                                );
                                firebase
                                    .database()
                                    .ref()
                                    .child('log')
                                    .child(key)
                                    .update({
                                        erro: error
                                    });
                                break;
                        }
                    },
                    function () {
                        task.snapshot.ref.getDownloadURL().then(function (url) {
                            conteudo['logomarca'] = url;
                            $scope.objParametro = url;
                            firebase
                                .database()
                                .ref()
                                .child(nomeTabela)
                                .update(conteudo)
                                .then(function () {
                                    alert('Ação realizada com sucesso');
                                    document.location.reload();
                                });
                        });
                    }
                );
            } else {
                alert('Favor escolher um arquivo');
            }
        };

        $scope.delete = function (item, e) {
            var confirmar = confirm('Deseja excluir o item selecionado?');
            if (confirmar) {
                var novo = firebase
                    .database()
                    .ref()
                    .child(nomeTabela)
                    .child("logomarca")
                    .remove().then(function () {
                        document.location.reload();
                    });

            }
        };



        $scope.verificaFormato = function (tipoDeArquivo) {

            if (tipoDeArquivo == "image/png" || tipoDeArquivo == "image/gif" || tipoDeArquivo == "image/jpeg" || tipoDeArquivo == "image/jpg") {
                return true;
            } else {
                return false;
            }
        }

    }
]);

'use strict';



angular.module('trh')
    .controller('InsightsConteudos', ['$scope', '$http', 'Auth', '$location', '$timeout', '$firebaseObject', '$firebaseArray', 'AtualizaNotificacao', '$window', 'FirebaseService', function ($scope, $http, Auth, $location, $timeout, $firebaseObject, $firebaseArray, AtualizaNotificacao, $window, objFirebaseService) {

        var queryString = $location.search();

        var userId = sessionStorage.getItem("codUsuarioLogado");

        if (!userId) {
            document.location.href = "#/login";
            return;
        }

        $scope.auth = Auth;
        // any time auth state changes, add the user data to scope
        $scope.auth.$onAuthStateChanged(function (firebaseUser) {
            if (!firebaseUser && userId != undefined) {
                document.location.href = "#/login";
            }
        });
        AtualizaNotificacao.notificacao();

        var rootRef = firebase.database().ref();
        $scope.filter_data = 0;
        var items = [];
        var promises = [];
        var userId = sessionStorage.getItem("codUsuarioLogado");
        var nomeTabela = "conteudos";

        var promise_conteudos = firebase.database().ref("conteudos").once('value');
        var promise_temas = firebase.database().ref().child('temas').once('value');
        var promise_usuarios = firebase.database().ref().child('usuarios').once('value');
        var promise_usuarios_conteudo = firebase.database().ref().child('usuarios-conteudos').once('value');
        promises.push(promise_conteudos, promise_temas, promise_usuarios, promise_usuarios_conteudo) //inserindo as promises na fila

        Promise.all(promises).then(function (resp) {
            var conteudo = resp[0].val();
            var temas = resp[1].val();
            var usuarios = resp[2].val();
            var usuariosConteudos = resp[3].val();


            var usersSize = Object.keys(usuarios).length;
            $scope.totalUsuarios = usersSize;

            for (var k in conteudo) {
                var numEmAndamento = 0;
                var numConcluido = 0;
                var totalUsuariosComConteudo = 0;
                for (var item in temas) {
                    if (conteudo[k].temas == item) {
                        for (var U in usuarios) {
                            if (usuarios[U].temas && usuarios[U].temas.indexOf(item) > -1) {
                                totalUsuariosComConteudo++;
                                for (var cont in usuariosConteudos[U]) {

                                    if (cont == k) {

                                        var status = usuariosConteudos[U][cont].status;
                                        if (status == "concluído") {
                                            numConcluido++;
                                        }
                                        if (status == "Em andamento") {
                                            numEmAndamento++;
                                        }
                                    }
                                }
                            }
                        }

                        items.push({
                            codigo: k,
                            name: conteudo[k].name,
                            imagem: conteudo[k].imagem,
                            tipo: conteudo[k].tipo,
                            description: conteudo[k].description,
                            tema: temas[item],
                            temaKey: item,
                            video: conteudo[k].video,
                            audio: conteudo[k].audio,
                            arquivo: conteudo[k].arquivo,
                            numConcluido: numConcluido,
                            numEmAndamento: numEmAndamento,
                            totalUsuariosComConteudo: totalUsuariosComConteudo
                        });

                    }
                }



            }
            console.log(items);
            items = items.reverse();
            $scope.file = items;
            $scope.filter_data = items.length;
            $scope.entire_user = items.length;
            $scope.cbTemas = resp[1].val();
        });



        $scope.current_grid = 1;
        $scope.data_limit = 100;

        var tipoAtualizacao = false;

        var conteudo = {};

        $scope.page_position = function (page_number) {
            $scope.current_grid = page_number;
        };
        $scope.filter = function () {
            $timeout(function () {
                $scope.filter_data = $scope.searched.length;
            }, 20);
        };
        $scope.sort_with = function (base) {
            $scope.base = base;
            $scope.reverse = !$scope.reverse;
        };

        $scope.logOut = function () {
            var auth2 = gapi.auth2.getAuthInstance();
            auth2.signOut().then(function () {
                console.log('User signed out.');
            });
        }

        /**
         * Relatório
         *
         * @param {object} data Objeto de usuário
         */
        $scope.relatorio = function(data) {
            angular.element('#modalRelatorio').find('iframe').attr('src', '//about:blank');
            $timeout(function () {
                angular.element('#modalRelatorio').find('iframe').attr('src', '#/cardListaInsight?id=' + data.codigo);
            }, 500);
        }

        angular.element(document).ready(function () {
            angular.element(".input-busca").focus();
            setTimeout(function () {
                angular.element(".input-busca").blur();
            }, 500)


        });

    }]).filter('beginning_data', function () {
        return function (input, begin) {
            if (input) {
                begin = +begin;
                return input.slice(begin);
            }
            return [];
        }
    });

(function () {

    'use strict';

    angular.module('trh')
        .controller('ImportarUsuariosController', ImportarUsuariosController);

    ImportarUsuariosController.$inject = ['$scope', '$q', 'Auth', 'FirebaseService', 'utilsService', '$uibModalInstance', 'objData'];

    /**
     * Controller de importação de usuários
     *
     * @param {object} $scope Escopo angular do controller
     * @param {object} $q Objeto promise angular
     * @param {object} Auth Firebase autenticação
     * @param {object} objFirebaseService Firebase service
     * @param {object} objUtilsService Utils service
     * @param {object} $uibModalInstance Objeto do modal
     * @param {object} objData Objeto do controller que chamou
     */
    function ImportarUsuariosController($scope, $q, Auth, objFirebaseService, objUtilsService, $uibModalInstance, objData) {
        // View model
        var vm = this;

        /***************************************************
         *** Attributes
         ***************************************************/
        vm.auth = Auth;
        vm.file = null;
        vm.senhaPadrao = null;
        vm.log = {
            countSuccess: -1,
            errorList: []
        };
        vm.regex = null;

        vm.importar = importar;
        vm.cancelar = cancelar;
        vm.salvar = salvar;

        vm.lstAllTemas = [];
        vm.setTemas = setTemas;

        vm.objResponseList = [];

        /***************************************************
         *** Initialize
         ***************************************************/
        init();

        function init() {
            vm.regex = /^([a-zA-Z0-9\s_\\.\-:()])+(.xls|.xlsx)$/;
        }

        /***************************************************
         *** Public methods
         ***************************************************/

        $scope.loadFile = function (files) {
            if (files && files.length > 0) {
                vm.file = files[0];
                verificaArquivo(vm.file, false);
            }
        }

        /**
         * Importação dos usuários
         *
         */
        function importar() {

            if (verificaArquivo(vm.file, true)) {
                if (typeof (FileReader) !== 'undefined') {
                    try {
                        var reader = new FileReader();
                        // For Browsers other than IE.
                        if (reader.readAsBinaryString) {
                            reader.onload = function (e) {
                                ProcessaExcel(e.target.result);
                            };
                            reader.readAsBinaryString(vm.file);
                        } else {
                            // For IE Browser.
                            reader.onload = function (e) {
                                var data = '';
                                var bytes = new Uint8Array(e.target.result);
                                for (var i = 0; i < bytes.byteLength; i++) {
                                    data += String.fromCharCode(bytes[i]);
                                }
                                ProcessaExcel(data);
                            };
                            reader.readAsArrayBuffer(vm.file);
                        }
                    } catch (error) {
                        alert('Algo deu errado ao tentar importar. Motivo: ' + error);
                    }
                } else {
                    alert('Esse navegador não suporta HTML5.');
                }
            }
        }

        /**
         * Cancela a importação
         *
         */
        function cancelar() {
            $uibModalInstance.close();
        }

        /***************************************************
         *** Private methods
         ***************************************************/

        /**
         * Verifica se o arquivo é um arquivo Excel válido
         *
         * @param {object} file Objeto do arquivo
         * @param {boolean} blnVerificarSenha Verdadeiro para verificar senha
         * @returns Verdadeiro se o arquivo é válido
         */
        function verificaArquivo(file, blnVerificarSenha) {
            var msgWarning = '';

            if (!file || (blnVerificarSenha && !vm.senhaPadrao)) {
                msgWarning += 'Você deve preencher corretamente todos os campos obrigatórios. ';
            }

            if (file && !vm.regex.test(file.name.toLowerCase())) {
                msgWarning += 'Escolha um arquivo Excel válido. ';
            }

            if (blnVerificarSenha && vm.senhaPadrao && vm.senhaPadrao.length < 6) {
                msgWarning += 'A senha padrão deve conter pelo menos 6 caracteres. ';
            }

            if (msgWarning.length > 0) {
                alert(msgWarning);
                return false;
            }

            return true;
        }

        /**
         * Faz o processamento do arquivo excel
         *
         * @param {object} objFile Objeto do arquivo
         */
        function ProcessaExcel(objFile) {
            try {
                //Read the Excel File data.
                var workbook = XLSX.read(objFile, {
                    type: 'binary'
                });

                // Pega a primeira planilha do arquivo
                var firstSheet = workbook.SheetNames[0];

                // Lê as linhas da primeira planilha do arquivo para um JSON array.
                var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
            } catch (error) {
                alert('Algo deu errado ao tentar importar. Motivo: ' + error);
            }

            salvar(excelRows);
        }

        /**
         * Salva o usuário
         *
         * @param {array} objResponseList Lista de usuários, áreas, perfis e unidades
         * @param {object} objUsuario Objeto usuário no Excel
         * @param {number} linha Linha do excel
         */
        function salvaUsuarioVinculo(objResponseList, objUsuario) {


            var objAreaList = objResponseList[1];
            var objPerfilList = objResponseList[2];
            var objUnidadeList = objResponseList[3];

            var promises = [];
            promises.push(salvaVinculos('areas', objAreaList, objUsuario.Area, 1));
            promises.push(salvaVinculos('cargos', objPerfilList, objUsuario.Perfil, 2));
            promises.push(salvaVinculos('empresas', objUnidadeList, objUsuario.Unidade, 3));

            Promise.all(promises)
                .then(function () {
                    $scope.$apply();
                    return vm.objResponseList;
                });

        }

        function salvaUsuario(objResponseList, objUsuario, linha, objUsuarioExiste) {


            if (objUsuarioExiste) {

                var objAreaList = objResponseList[1];
                var objPerfilList = objResponseList[2];
                var objUnidadeList = objResponseList[3];

                var objArea = objAreaList;
                var idArea = ((objArea) ? objArea.find(function (area) {
                    return area.nome === objUsuario.Area
                }) : null);
                //var idArea = ((objArea && objArea.key) ? objArea.key : ((objArea && objArea.$id) ? objArea.$id : null));

                var objPerfil = objPerfilList;
                var idPerfil = ((objPerfil) ? objPerfil.find(function (perfil) {
                    return perfil.nome === objUsuario.Perfil
                }) : null);
                //var idPerfil = ((objPerfil && objPerfil.key) ? objPerfil.key : ((objPerfil && objPerfil.$id) ? objPerfil.$id : null));

                var objUnidade = objUnidadeList;
                var idUnidade = ((objUnidade) ? objUnidade.find(function (unidade) {
                    return unidade.nome === objUsuario.Unidade
                }) : null);
                //var idUnidade = ((objUnidade && objUnidade.key) ? objUnidade.key : ((objUnidade && objUnidade.$id) ? objUnidade.$id : null

                objUsuarioExiste.area = idArea ? idArea.$id : null;
                objUsuarioExiste.cargo = idPerfil ? idPerfil.$id : null;
                objUsuarioExiste.empresa = idUnidade ? idUnidade.$id : null;

                vm.lstAllTemas = [];
                if (objArea) {
                    for (var k in objArea) {
                        for (var j in objArea[k].temas) {
                            vm.lstAllTemas.splice(1, 0, objArea[k].temas[j]);
                        }

                    }
                }
                if (objPerfil) {
                    for (var k in objPerfil) {
                        for (var j in objPerfil[k].temas) {
                            vm.lstAllTemas.splice(1, 0, objPerfil[k].temas[j]);
                        }

                    }
                }
                var objTemas = vm.setTemas(objUsuarioExiste.temas)
                objUsuarioExiste.temas = objTemas;

                try {
                    objFirebaseService.update('usuarios', objUsuarioExiste)
                        .then(
                            function () {
                                vm.log.countSuccess++;
                                //salvarUsuarioLogin(objUsuario.login, objUsuario.email, linha);
                            },
                            function (error) {
                                vm.log.errorList[linha] = 'Linha ' + linha + ': ' + error;
                                console.error(error);
                            }
                        );
                } catch (error) {
                    vm.log.errorList[linha] = 'Linha ' + linha + ': ' + 'Algo ocorreu ao tentar salvar o usuário.' + error;
                }

            } else {
                try {
                    // Cria usuário para acessar o sistema
                    vm.auth.$createUserWithEmailAndPassword(objUsuario.Email.trim(), vm.senhaPadrao)
                        .then(function (firebaseUser) {

                                var objAreaList = objResponseList[1];
                                var objPerfilList = objResponseList[2];
                                var objUnidadeList = objResponseList[3];

                                var objArea = objAreaList;
                                var idArea = ((objArea) ? objArea.find(function (area) {
                                    return area.nome === objUsuario.Area
                                }) : null);
                                //var idArea = ((objArea && objArea.key) ? objArea.key : ((objArea && objArea.$id) ? objArea.$id : null));

                                var objPerfil = objPerfilList;
                                var idPerfil = ((objPerfil) ? objPerfil.find(function (perfil) {
                                    return perfil.nome === objUsuario.Perfil
                                }) : null);
                                //var idPerfil = ((objPerfil && objPerfil.key) ? objPerfil.key : ((objPerfil && objPerfil.$id) ? objPerfil.$id : null));

                                var objUnidade = objUnidadeList;
                                var idUnidade = ((objUnidade) ? objUnidade.find(function (unidade) {
                                    return unidade.nome === objUsuario.Unidade
                                }) : null);
                                //var idUnidade = ((objUnidade && objUnidade.key) ? objUnidade.key : ((objUnidade && objUnidade.$id) ? objUnidade.$id : null));

                                var objToSave = {
                                    admin: false,
                                    area: idArea ? idArea.$id : null,
                                    cargo: idPerfil ? idPerfil.$id : null,
                                    email: objUsuario.Email,
                                    empresa: idUnidade ? idUnidade.$id : null,
                                    foto: getFotoEmpty(),
                                    login: objUsuario.Login,
                                    name: objUsuario.Nome,
                                    password: vm.senhaPadrao,
                                    temas: []
                                };

                                vm.lstAllTemas = [];
                                if (objArea) {
                                    for (var k in objArea) {
                                        for (var j in objArea[k].temas) {
                                            vm.lstAllTemas.splice(1, 0, objArea[k].temas[j]);
                                        }

                                    }
                                }
                                if (objPerfil) {
                                    for (var k in objPerfil) {
                                        for (var j in objPerfil[k].temas) {
                                            vm.lstAllTemas.splice(1, 0, objPerfil[k].temas[j]);
                                        }

                                    }
                                }


                                objToSave.temas = vm.lstAllTemas;

                                try {
                                    objFirebaseService.addWithUid('usuarios', objToSave, firebaseUser.uid)
                                        .then(
                                            function () {
                                                vm.log.countSuccess++;
                                                salvarUsuarioLogin(objToSave.login, objToSave.email, linha);
                                            },
                                            function (error) {
                                                vm.log.errorList[linha] = 'Linha ' + linha + ': ' + error;
                                                console.error(error);
                                            }
                                        );
                                } catch (error) {
                                    vm.log.errorList[linha] = 'Linha ' + linha + ': ' + 'Algo ocorreu ao tentar salvar o usuário.' + error;
                                }
                            },
                            function (error) {
                                vm.log.errorList[linha] = 'Linha ' + linha + ': ' + 'Algo ocorreu ao tentar salvar o usuário.' + error;
                            });
                } catch (error) {
                    vm.log.errorList[linha] = 'Linha ' + linha + ': ' + 'Algo ocorreu ao tentar salvar o usuário. Revise o email informado. O email informado não é válido ou já está cadastrado. ';
                }
            }
        }

        function setTemas(value) {
            var temas;
            if (value) {
                if (vm.lstAllTemas) {
                    temas = vm.lstAllTemas.concat(value);
                } else {
                    temas = value;
                }
            } else {
                if (vm.lstAllTemas) {
                    temas = vm.lstAllTemas;
                } else {
                    temas = null;
                }
            }
            return temas;
        }

        /**
         * Salva os dados na collection usuarios-login
         *
         * @param {string} login Login
         * @param {string} email Email
         */
        function salvarUsuarioLogin(login, email, linha) {
            try {
                var objToSave = {
                    email: email,
                    login: login
                };

                objFirebaseService.add('usuarios-login', objToSave);
            } catch (error) {
                vm.log.errorList[linha] = 'Linha ' + linha + ': ' + 'Algo ocorreu ao tentar salvar o usuário.' + error;
            }
        }

        /**
         * Salva os usuários
         *
         * @param {array} objUsuariosExcel Usuários no arquivo excel
         */
        function salvar(objUsuariosExcel) {
            vm.log = {
                countSuccess: 0,
                errorList: []
            };

            var promises = [];
            promises.push(objFirebaseService.getAll('usuarios'));
            promises.push(objFirebaseService.getAll('areas'));
            promises.push(objFirebaseService.getAll('cargos'));
            promises.push(objFirebaseService.getAll('empresas'));
            angular.element('.loading').show();

            Promise.all(promises)
                .then(function (objResponseList) {
                    vm.objResponseList = objResponseList;
                    var promiseVinculo = [];
                    promiseVinculo.push(executarVinculos(vm.objResponseList, objUsuariosExcel));

                    Promise.all(promiseVinculo).then(function (objResposta) {
                        executarSalvarUsuario(vm.objResponseList, objUsuariosExcel)
                        angular.element('.loading').hide();
                    });

                });
        }

        function executarVinculos(objResponseList, objUsuariosExcel) {
            var objUsuarioList = objResponseList[0];

            for (var i = 0; i < objUsuariosExcel.length; i++) {
                var objUsuario = objUsuariosExcel[i];
                var linha = angular.copy(i + 2);
                var errorMsg = verificaUsuario(objUsuarioList, objUsuario, linha);
                if (errorMsg.length === 0) {
                    var usuarioExiste = objUsuarioList.find(function (o) {
                        return o.email === objUsuario.Email.trim().toLowerCase() || o.login === objUsuario.Login.trim();
                    });
                    if (usuarioExiste) {
                        salvaUsuarioVinculo(vm.objResponseList, objUsuario);
                    } else {
                        salvaUsuarioVinculo(vm.objResponseList, objUsuario);
                    }

                }
            }
            $scope.$apply();
        }

        function executarSalvarUsuario(objResponseList, objUsuariosExcel) {

            var promises = [];
            promises.push(objFirebaseService.getAll('usuarios'));
            promises.push(objFirebaseService.getAll('areas'));
            promises.push(objFirebaseService.getAll('cargos'));
            promises.push(objFirebaseService.getAll('empresas'));
            Promise.all(promises)
                .then(function (objResponseList) {
                    vm.objResponseList = objResponseList;

                    var objUsuarioList = objResponseList[0];

                    for (var i = 0; i < objUsuariosExcel.length; i++) {
                        var objUsuario = objUsuariosExcel[i];
                        var linha = angular.copy(i + 2);
                        var errorMsg = verificaUsuario(objUsuarioList, objUsuario, linha);
                        if (errorMsg.length === 0) {
                            var usuarioExiste = objUsuarioList.find(function (o) {
                                return o.email === objUsuario.Email.trim().toLowerCase() || o.login === objUsuario.Login.trim();
                            });
                            if (usuarioExiste) {
                                salvaUsuario(objResponseList, objUsuario, linha, usuarioExiste);
                            } else {
                                salvaUsuario(objResponseList, objUsuario, linha, null);
                            }

                        } else {
                            vm.log.errorList[linha] = errorMsg;
                        }
                    }
                });

        }

        /**
         * Salva vínculos do usuários (Área, Perfil e Unidade)
         *
         * @param {string} strCollection Nome da collection (areas, cargos, empresas)
         * @param {array} objList Lista com os vínculos
         * @param {string} strNome Nome vinculado ao usuário
         * @returns Id. do vínculo
         */
        function salvaVinculos(strCollection, objList, strNome, index) {
            if (strNome) {

                var objExiste = false;
                if (vm.objResponseList[index] && vm.objResponseList[index].length > 0) {
                    objExiste = vm.objResponseList[index].filter(function (obj) {
                        if (obj.nome && (obj.nome.toLowerCase() === strNome.toLowerCase())) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                }

                if (!objExiste || (objExiste && objExiste.length === 0)) {
                    var key = objFirebaseService.generateId(strCollection);
                    var objNew = {
                        $id: key,
                        nome: strNome
                    };

                    // objList.push(objNew);

                    vm.objResponseList[index].push(objNew);

                    return objFirebaseService.add(strCollection, objNew);

                } else if (objExiste && objExiste.length > 0) {
                    return $q(function (resolve) {
                        resolve(objExiste[0]);
                    });
                } else {
                    return $q(function (resolve) {
                        resolve(null);
                    });
                }
            } else {
                return $q(function (resolve) {
                    resolve(null);
                });
            }
        }

        /**
         * Verifica inconsistências para salvar o usuário
         *
         * @param {array} objUsuarioList Lista de usuário no firebase
         * @param {object} objUsuarioExcel Objeto usuário do arquivo Excel
         * @param {number} linha Linha do arquivo
         * @returns {string} Mensagens de validação
         */
        function verificaUsuario(objUsuarioList, objUsuarioExcel, linha) {
            var errorMsg = '';

            // Verifica o campo nome
            if (!objUsuarioExcel.Nome) {
                errorMsg += 'O campo Nome é obrigatório e não foi encontrado. ';
            }

            // Verifica o campo email
            if (!objUsuarioExcel.Email) {
                errorMsg += 'O campo Email é obrigatório e não foi encontrado. ';
            } else {
                if (objUsuarioExcel.Email && !objUtilsService.validateEmail(objUsuarioExcel.Email.trim())) {
                    errorMsg += 'O campo Email não é um email válido (' + objUsuarioExcel.Email.trim() + '). ';
                }
                /*
                else {
                    var emailExiste = objUsuarioList.some(function (o) {
                        return o.email === objUsuarioExcel.Email;
                    });

                    if (emailExiste) {
                        errorMsg += 'O Email informado já existe no sistema (' + objUsuarioExcel.Email + '). ';
                    }
                }
                */

            }

            // Verifica o campo Login
            if (!objUsuarioExcel.Login) {
                errorMsg += 'O campo Login é obrigatório e não foi encontrado. ';
            } else {
                // var loginExiste = objUsuarioList.some(function (o) {
                //     return o.login === objUsuarioExcel.Login;
                // });

                // if (loginExiste) {
                //     errorMsg += 'O Login informado já existe no sistema (' + objUsuarioExcel.Login + '). ';
                // }
            }

            if (errorMsg.length > 0) {
                errorMsg = 'Linha ' + linha + ': ' + errorMsg;
            }

            return errorMsg;
        }

        /**
         * Obtém a foto para usuários sem fotos
         *
         * @returns
         */
        function getFotoEmpty() {
            return 'https://firebasestorage.googleapis.com/v0/b/abaris-treinamento-0001.appspot.com/o/profile_empty.jpg?alt=media&token=1433ea4e-a573-4cda-842b-14a9aac94618';
        }
    }

})();

'use strict';



angular.module('trh')
    .controller('EnviarNotificacoes', ['$scope', '$http', 'Auth', '$location', '$timeout', '$firebaseObject', '$firebaseArray', 'AtualizaNotificacao', function ($scope, $http, Auth, $location, $timeout, $firebaseObject, $firebaseArray, AtualizaNotificacao) {

        var queryString = $location.search();

        var userId = sessionStorage.getItem("codUsuarioLogado");

        if (!userId) {
            document.location.href = "#/login";
            return;
        }

        $scope.auth = Auth;

        //any time auth state changes, add the user data to scope
        $scope.auth.$onAuthStateChanged(function (firebaseUser) {
            if (!firebaseUser && userId != undefined) {
                document.location.href = "#/login";
            }
        });

        AtualizaNotificacao.notificacao();

        $scope.enviar = function (value, formValidate) {

            if (formValidate) {
                document.getElementById('sendButtonText').innerHTML = 'Enviando...';
                document.getElementById('sendButton').disabled = 'true';

                $.ajax({
                    type: 'POST',
                    url: "https://fcm.googleapis.com/fcm/send",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": 'key=' + 'AIzaSyBnZAZ7PtTPlPgYGaOfQ53jUuUtXy7K1Ew'
                    },
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify({
                        "notification": {
                            "title": value.title,
                            "body": value.body,
                            "sound": "default",
                            "click_action": "FCM_PLUGIN_ACTIVITY",
                            "icon": "fcm_push_icon"
                        },
                        "data": {
                            "param1": "value1",
                            "param2": "value2"
                        },
                        "to": "/topics/" + firebaseConfig.clientName,
                        "priority": "high",
                        "restricted_package_name": "com.abaris.ouview"
                    }),
                    success: function (response) {
                        console.log(response);
                        alert('Mensagem enviada com sucesso');
                        document.getElementById('sendButtonText').innerHTML = 'Enviar';
                        document.getElementById('sendButton').removeAttribute('disabled');
                    },
                    error: function (xhr, status, error) {
                        alert('Um erro ocorreu ao enviar a mensagem. Tente novamente. Dados técnicos do erro:' + xhr.error);
                        console.log(xhr.error);
                        document.getElementById('sendButtonText').innerHTML = 'Enviar';
                        document.getElementById('sendButton').removeAttribute('disabled');
                    }
                });

            } else {
                alert("Você deve preencher corretamente todos os itens obrigatórios");
            }
        }

    }]);

(function () {

    'use strict';

    angular.module('trh')
        .controller('CadastroUsuarios', CadastroUsuarios);

    CadastroUsuarios.$inject = ['$scope', 'Auth', '$timeout', '$state', 'AtualizaNotificacao', '$uibModal'];

    /**
     * Controller de cadastro de usuários
     *
     * @param {object} $scope Escopo angular do controller
     * @param {object} Auth Objeto de autenticação
     * @param {object} $timeout Objeto para timeout
     * @param {object} $state Objeto route state
     * @param {object} AtualizaNotificacao Notificações
     * @param {object} $uibModal Objeto modal do bootstrap
     */
    function CadastroUsuarios($scope, Auth, $timeout, $state, AtualizaNotificacao, $uibModal) {
        // View model
        var vm = this;

        /***************************************************
         *** Attributes
         ***************************************************/
        vm.auth = Auth;
        vm.fireBaseRefUsuarios = null;
        vm.fireBaseRef = null;
        vm.tipoAtualizacao = null;
        vm.userId = null;
        vm.fotoEmpty = null;
        vm.file = null;
        vm.app = {};

        vm.filter_data = 0;
        vm.entire_user = 0
        vm.current_grid = 1;
        vm.data_limit = 100;
        vm.searched = [];
        vm.base = null;
        vm.reverse = null;

        vm.nomeTabela = 'usuarios';

        vm.lstArea = {};
        vm.lstCargo = {};
        vm.lstEmpresa = {};
        vm.lstTemas = {};
        vm.lstLogin = {};
        vm.lstAllTemas = [];
        vm.lstUniqueTemas = [];

        // Método para carregar os dados para a tela
        vm.loadDados = loadDados;
        // Page position
        vm.page_position = page_position;
        // Filter
        vm.filter = filter;
        // Sort with
        vm.sort_with = sort_with;
        // Add um novo usuário
        vm.addUsuario = addUsuario;
        // Edit um usuário
        vm.edit = edit;
        // Antes de atualizar
        vm.beforeUpdate = beforeUpdate;
        // Atualiza/salva usuário
        vm.update = update;
        // Deleta um usuário
        vm.deleteUser = deleteUser;
        // Reset
        vm.reset = reset;
        // Relatório
        vm.relatorio = relatorio;
        // Importar usuário
        vm.openImportarUsuarios = openImportarUsuarios;
        // Toggle para checkbox list de temas
        vm.toggleSelection = toggleSelection;
        vm.listaTemasCargoPerfil = listaTemasCargoPerfil;
        // TSetar os temas para cadastro de novo usuario
        vm.setTemas = setTemas;

        vm.verificaFormato = verificaFormato;


        // Método para tratar o botão fechar
        vm.botaoFechar = botaoFechar;

        vm.beforeEdit = null;
        vm.afterEdit = null;

        vm.desabilitarUser = desabilitarUser;
        vm.habilitarUser = habilitarUser;

        /***************************************************
         *** Initialize
         ***************************************************/
        init();

        /**
         * Inicialização
         *
         */
        function init() {
            vm.userId = getUserId();
            onAuthStateChanged();
            atualizaNotificacao();
            getFotoEmpty();
            setFirebaseRef();
            vm.loadDados();
        }

        /***************************************************
         *** Public methods
         ***************************************************/



        /**
         *
         *
         * @param {*} tipoDeArquivo
         * @returns
         */
        function verificaFormato(tipoDeArquivo) {

            if (tipoDeArquivo == "image/png" || tipoDeArquivo == "image/gif" || tipoDeArquivo == "image/jpeg" || tipoDeArquivo == "image/jpg") {
                return true;
            } else {
                return false;
            }
        }

        /**
         * Carregam os usuários
         *
         */
        function loadDados() {
            vm.filter_data = 0;
            var items = [];
            var promises = [];

            var promise_usuarios = vm.fireBaseRefUsuarios.orderByChild('timestamp').once('value');
            var promise_areas = vm.fireBaseRef.child('areas').once('value');
            var promise_cargos = vm.fireBaseRef.child('cargos').once('value');
            var promise_empresas = vm.fireBaseRef.child('empresas').once('value');
            var promise_temas = vm.fireBaseRef.child('temas').once('value');

            //teste de validação de login
            var promise_usuarios_login = vm.fireBaseRef.child('usuarios-login').once('value');

            promises.push(promise_usuarios, promise_areas, promise_cargos, promise_empresas, promise_temas, promise_usuarios_login);

            Promise.all(promises).then(function (resp) {
                var lstUsuario = {};
                resp[0].forEach(function (child) {
                    lstUsuario[child.key] = child.val();
                });

                vm.lstArea = resp[1].val();
                vm.lstCargo = resp[2].val();
                vm.lstEmpresa = resp[3].val();
                vm.lstTemas = resp[4].val();
                vm.lstLogin = resp[5].val();

                // vm.lstUniqueTemas = [];
                // vm.lstAllTemas.forEach(function(item) {
                //     if(vm.lstUniqueTemas.indexOf(item) < 0) {
                //         vm.lstUniqueTemas.push(item);
                //     }
                // });

                //console.log(vm.lstAllTemas, vm.lstUniqueTemas);

                var result = {};

                var count = 0;
                for (var k in lstUsuario) {
                    if (lstUsuario[k]) {
                        count++;

                        result = {
                            codigo: k,
                            name: lstUsuario[k].name,
                            login: lstUsuario[k].login,
                            foto: lstUsuario[k].foto,
                            area: lstUsuario[k].area,
                            objArea: (lstUsuario[k].area) ? vm.lstArea[lstUsuario[k].area] : null,
                            cargo: lstUsuario[k].cargo,
                            objCargo: (lstUsuario[k].cargo) ? vm.lstCargo[lstUsuario[k].cargo] : null,
                            empresa: lstUsuario[k].empresa,
                            objEmpresa: (lstUsuario[k].empresa) ? vm.lstEmpresa[lstUsuario[k].empresa] : null,
                            admin: lstUsuario[k].admin,
                            email: lstUsuario[k].email,
                            password: lstUsuario[k].password,
                            permanente: lstUsuario[k].permanente ? true : false,
                            desabilitado: (lstUsuario[k].desabilitado ? true : false),
                            timestamp: lstUsuario[k].timestamp ? lstUsuario[k].timestamp : null
                        }

                        var usuarioTema = lstUsuario[k].temas;
                        console.log("resp[4]", resp[4].val())
                        var temaItens = resp[4].val();
                        var temas = {};
                        result['temas'] = [];

                        if (usuarioTema && usuarioTema.length > 0) {
                            for (var i = 0; i < usuarioTema.length; i++) {
                                var key = usuarioTema[i];
                                for (var chave in temaItens) {
                                    if (chave == key) {
                                        temas = chave.toString();
                                        result['temas'].push(temas);
                                    }
                                }
                            }
                        }

                        console.log("result", result)

                        items.push(result);
                        vm.filter_data = count;
                        vm.entire_user = count;
                    }
                }

                items = items.reverse();
                $scope.$apply(function () {
                    vm.file = items;
                });

            });


            vm.current_grid = 1;
            vm.data_limit = 100;

            loadReady();
        }

        /**
         *Lista os temas do cargo e área selecionados
         *
         * @param {*} value objeto do formulário
         */
        function listaTemasCargoPerfil(value) {
            vm.lstAllTemas = [];
            if (vm.lstArea[value.area]) {
                for (var k in vm.lstArea[value.area].temas) {
                    vm.lstAllTemas.splice(1, 0, vm.lstArea[value.area].temas[k]);
                }
            }
            if (vm.lstCargo[value.cargo]) {
                for (var k in vm.lstCargo[value.cargo].temas) {
                    vm.lstAllTemas.splice(1, 0, vm.lstCargo[value.cargo].temas[k]);
                }
            }

        }

        /**
         * Page position
         *
         * @param {number} page_number Posição da página
         */
        function page_position(page_number) {
            vm.current_grid = page_number;
        }

        /**
         * Filtro
         *
         */
        function filter() {
            $timeout(function () {
                vm.filter_data = vm.searched.length;
            }, 20);
        }

        /**
         * Sort with
         *
         * @param {number} base
         */
        function sort_with(base) {
            vm.base = base;
            vm.reverse = !vm.reverse;
        }

        /**
         * Abre o form para adicionar um novo usuário
         *
         */
        function addUsuario() {
            vm.tipoAtualizacao = 'add';
            vm.lstAllTemas = [];
            angular.element('#email').prop('disabled', false);
            angular.element('#password').prop('disabled', false);
            angular.element('#login').prop('disabled', false);

            delete vm.app;
            vm.app = {};
            vm.beforeEdit = null;
        }

        /**
         * Edita um usuário
         *
         * @param {object} value Objeto de usuário
         */
        function edit(value) {
            vm.tipoAtualizacao = 'edit';
            vm.beforeEdit = value.name;
            delete vm.app;

            angular.element('#email').prop('disabled', true);
            angular.element('#password').prop('disabled', true);
            angular.element('#login').prop('disabled', true);
            vm.listaTemasCargoPerfil(value);
            vm.app = angular.copy(value);
        }


        function botaoFechar(value) {
            debugger;


            vm.afterEdit = value.name;

            if ((vm.beforeEdit === vm.afterEdit) || !vm.beforeEdit) {
                angular.element('#modalEdicao').modal('hide')

            } else {
                if (confirm("Existem itens pendentes de salvamento. Deseja encerrar e perder os dados não salvos?")) {
                    angular.element('#modalEdicao').modal('hide');
                }

            }



        }

        /**
         * Validações antes de salvar
         *
         * @param {object} value Objeto de usuário
         */
        function beforeUpdate(value) {



            var file = document.querySelector('#imagemConteudo').files[0];
            if (file) {
                var tipoDeArquivo = file.type;

                var arquivoEscolhido = verificaFormato(tipoDeArquivo);

                console.log(arquivoEscolhido)

                if (arquivoEscolhido == false) {
                    alert("Escolha um arquivo no formato de imagem.")
                    return;
                }
            }


            if (!value.email || !value.login || !value.name || !value.password) {
                alert('Você deve preencher corretamente todos os itens obrigatórios.');
                return false;
            }

            if (value.codigo) {
                vm.update(value);
            } else {
                var verificaLogin = vm.fireBaseRef.child('usuarios-login');
                verificaLogin.orderByChild('login').equalTo(value.login.toLowerCase()).limitToFirst(1).once('value', function (snapshot) {
                    if (snapshot.val()) {
                        alert('Login já existente! Favor digitar outro login.');
                        angular.element('#login').focus();
                        return;
                    } else {
                        vm.update(value);
                    }
                });

            }
        }

        /**
         * Salva um usuário
         *
         * @param {object} value Objeto de usuário
         * @returns
         */
        function update(value) {
            var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if (!value.email || !value.login || !value.name || !value.password) {
                alert('Você deve preencher corretamente todos os itens obrigatórios.');
                return false;
            }
            if (!pattern.test(value.email)) {
                alert("O campo e-mail está fora do padrão");
                return false;
            }

            if (value.password.length < 6) {
                alert("A senha deve conter pelo menos 6 caracters");
                return false;
            }

            vm.tipoAtualizacao = 'update';
            vm.listaTemasCargoPerfil(value);
            if (value.codigo) {
                updateUser(value); // Atualiza
            } else {
                saveNewUser(value); // Cria um novo
            }
            //alert('mgs temp');
        }

        function desabilitarUser(item, e) {
            var conteudo = {
                desabilitado: true
            }
            var confirmar = confirm('Deseja desabilitar o usuário selecionado?');
            if (confirmar) {
                angular.element('.loading').show();
                vm.fireBaseRef.child(vm.nomeTabela).child(item.codigo).update(conteudo).then(function () {
                    angular.element('.loading').hide();
                    $timeout(function () {
                        location.reload()
                    }, 200);
                });
            }
        }

        function habilitarUser(item, e) {
            var conteudo = {
                desabilitado: false
            }
            var confirmar = confirm('Deseja habilitar o usuário selecionado?');
            if (confirmar) {
                angular.element('.loading').show();
                vm.fireBaseRef.child(vm.nomeTabela).child(item.codigo).update(conteudo).then(function () {
                    angular.element('.loading').hide();
                    $timeout(function () {
                        location.reload()
                    }, 200);
                });
            }
        }

        /**
         * Deleta um usuário
         *
         * @param {object} item Obejto de usuário
         * @param {*} e Evento
         */
        function deleteUser(item, e) {

            var confirmar = confirm('Deseja excluir o item selecionado?');
            if (confirmar) {
                vm.fireBaseRef.child(vm.nomeTabela).child(item.codigo).remove();
                vm.fireBaseRef.child('usuarios-conteudos').child(item.codigo).remove();
                vm.fireBaseRef.child('usuarios-login').orderByChild('login').equalTo(item.login).once('value',
                    function (snapshot) {
                        if (snapshot.val()) {
                            var key = Object.keys(snapshot.val())[0];
                            if (key) {
                                vm.fireBaseRef.child('usuarios-login').child(key).remove();
                            }
                        }
                    }
                );
                angular.element(e.currentTarget).closest('tr').remove();
                if (angular.element('#gridDados tbody tr').length <= 0) {
                    vm.filter_data = 0;
                    vm.entire_user = 0;
                    delete vm.file;
                } else {
                    vm.filter_data = vm.filter_data - 1;
                    vm.entire_user = vm.entire_user - 1;
                }
            }
        }

        /**
         * Reset
         *
         */
        function reset(key, temas) {
            incluirUsuariosConteudos(key, temas, function () {
                debugger;
                //vm.aux = 0;
                alert('Ação realizada com sucesso');
                angular.element('#modalEdicao').modal('hide');
                angular.element('.loading').hide();
                $timeout(function () {
                    location.reload()
                }, 200);
            })

        }

        /**
         * Relatório
         *
         * @param {object} data Objeto de usuário
         */
        function relatorio(data) {
            angular.element('#modalRelatorio').find('iframe').attr('src', '//about:blank');
            $timeout(function () {
                angular.element('#modalRelatorio').find('iframe').attr('src', '#/cardUsuario?id=' + data.codigo);
            }, 500);
        }

        /**
         * Importação de usuários pelo excel
         *
         */
        function openImportarUsuarios() {
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/cadastros/importar-usuarios.modal.html',
                controller: 'ImportarUsuariosController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    objData: function () {
                        return ['galo'];
                    }
                }
            });

            modalInstance.result.then(function () {
                $state.reload();
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
            });
        }

        /***************************************************
         *** Private methods
         ***************************************************/

        /**
         * Pega o Id do usuário e senão tiver sucesso redireciona para login
         *
         * @returns Id do usuário
         */
        function getUserId() {
            var userId = sessionStorage.getItem('codUsuarioLogado');

            if (!userId) {
                document.location.href = '#/login';
                return;
            } else {
                return userId;
            }
        }

        /**
         * Evento ao mudar o estado da autenticação
         *
         */
        function onAuthStateChanged() {
            // any time auth state changes, add the user data to scope
            vm.auth.$onAuthStateChanged(function (firebaseUser) {
                if (!firebaseUser && vm.userId != undefined) {
                    document.location.href = '#/login';
                }
            });
        }

        /**
         * Atualiza notificações
         *
         */
        function atualizaNotificacao() {
            AtualizaNotificacao.notificacao();
        }

        /**
         * Set firebase ref
         *
         */
        function setFirebaseRef() {
            vm.fireBaseRefUsuarios = firebase.database().ref('usuarios');
            vm.fireBaseRef = firebase.database().ref();
        }

        /**
         * Obtém a foto para usuários sem fotos
         *
         * @returns
         */
        function getFotoEmpty() {
            return 'https://firebasestorage.googleapis.com/v0/b/abaris-treinamento-0001.appspot.com/o/profile_empty.jpg?alt=media&token=1433ea4e-a573-4cda-842b-14a9aac94618';
        }

        /**
         * Ready jQuery
         *
         */
        function loadReady() {
            angular.element(document).ready(function () {
                angular.element('.input-busca').focus();
                $timeout(function () {
                    angular.element('.input-busca').blur();
                }, 500);
            });
        }

        /**
         * Atualiza usuário
         *
         * @param {object} value Objeto de usuário
         */
        function updateUser(value) {
            angular.element('.loading').show();
            var file = document.querySelector('#imagemConteudo').files[0];
            var key = value.codigo;

            var conteudo = {
                name: value.name,
                login: value.login.toLowerCase(),
                area: value.area,
                cargo: value.cargo,
                empresa: value.empresa,
                temas: value.temas,
                timestamp: value.timestamp ? value.timestamp : null
            };

            if (file != undefined) {
                var name = (+new Date()) + '-' + file.name;
                var metadata = {
                    contentType: file.type
                };
                var task = firebase.storage().ref().child(name).put(file, metadata);

                task.on(firebase.storage.TaskEvent.STATE_CHANGED,
                    function (snapshot) {
                        //snapshot.ref.getDownloadURL()
                        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        console.log('Upload is ' + progress + '% done');
                        switch (snapshot.state) {
                            case firebase.storage.TaskState.PAUSED: // or 'paused'
                                console.log('Upload is paused');
                                break;
                            case firebase.storage.TaskState.RUNNING: // or 'running'
                                console.log('Upload is running');
                                break;
                        }
                    },
                    function (error) {

                        // A full list of error codes is available at
                        // https://firebase.google.com/docs/storage/web/handle-errors
                        switch (error.code) {
                            case 'storage/unauthorized':
                                // User doesn't have permission to access the object
                                angular.element('.loading').hide();
                                alert('O upload não foi concluído porque o seu usuário não está logado no sistema');
                                break;

                            case 'storage/canceled':
                                // User canceled the upload
                                angular.element('.loading').hide();
                                alert('O usuário cancelou o upload');
                                break;

                            case 'storage/unknown':
                                // Unknown error occurred, inspect error.serverResponse
                                angular.element('.loading').hide();
                                alert('Um erro desconhecido aconteceu durante o upload, tente novamente. Se persistir contate o administrador do sistema');
                                vm.fireBaseRef.child('log').child(key).update({
                                    erro: error
                                });
                                break;
                        }
                    },
                    function () {
                        task.snapshot.ref.getDownloadURL().then(function (url) {
                            conteudo['foto'] = url
                            vm.fireBaseRef.child(vm.nomeTabela).child(key).update(conteudo).then(function () {
                                vm.reset(key, conteudo.temas);
                            });
                        });
                    });
            } else {
                if (value.foto == undefined || value.foto == '') {
                    conteudo['foto'] = vm.fotoEmpty;
                }

                vm.fireBaseRef.child(vm.nomeTabela).child(key).update(conteudo).then(function () {
                    vm.reset(key, conteudo.temas);
                });
            }
        }

        function setTemas(value) {
            var temas;
            if (value.temas) {
                if (vm.lstAllTemas) {
                    temas = vm.lstAllTemas.concat(value.temas);
                } else {
                    temas = value.temas;
                }
            } else {
                if (vm.lstAllTemas) {
                    temas = vm.lstAllTemas;
                } else {
                    temas = null;
                }
            }
            return temas;
        }

        /**
         * Adiciona um novo usuário
         *
         * @param {object} value Objeto do novo usuário
         */
        function saveNewUser(value) {

            angular.element('.loading').show();
            var file = document.querySelector('#imagemConteudo').files[0];
            var username = value.email;
            var password = value.password;
            var conteudo = {};

            vm.auth.$createUserWithEmailAndPassword(username, password)
                .then(function (firebaseUser) {
                    var temasUsuario = vm.setTemas(value);
                    vm.fireBaseRef.child('usuarios').child(firebaseUser.uid)
                        .update({
                            name: value.name,
                            email: value.email,
                            login: value.login.toLowerCase(),
                            password: value.password,
                            area: value.area ? value.area : '',
                            cargo: value.cargo ? value.cargo : '',
                            empresa: value.empresa ? value.empresa : '',
                            admin: false,
                            foto: 'https://firebasestorage.googleapis.com/v0/b/angularjs-firebase-0001.appspot.com/o/profile_empty.jpg?alt=media&token=5b2a97b1-27bc-45a9-aeed-520aac50b826',
                            temas: temasUsuario,
                            timestamp: firebase.database.ServerValue.TIMESTAMP
                        })
                        .then(function () {
                            //Inserindo novo campo de login para o usuário em outro nó do firebase
                            var chave = vm.fireBaseRef.child('usuarios-login').push().key;

                            vm.fireBaseRef.child('usuarios-login').child(chave)
                                .update({
                                    login: value.login.toLowerCase(),
                                    email: value.email
                                });

                            if (file != undefined) {
                                var name = (+new Date()) + file.name;
                                var metadata = {
                                    contentType: file.type
                                };
                                var task = firebase.storage().ref().child(name).put(file, metadata);

                                task.on(firebase.storage.TaskEvent.STATE_CHANGED,
                                    function (snapshot) {
                                        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                        console.log('Upload is ' + progress + '% done');
                                        switch (snapshot.state) {
                                            case firebase.storage.TaskState.PAUSED: // or 'paused'
                                                console.log('Upload is paused');
                                                break;
                                            case firebase.storage.TaskState.RUNNING: // or 'running'
                                                console.log('Upload is running');
                                                break;
                                        }
                                    },
                                    function (error) {

                                        // A full list of error codes is available at
                                        // https://firebase.google.com/docs/storage/web/handle-errors
                                        switch (error.code) {
                                            case 'storage/unauthorized':
                                                // User doesn't have permission to access the object
                                                angular.element('.loading').hide();
                                                alert('O upload não foi concluído porque o seu usuário não está logado no sistema');
                                                break;

                                            case 'storage/canceled':
                                                // User canceled the upload
                                                angular.element('.loading').hide();
                                                alert('O usuário cancelou o upload');
                                                break;

                                            case 'storage/unknown':
                                                // Unknown error occurred, inspect error.serverResponse
                                                angular.element('.loading').hide();
                                                alert('Um erro desconhecido aconteceu durante o upload, tente novamente. Se persistir contate o administrador do sistema');
                                                vm.fireBaseRef.child('log').child(key).update({
                                                    erro: error
                                                });
                                                break;
                                        }
                                    },
                                    function () {
                                        task.snapshot.ref.getDownloadURL()
                                            .then(function (url) {
                                                conteudo['foto'] = url
                                                vm.fireBaseRef.child(vm.nomeTabela).child(firebaseUser.uid).update(conteudo).then(function () {
                                                    vm.reset(firebaseUser.uid, temasUsuario);
                                                });
                                            });
                                    });
                            } else {
                                vm.fireBaseRef.child(vm.nomeTabela).child(firebaseUser.uid).update(conteudo)
                                    .then(function () {
                                        console.log('uid', firebaseUser.uid);
                                        vm.reset(firebaseUser.uid, temasUsuario);
                                    });
                            }
                        });

                    //O email informado não é válido ou já está cadastrado.

                }).catch(function (error) {
                    alert('O email informado não é válido ou já está cadastrado.')
                    console.error('Criação erro: ', error);
                    angular.element('.loading').hide();
                });
        }

        /**
         * Toggle para checkbox list de temas
         *
         * @param {*} value
         * @param {*} obj
         */
        function toggleSelection(value, obj) {
            if (!vm.app.temas) {
                vm.app.temas = [];
            }

            var index = vm.app.temas.indexOf(value);
            if (obj.currentTarget.checked) {
                if (index == -1) {
                    vm.app.temas.push(value);
                }
            } else {

                if (index != -1) {
                    vm.app.temas.splice(index, 1);
                }
            }
        }

        function incluirUsuariosConteudos(key, temas, callback) {
            var count = 0;
            vm.fireBaseRef.child('conteudos').on('child_added', function (snap) {
                count++;

                vm.fireBaseRef.child("usuarios-conteudos").child(key).child(snap.key).once("value", function (snp) {

                    if (snp.val() != null) {

                        if (temas.indexOf(snp.val().temaId) == -1) {
                            vm.fireBaseRef.child("usuarios-conteudos").child(key).child(snap.key).remove();
                        } else {
                            var content = {};
                            if (snap.val().temas == snp.val().temaId) {
                                content[snap.key] = {
                                    status: snp.val().status,
                                    temaId: snap.val().temas,
                                    comentario: snp.val().comentario != undefined ? snp.val().comentario : null,
                                    curtiuConteudo: snp.val().curtiuConteudo != undefined ? snp.val().curtiuConteudo : null
                                };

                                vm.fireBaseRef.child("usuarios-conteudos").child(key).update(content).then(function () {});
                            }
                        }

                    } else {
                        var content = {};
                        if (temas.indexOf(snap.val().temas) != -1) {
                            content[snap.key] = {
                                status: "novo",
                                temaId: snap.val().temas
                            };
                            vm.fireBaseRef.child("usuarios-conteudos").child(key).update(content).then(function () {});
                        }
                    }

                }).then(function () {
                    count--;
                    if (count <= 0) {
                        if (typeof (callback) === "function")
                            callback();
                    }
                });
            });

        }

    }

    angular.module('trh')
        .filter('beginning_data', beginningDataFilter);

    function beginningDataFilter() {
        return function (input, begin) {
            if (input) {
                begin = +begin;
                return input.slice(begin);
            }
            return [];
        }



    }

})();

'use strict';



angular.module('trh')
    .controller('CadastroTemas', ['$scope', '$http', 'Auth', '$location', '$timeout', '$firebaseObject', '$firebaseArray', 'AtualizaNotificacao', function ($scope, $http, Auth, $location, $timeout, $firebaseObject, $firebaseArray, AtualizaNotificacao) {

        var queryString = $location.search();

        var userId = sessionStorage.getItem("codUsuarioLogado");

        $scope.beforeEdit = null;
        $scope.afterEdit = null;

        if (!userId) {
            document.location.href = "#/login";
            return;
        }

        $scope.tipoAtualizacao = null;

        $scope.auth = Auth;
        // any time auth state changes, add the user data to scope
        $scope.auth.$onAuthStateChanged(function (firebaseUser) {
            if (!firebaseUser && userId != undefined) {
                document.location.href = "#/login";
            }
        });
        AtualizaNotificacao.notificacao();
        var nomeTabela = "temas";
        var rootRef = firebase.database().ref();
        var tabela = rootRef.child(nomeTabela);

        // $firebaseArray(temas).$loaded().then(function (snap) {
        //   $scope.titulo = snap.$value;
        // })

        var env = this

        var count = 0;
        var dados = [];
        $scope.filter_data = 0;
        tabela.orderByPriority().on('child_added', function (snap) {
            count += 1;

            dados.push({
                "codigo": snap.key,
                "valor": snap.val()
            });
            dados = dados.reverse();
            $scope.file = dados;
            $scope.filter_data = count;
            $scope.entire_user = count;
            $scope.page_position(1);
        })

        $scope.current_grid = 1;
        $scope.data_limit = 100;

        $scope.page_position = function (page_number) {
            $scope.current_grid = page_number;
        };
        $scope.filter = function () {
            $timeout(function () {
                $scope.filter_data = $scope.searched.length;
            }, 20);
        };
        $scope.sort_with = function (base) {
            $scope.base = base;
            $scope.reverse = !$scope.reverse;
        };



        $scope.abreForm = function () {
            $scope.tipoAtualizacao = "add";
            delete $scope.app;
            $scope.app = {};
            $scope.beforeEdit = null;
        }

        $scope.botaoFechar = function (value) {
            debugger;

            $scope.afterEdit = value.valor;

            if (($scope.beforeEdit === $scope.afterEdit) || !$scope.beforeEdit) {
                $('#modalEdicao').modal('hide')

            } else {

                var confirmar = confirm("Existem itens pendentes de salvamento. Deseja encerrar e perder os dados não salvos?");

                if (confirmar == true) {
                    $('#modalEdicao').modal('hide')

                }


            }

        }

        $scope.verificaDuplicado = function (value) {

            if (!value.valor) {
                alert("Você deve preencher corretamente todos os itens obrigatórios")
                return;
            }

            var verificaTemas = firebase.database().ref().child('temas');

            verificaTemas.orderByValue().equalTo(value.valor).limitToFirst(1).once('value', function (snapshot) {

                if (snapshot.val()) {

                    if ($scope.tipoAtualizacao == 'add') {
                        alert('Já existe um item com os dados informados.');
                        return;
                    } else {
                        if (snapshot.val()[value.valor] == $scope.app.valor) {
                            alert('Já existe um item com os dados informados.');
                            return;
                        } else {
                            $scope.update($scope.app);
                        }
                    }
                } else {

                    $scope.update($scope.app);
                }
            });
        }
        $scope.edit = function (value) {
            $scope.beforeEdit = value.valor;
            $scope.tipoAtualizacao = "edit";
            $scope.app = value
            $scope.app = angular.copy(value);
        }
        $scope.update = function (value) {

            if (!value.valor) {
                alert("Você deve preencher corretamente todos os itens obrigatórios.");
                return false;
            }

            console.log("valor", value.codigo)
            if (value.codigo) {
                var key = value.codigo
            } else {

                var key = firebase.database().ref().child(nomeTabela).push().key;
                console.log("chave", key);
            }
            var conteudo = {}
            debugger;
            conteudo[key] = value.valor
            var novo = firebase.database().ref().child(nomeTabela).update(conteudo);
            delete $scope.app;
            $('#modalEdicao').modal('hide')
            //$scope.filter_data = $scope.filter_data + 1;
            //$scope.entire_user = $scope.entire_user + 1;

            document.location.reload();

            alert('Ação realizada com sucesso');
        }
        $scope.delete = function (item, e) {
            var confirmar = confirm("Deseja excluir o item selecionado?");
            if (confirmar) {
                var novo = firebase.database().ref().child(nomeTabela).child(item.codigo).remove();
                angular.element(e.currentTarget).closest("tr").remove();
                $scope.filter_data = $scope.filter_data - 1;
                $scope.entire_user = $scope.entire_user - 1;
            }
        }
        angular.element(document).ready(function () {
            angular.element(".input-busca").focus();
            setTimeout(function () {
                angular.element(".input-busca").blur();
            }, 500)


        });

    }]).filter('beginning_data', function () {
        return function (input, begin) {
            console.log(123);
            if (input) {
                begin = +begin;
                return input.slice(begin);
            }
            return [];
        }
    });;

(function () {
    'use strict';

    angular.module('trh').controller('CadastroEmpresas', CadastroEmpresas);

    CadastroEmpresas.$inject = [
        'FirebaseService', '$scope', '$http', 'Auth', '$location', '$timeout', '$firebaseObject',
        '$firebaseArray', 'AtualizaNotificacao', '$state'
    ];

    /**
     * Controller de cadastro de empresas
     *
     * @param {*} $scope
     * @param {*} $http
     * @param {*} Auth
     * @param {*} $location
     * @param {*} $timeout
     * @param {*} $firebaseObject
     * @param {*} $firebaseArray
     * @param {*} AtualizaNotificacao
     * @param {*} $state
     */
    function CadastroEmpresas(objFirebaseService, $scope, $http, Auth, $location, $timeout, $firebaseObject,
        $firebaseArray, AtualizaNotificacao, $state) {

        // View model
        var vm = this;

        /***************************************************
         *** Attributes
         ***************************************************/
        vm.objEmpresaList = [];
        vm.auth = Auth;
        vm.userId = null;
        vm.tipoAtualizacao = null;
        vm.app = {};
        vm.filter_data = 0;
        vm.searched = [];
        vm.base = null;
        vm.reverse = null;
        vm.current_grid = 1;
        vm.file = null;
        vm.entire_user = 0;
        vm.data_limit = 100;
        vm.beforeEdit = null;
        vm.afterEdit = null;
        vm.fireBaseRef = null;
        vm.fireBaseRefUnidades = null;
        vm.nomeTabela = 'empresas'


        // Carregam as empresas
        vm.loadEmpresas = loadEmpresas;
        // Atualiza/salva unidade
        vm.update = update;
        // Page position
        vm.page_position = page_position;

        // Apaga uma unidade
        vm.deleteUnidade = deleteUnidade;

        // Checkbox para escolher ou não a inclusão de logomarca
        vm.toggleSemLogomarca = toggleSemLogomarca;

        // Método para tratar o botão fechar
        vm.botaoFechar = botaoFechar;

        // Método para verificar se o registro é duplicado
        vm.verificaDuplicado = verificaDuplicado;

        vm.verificaFormato = verificaFormato;

        vm.addNovaUnidade = addNovaUnidade;

        vm.filter = filter;

        vm.sort_with = sort_with;

        vm.edit = edit;

        var nomeTabela = "empresas";



        /***************************************************
         *** Initialize
         ***************************************************/

        init();

        /**
         * Inicialização
         *
         */
        function init() {
            vm.userId = getUserId();
            onAuthStateChanged();
            atualizaNotificacao();
            vm.loadEmpresas();
            angularReady();
            setFirebaseRef();
        }


        function verificaFormato(tipoDeArquivo) {

            if (tipoDeArquivo == "image/png" || tipoDeArquivo == "image/gif" || tipoDeArquivo == "image/jpeg" || tipoDeArquivo == "image/jpg") {
                return true;
            } else {
                return false;
            }
        }

        /**
         *
         *
         * @param {*} value
         */
        function verificaDuplicado(value) {
            debugger;
            if (!value.nome) {
                alert("Você deve preencher corretamente todos os itens obrigatórios");
                return false;
            }
            var file = document.querySelector('#imagemConteudo').files[0];
            var tipoDeArquivo = file ? file.type : null;


            //  var tipoMidia = fMidia ? fMidia.type : null;
            var arquivoEscolhido = verificaFormato(tipoDeArquivo);

            console.log(arquivoEscolhido)

            if (arquivoEscolhido == false && tipoDeArquivo) {
                alert("Escolha um arquivo no formato de imagem.")
                return;
            }


            if ((arquivoEscolhido == false && !tipoDeArquivo) && !value.nome) {
                alert("Você deve preencher corretamente todos os itens obrigatórios")
                return;
            }
            var verificaEmpresa = vm.fireBaseRef.child('empresas');

            verificaEmpresa.orderByChild('nome').equalTo(value.nome).limitToFirst(1).once('value', function (snapshot) {
                if (snapshot.val()) {
                    if (vm.tipoAtualizacao == 'add') {
                        alert('Já existe um item com os dados informados.');
                        return;
                    } else {
                        if (!file && snapshot.val().nome == value.nome) {
                            alert('Já existe um item com os dados informados.');
                            return;
                        } else {
                            vm.update(value);
                        }
                    }

                } else {
                    vm.update(value);
                }
            });


        }

        /**
         * Set firebase ref
         *
         */

        function setFirebaseRef() {

            vm.fireBaseRefUnidades = firebase.database().ref('empresas');
            vm.fireBaseRef = firebase.database().ref();
        }

        function botaoFechar(value) {

            debugger;
            vm.afterEdit = value.nome;

            if ((vm.beforeEdit === vm.afterEdit) || !vm.beforeEdit) {
                $('#modalEdicao').modal('hide')

            } else {

                var confirmar = confirm("Existem itens pendentes de salvamento. Deseja encerrar e perder os dados não salvos?");

                if (confirmar == true) {
                    $('#modalEdicao').modal('hide')

                }


            }

        }


        /**
         * Page postion
         *
         * @param {number} page_number Número da página
         */


        function page_position(page_number) {
            vm.current_grid = page_number;
        }

        function update(value) {
            debugger;

            var data = null;

            if (vm.tipoAtualizacao == 'add') {
                data = firebase.database.ServerValue.TIMESTAMP;
            }

            var ref = firebase.storage().ref();
            var semLogomarca = value.semLogomarca;
            var file = semLogomarca ? null : document.querySelector('#imagemConteudo').files[0];

            if (value.$id) {
                var key = value.$id
            } else {
                var key = firebase.database().ref().child(nomeTabela).push().key;
                console.log("chave", key);
            }

            var conteudo = {
                nome: value.nome,
                foto: semLogomarca ? null : (value.foto ? value.foto : null),
                timestamp: value.timestamp ? value.timestamp : data
            }

            firebase.database().ref().child(nomeTabela).child(key).update(conteudo)
                .then(function () {

                    if (file != undefined || file != null) {
                        var name = (+new Date()) + file.name;
                        var metadata = {
                            contentType: file.type
                        };
                        var task = ref.child(name).put(file, metadata);
                        task
                            .on(firebase.storage.TaskEvent.STATE_CHANGED, function (snapshot) {

                                //snapshot.ref.getDownloadURL()
                                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                console.log('Upload is ' + progress + '% done');
                                switch (snapshot.state) {
                                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                                        console.log('Upload is paused');
                                        break;
                                    case firebase.storage.TaskState.RUNNING: // or 'running'
                                        console.log('Upload is running');
                                        break;
                                }
                            }, function (error) {

                                // A full list of error codes is available at
                                // https://firebase.google.com/docs/storage/web/handle-errors
                                switch (error.code) {
                                    case 'storage/unauthorized':
                                        // User doesn't have permission to access the object
                                        alert("O upload não foi concluído porque o seu usuário não está logado no sistema");
                                        break;

                                    case 'storage/canceled':
                                        // User canceled the upload
                                        alert("O usuário cancelou o upload");
                                        break;

                                    case 'storage/unknown':
                                        // Unknown error occurred, inspect error.serverResponse
                                        alert("Um erro desconhecido aconteceu durante o upload, tente novamente. Se persistir contate o administrador do sistema");
                                        firebase.database().ref().child("log").child(key).update({
                                            erro: error
                                        });
                                        break;
                                }
                            }, function () {

                                task.snapshot.ref.getDownloadURL().then(function (url) {

                                    conteudo.foto = url

                                    firebase.database().ref().child(nomeTabela).child(key).update(conteudo).then(function () {
                                        alert('Ação realizada com sucesso');
                                        document.location.reload();
                                        // $scope.reset();
                                    });
                                });
                            });
                    } else {
                        firebase.database().ref().child(nomeTabela).child(key).update(conteudo).then(function () {
                            alert('Ação realizada com sucesso');
                            document.location.reload();
                            // $scope.reset();
                        });
                    }

                });

        }

        function addNovaUnidade() {
            vm.semLogomarca = false;
            vm.tipoAtualizacao = 'add';
            delete vm.app;
            vm.app = {};
            vm.beforeEdit = null;
        }


        function filter() {
            $timeout(function () {
                vm.filter_data = vm.searched.length;
            }, 20);
        };

        function sort_with(base) {
            vm.base = base;
            vm.reverse = !vm.reverse;
        };

        function edit(value) {

            vm.beforeEdit = value.nome;
            vm.tipoAtualizacao = 'edit';
            delete vm.app;

            vm.app = angular.copy(value);
        }


        function deleteUnidade(item, e) {
            debugger;
            var confirmar = confirm("Deseja excluir o item selecionado?");
            if (confirmar) {
                var novo = firebase.database().ref().child(nomeTabela).child(item.codigo).remove();
                angular.element(e.currentTarget).closest("tr").remove();
                if (angular.element("#gridDados tbody tr").length <= 0) {
                    $scope.filter_data = 0;
                    $scope.entire_user = 0;
                    delete $scope.file;
                } else {
                    $scope.filter_data = $scope.filter_data - 1;
                    $scope.entire_user = $scope.entire_user - 1;
                }
            }
        }

        function toggleSemLogomarca(e) {

            if (e.currentTarget.checked) {
                vm.semLogomarca = true;
                //angular.element("#formGroupimagem").hide();
            } else {
                vm.semLogomarca = false;
                //angular.element("#formGroupimagem").show();
            };
        }

        /**
         * Pega o Id do usuário e senão tiver sucesso redireciona para login
         *
         * @returns Id do usuário
         */
        function getUserId() {
            var userId = sessionStorage.getItem('codUsuarioLogado');

            if (!userId) {
                document.location.href = '#/login';
                return;
            } else {
                return userId;
            }
        }

        /**
         * Evento ao mudar o estado da autenticação
         *
         */
        function onAuthStateChanged() {
            // any time auth state changes, add the user data to scope
            vm.auth.$onAuthStateChanged(function (firebaseUser) {
                if (!firebaseUser && vm.userId != undefined) {
                    document.location.href = '#/login';
                }
            });
        }

        /**
         * Angular ready
         *
         */
        function angularReady() {
            // angular.element(document).ready(function () {
            //     angular.element('.input-busca').focus();
            //     $timeout(function () {
            //         angular.element('.input-busca').blur();
            //     }, 500);

            // });
        }

        /**
         * Atualiza notificações
         *
         */
        function atualizaNotificacao() {
            AtualizaNotificacao.notificacao();
        }

        function loadEmpresas() {
            debugger;
            vm.objEmpresaList = [];

            objFirebaseService.getAll(vm.nomeTabela)
                .then(function (objEmpresaList) {
                    vm.objEmpresaList = [].concat(objEmpresaList);

                    vm.objEmpresaList = vm.objEmpresaList.reverse();
                    var count = vm.objEmpresaList.length;
                    vm.filter_data = count;
                    vm.entire_user = count;

                });
        }

        // function loadEmpresas() {

        //     var rootRef = firebase.database().ref();
        //     var tabela = rootRef.child("empresas");


        //     var count = 0;
        //     var dados = [];
        //     vm.filter_data = 0;

        //     tabela.orderByChild("timestamp").on('value', function (snap) {

        //         count += 1;

        //         dados.push({
        //             "codigo": snap.key,
        //             "nome": snap.val().nome,
        //             "foto": snap.val().foto
        //         });

        //         // function page_position(page_number) {
        //         //     vm.current_grid = page_number;
        //         // };


        //         // dados = dados.reverse();

        //         vm.file = dados;
        //         vm.filter_data = count;
        //         vm.entire_user = count;

        //         //$scope.current_grid = 1;
        //         //data_limit = 100;
        //         vm.page_position(1);
        //     });
        // }
    }

    angular.module('trh')
        .filter('beginning_data', function () {
            return function (input, begin) {
                if (input) {
                    begin = +begin;
                    return input.slice(begin);
                }
                return [];
            }
        });;

})();

'use strict';

angular.module('trh')
    .controller('CadastroConteudos', ['$scope', '$http', 'Auth', '$location', '$timeout', '$firebaseObject', '$firebaseArray', 'AtualizaNotificacao', '$window', function ($scope, $http, Auth, $location, $timeout, $firebaseObject, $firebaseArray, AtualizaNotificacao, $window) {

        var queryString = $location.search();

        $scope.tipoAtualizacao = null;

        $scope.beforeEdit = null;
        $scope.afterEdit = null;


        var userId = sessionStorage.getItem("codUsuarioLogado");

        if (!userId) {
            document.location.href = "#/login";
            return;
        }

        $scope.auth = Auth;
        // any time auth state changes, add the user data to scope
        $scope.auth.$onAuthStateChanged(function (firebaseUser) {
            if (!firebaseUser && userId != undefined) {
                document.location.href = "#/login";
            }
        });
        AtualizaNotificacao.notificacao();

        var icoPdf = "https://firebasestorage.googleapis.com/v0/b/abaris-treinamento-0001.appspot.com/o/pdf-ico.png?alt=media&token=956cff56-5b4e-44f3-9bc4-f11955df9d3b";
        var icoAudio = "https://firebasestorage.googleapis.com/v0/b/abaris-treinamento-0001.appspot.com/o/audio-ico.png?alt=media&token=f24dab58-937c-4a5e-add3-7e01319af3d7";
        var icoVideo = "https://firebasestorage.googleapis.com/v0/b/abaris-treinamento-0001.appspot.com/o/play-ico.png?alt=media&token=a83c1201-a861-42f6-86b0-5aa3ce55e5b0";

        var rootRef = firebase.database().ref();
        if (!angular.element("#metaClientId")[0]) {
            angular.element("head").append('<meta id="metaClientId" name="google-signin-client_id" content="'+ firebaseConfig.dataClientId +'">');
        }
        $scope.dataClientId = firebaseConfig.dataClientId;
        $scope.filter_data = 0;
        var items = [];
        var promises = [];
        var userId = sessionStorage.getItem("codUsuarioLogado");
        var nomeTabela = "conteudos";

        var promise_conteudos = firebase.database().ref("conteudos").orderByChild('timestamp').once('value');
        var promise_temas = firebase.database().ref().child('temas').once('value');
        promises.push(promise_conteudos, promise_temas) //inserindo as promises na fila

        Promise.all(promises).then(function (resp) {
            var temas = resp[1].val();
            var conteudo = {};

            resp[0].forEach(function (child) {
                conteudo[child.key] = child.val();
            });


            for (var k in conteudo) {
                for (var item in temas) {
                    if (conteudo[k].temas == item) {
                        items.push({
                            codigo: k,
                            name: conteudo[k].name,
                            imagem: conteudo[k].imagem,
                            tipo: conteudo[k].tipo,
                            description: conteudo[k].description,
                            tema: temas[item],
                            temaKey: item,
                            video: conteudo[k].video,
                            audio: conteudo[k].audio,
                            arquivo: conteudo[k].arquivo,
                            like: conteudo[k].like ? conteudo[k].like : "0",
                            dislike: conteudo[k].dislike ? conteudo[k].dislike : "0",
                            timestamp: conteudo[k].timestamp ? conteudo[k].timestamp : null
                        });

                    }
                }

            }
            items = items.reverse();
            $scope.file = items;
            $scope.filter_data = items.length;
            $scope.entire_user = items.length;
            $scope.cbTemas = resp[1].val();
        });



        $scope.current_grid = 1;
        $scope.data_limit = 100;

        var tipoAtualizacao = false;

        var conteudo = {};

        var script = document.createElement('script');
        script.src = "https://apis.google.com/js/client:plusone.js";
        document.getElementsByTagName('head')[0].appendChild(script);

        var script2 = document.createElement('script');
        script2.src = "../../bower_components/youtubeapi/cors_upload.js";
        document.getElementsByTagName('head')[0].appendChild(script2);

        var script3 = document.createElement('script');
        script3.src = "../../bower_components/youtubeapi/upload_video.js";
        document.getElementsByTagName('head')[0].appendChild(script3);


        $scope.page_position = function (page_number) {
            $scope.current_grid = page_number;
        };
        $scope.filter = function () {
            $timeout(function () {
                $scope.filter_data = $scope.searched.length;
            }, 20);
        };
        $scope.sort_with = function (base) {
            $scope.base = base;
            $scope.reverse = !$scope.reverse;
        };

        $scope.abreForm = function () {
            $scope.tipoAtualizacao = "add";

            delete $scope.app;
            $scope.app = {};
            $scope.beforeEdit = null;
        }


        $scope.botaoFechar = function (value) {




            $scope.afterEdit = value.name;

            if (($scope.beforeEdit === $scope.afterEdit) || !$scope.beforeEdit) {
                $('#modalEdicao').modal('hide')

            } else {

                var confirmar = confirm("Existem itens pendentes de salvamento. Deseja encerrar e perder os dados não salvos?");

                if (confirmar == true) {
                    $('#modalEdicao').modal('hide')

                }


            }

        }


        $scope.edit = function (value) {
            $scope.beforeEdit = value.name;
            $scope.tipoAtualizacao = "edit";
            delete $scope.app;
            $scope.app = angular.copy(value);
            $scope.app = {};
            $scope.app = value

        }


        $scope.verificaFormato = function (tipoImagem, tipoMidia, tipoVideo, tipoArquivo, tipoSelecionado) {


            if ((tipoImagem == 0) && ((tipoMidia == 0) && (tipoVideo == 0))) {
                return false;

            }

            if ((tipoVideo && tipoVideo.indexOf("video/") != -1) && (tipoSelecionado == "video")) {
                return true;
            }


            if ((tipoMidia && tipoMidia.indexOf("audio/") != -1) && (tipoSelecionado == "audio")) {
                return true;
            }

            if ((tipoArquivo && tipoArquivo.indexOf("application/") != -1) && (tipoSelecionado == "arquivo")) {
                return true;
            } else {
                return false;
            }



        }




        $scope.update = function (value) {


            var data = null;

            if ($scope.tipoAtualizacao == 'add') {
                data = firebase.database.ServerValue.TIMESTAMP;
            }

            var fImagem = document.querySelector('#imagemConteudo').files[0];
            var fMidia = document.querySelector('#midia').files[0];
            var fVideo = document.querySelector('#file').files[0];

            var tipoImagem = fImagem ? fImagem.type : null;
            var tipoMidia = fMidia ? fMidia.type : null;
            var tipoVideo = fVideo ? fVideo.type : null

            var tipoSelecionado = document.querySelector('#cbTipo').value;

            if (tipoSelecionado != "urlvideo") {
                if ((tipoMidia) && (tipoMidia.indexOf("/pdf") != -1)) {

                    var fArquivo = document.querySelector('#midia').files[0];
                    //var tipoSelecionado = "arquivo";

                    var tipoArquivo = fArquivo ? fArquivo.type : null;

                    var arquivoEscolhido = $scope.verificaFormato(tipoImagem, tipoMidia, tipoVideo, tipoArquivo, tipoSelecionado);

                } else {

                    var tipoArquivo = fArquivo ? fArquivo.type : null;

                    var arquivoEscolhido = $scope.verificaFormato(tipoImagem, tipoMidia, tipoVideo, tipoArquivo, tipoSelecionado);

                }

                if ((arquivoEscolhido == false) && (tipoImagem || tipoVideo || tipoMidia)) {
                    //var msg = fImagem ? "de imagem" : (fMidia ? "de arquivo" : fVideo ? "de vídeo" : "adequado");
                    alert("Escolha um arquivo no formato adequado")
                    return;
                }
            }



            if (!value.name || !value.description || !value.tipo || !value.temaKey) {
                alert("Você deve preencher corretamente todos os itens obrigatórios.");
                return false;
            }

            if (angular.element("#cbTipo option:first").text() == "") {
                angular.element("#cbTipo option:eq(1)").attr("selected", "selected");
            }
            angular.element(".loading").show();

            if (value.codigo) {
                var key = value.codigo;
            } else {
                tipoAtualizacao = true;
                var key = firebase.database().ref().child(nomeTabela).push().key;
            }

            conteudo = {
                name: value.name,
                tipo: value.tipo,
                description: value.description,
                temas: value.temaKey,
                timestamp: value.timestamp ? value.timestamp : data
            }

            var tipo = angular.element("#cbTipo").val();

            if (tipo == "urlvideo") {
                debugger;
                var pattern = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/;
                var urlvideo = angular.element('#urlVideo').val();
                if ( urlvideo != "" && pattern.test(urlvideo)) {
                    conteudo["video"] = angular.element('#urlVideo').val().replace("https://www.youtube.com/watch?v=", "").replace("http://www.youtube.com/watch?v=", "").replace("https://youtube.com/watch?v=", "").replace("http://youtube.com/watch?v=", "").replace("https://youtu.be/", "");
                } else {
                    alert("O campo com endereço do vídeo deve ser preenchido corretamente");
                    angular.element(".loading").hide();
                    return false;
                }
            }

            if (tipo == "video") {
                if (angular.element('#video-id').val() != "") {
                    conteudo["video"] = angular.element('#video-id').val();
                } else {
                    alert("O Upload do vídeo ainda não foi concluído");
                    angular.element(".loading").hide();
                    return false;
                }
            }

            var ref = firebase.storage().ref();
            var file = document.querySelector('#imagemConteudo').files[0];
            var fileMidia = document.querySelector('#midia').files[0];

            if (file != undefined) {
                var name = (+new Date()) + '-' + file.name;
                var metadata = {
                    contentType: file.type
                };
                var task = ref.child(name).put(file, metadata);
                task.on(firebase.storage.TaskEvent.STATE_CHANGED, function (snapshot) {
                    //snapshot.ref.getDownloadURL()
                    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                        case firebase.storage.TaskState.PAUSED: // or 'paused'
                            console.log('Upload is paused');
                            break;
                        case firebase.storage.TaskState.RUNNING: // or 'running'
                            console.log('Upload is running');
                            break;
                    }
                }, function (error) {

                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (error.code) {
                        case 'storage/unauthorized':
                            // User doesn't have permission to access the object
                            angular.element(".loading").hide();
                            alert("O upload não foi concluído porque o seu usuário não está logado no sistema");
                            break;

                        case 'storage/canceled':
                            // User canceled the upload
                            angular.element(".loading").hide();
                            alert("O usuário cancelou o upload");
                            break;



                        case 'storage/unknown':
                            // Unknown error occurred, inspect error.serverResponse
                            angular.element(".loading").hide();
                            alert("Um erro desconhecido aconteceu durante o upload, tente novamente. Se persistir contate o administrador do sistema");
                            break;
                    }
                }, function () {
                    task.snapshot.ref.getDownloadURL().then(function (url) {
                        conteudo["imagem"] = url;
                        firebase.database().ref().child(nomeTabela).child(key).update(conteudo).then(function () {
                            if (tipo == "video" || tipo == "urlvideo") {
                                $scope.reset();
                            }
                        });
                    });
                });
            } else {

                if (!value.imagem || value.imagem == icoPdf || value.imagem == icoAudio || value.imagem == icoVideo) {
                    if (tipo == "arquivo") {
                        conteudo["imagem"] = icoPdf;
                    }

                    if (tipo == "audio") {
                        conteudo["imagem"] = icoAudio;
                    }

                    if (tipo == "video" || tipo == "urlvideo") {
                        conteudo["imagem"] = icoVideo;
                    }
                }

                firebase.database().ref().child(nomeTabela).child(key).update(conteudo).then(function () {
                    if (tipo == "video" || tipo == "urlvideo") {
                        $scope.reset();
                    }
                });


            }


            if (tipo == "arquivo" && !fileMidia) {
                if ($scope.tipoAtualizacao != "edit") {
                    alert("Você deve preencher corretamente todos os itens obrigatórios.");
                    angular.element(".loading").hide();
                    return false;
                }

            }

            ///upload arquivo midia
            if (tipo == "arquivo" || tipo == "audio") {

                if (fileMidia != undefined) {
                    var nameMidia = (+new Date()) + '-' + fileMidia.name;
                    var metadataMidia = {
                        contentType: fileMidia.type
                    };
                    var taskMidia = ref.child(nameMidia).put(fileMidia, metadataMidia);
                    taskMidia.on(firebase.storage.TaskEvent.STATE_CHANGED, function (snapshot) {
                        //snapshot.ref.getDownloadURL()
                        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        console.log('Upload is ' + progress + '% done');
                        switch (snapshot.state) {
                            case firebase.storage.TaskState.PAUSED: // or 'paused'
                                console.log('Upload is paused');
                                break;
                            case firebase.storage.TaskState.RUNNING: // or 'running'
                                console.log('Upload is running');
                                break;
                        }
                    }, function (error) {

                        // A full list of error codes is available at
                        // https://firebase.google.com/docs/storage/web/handle-errors
                        switch (error.code) {
                            case 'storage/unauthorized':
                                // User doesn't have permission to access the object
                                angular.element(".loading").hide();
                                alert("O upload não foi concluído porque o seu usuário não está logado no sistema");
                                break;

                            case 'storage/canceled':
                                // User canceled the upload
                                angular.element(".loading").hide();
                                alert("O usuário cancelou o upload");
                                break;



                            case 'storage/unknown':
                                // Unknown error occurred, inspect error.serverResponse
                                angular.element(".loading").hide();
                                alert("Um erro desconhecido aconteceu durante o upload, tente novamente. Se persistir contate o administrador do sistema");
                                firebase.database().ref().child("log").child(key).update({
                                    erro: error
                                });
                                break;
                        }
                    }, function () {
                        taskMidia.snapshot.ref.getDownloadURL().then(function (url) {
                            conteudo[tipo] = url;
                            firebase.database().ref().child(nomeTabela).child(key).update(conteudo).then(function () {
                                alert('Ação realizada com sucesso');
                                $scope.reset();
                            });
                        });
                    });
                } else {
                    $scope.reset();
                }
            }



        }
        $scope.delete = function (item, e) {
            var confirmar = confirm("Deseja excluir o item selecionado?");
            if (confirmar) {
                firebase.database().ref().child(nomeTabela).child(item.codigo).remove();
                angular.element(e.currentTarget).closest("tr").remove();
                if (angular.element("#gridDados tbody tr").length <= 0) {
                    $scope.filter_data = 0;
                    $scope.entire_user = 0;
                    delete $scope.file;
                } else {
                    $scope.filter_data = $scope.filter_data - 1;
                    $scope.entire_user = $scope.entire_user - 1;
                }
            }
        }
        $scope.relatorio = function (data) {
            angular.element('#modalRelatorio').find('iframe').attr('src', '//about:blank');
            $timeout(function () {
                angular.element('#modalRelatorio').find('iframe').attr('src', '#/cardRelatorio?id=' + data.codigo);
            }, 500);
        }
        $scope.reset = function () {


            delete $scope.app;
            conteudo = {};
            $('#modalEdicao').modal('hide')

            $scope.resetUpload();
            angular.element(".loading").hide();
            $timeout(function () {
                location.reload()
            }, 200);
        }

        $scope.resetUpload = function () {
            angular.element('#upload-progress').attr({
                value: 0,
                max: 1
            });

            angular.element('#percent-transferred').text("");
            angular.element('#bytes-transferred').text("");
            angular.element('#total-bytes').text("");

            angular.element('.during-upload').hide();

            angular.element('#video-id').val("");
            angular.element('.post-upload').hide();
            angular.element('#button').attr('disabled', false);
            angular.element('#player').empty()
            angular.element('#post-upload-status').empty();
        }

        $scope.logOut = function () {
            var auth2 = gapi.auth2.getAuthInstance();
            auth2.signOut().then(function () {
                console.log('User signed out.');
            });
        }

        angular.element(document).ready(function () {
            angular.element(".input-busca").focus();
            setTimeout(function () {
                angular.element(".input-busca").blur();
            }, 500)


        });

    }]).filter('beginning_data', function () {
        return function (input, begin) {
            if (input) {
                begin = +begin;
                return input.slice(begin);
            }
            return [];
        }
    });;

(function () {

    'use strict';

    angular.module('trh')
        .controller('CadastroPerfisController', CadastroPerfisController)

    CadastroPerfisController.$inject = ['FirebaseService', 'Auth', '$timeout', 'AtualizaNotificacao'];

    function CadastroPerfisController(objFirebaseService, Auth, $timeout, AtualizaNotificacao) {
        // View model
        var vm = this;

        /***************************************************
         *** Attributes
         ***************************************************/
        vm.objPerfilList = [];
        vm.lstTemas = [];
        vm.objPerfil = {};
        vm.userId = null;
        vm.auth = Auth;
        vm.nomeTabela = 'cargos';
        vm.rootRef = null;
        vm.refPerfil = null;

        vm.searched = [];
        vm.base = null;
        vm.reverse = null;
        vm.filter_data = 0;
        vm.entire_user = 0;
        vm.current_grid = 1;
        vm.data_limit = 100;
        vm.tipoAtualizacao = null;
        vm.beforeEdit = null;
        vm.afterEdit = null


        // Carrega as perfis
        vm.loadPerfis = loadPerfis;
        // Carrega a lista de temas
        vm.loadTemas = loadTemas;
        // Page position
        vm.page_position = page_position;
        // Filter
        vm.filter = filter;
        // Sort with
        vm.sort_with = sort_with;
        // Add uma nova área
        vm.addPerfil = addPerfil;
        // Edit uma área
        vm.edit = edit;
        // Atualiza/salva área
        vm.update = update;
        // Deleta uma área
        vm.deletePerfil = deletePerfil;
        // Toggle para checkbox list de temas
        vm.toggleSelection = toggleSelection;

        // Método para tratar o botão fechar
        vm.botaoFechar = botaoFechar;


        // Método para verificar se o registro é duplicado
        vm.verificaDuplicado = verificaDuplicado;


        /***************************************************
         *** Initialize
         ***************************************************/
        init();

        /**
         * Inicialização
         *
         */
        function init() {
            vm.userId = getUserId();
            onAuthStateChanged();
            atualizaNotificacao();
            setFirebaseRef();
            vm.loadPerfis();
            angularReady();

        }

        /***************************************************
         *** Public methods
         ***************************************************/


        /**
         *
         *
         * @param {*} value
         */
        function verificaDuplicado(value) {
            debugger;


            if (!value.nome) {
                alert("Você deve preencher corretamente todos os itens obrigatórios")
                return;
            }

            var verificaArea = firebase.database().ref().child("cargos");

            verificaArea.orderByChild('nome').equalTo(value.nome).limitToFirst(1).once('value', function (snapshot) {
                if (snapshot.val()) {
                    if (vm.tipoAtualizacao == 'add') {
                        alert('Já existe um item com os dados informados.');
                        return;
                    } else {
                        if (snapshot.val().nome == value.nome) {
                            alert('Já existe um item com os dados informados.');
                            return;
                        } else {
                            vm.update(value);
                        }
                    }
                } else {

                    vm.update(vm.objPerfil);
                }
            });


        }

        function botaoFechar(value) {


            vm.afterEdit = value.nome;

            if (vm.beforeEdit === vm.afterEdit) {
                $('#modalEdicao').modal('hide')

            } else {

                var confirmar = confirm("Existem itens pendentes de salvamento. Deseja encerrar e perder os dados não salvos?");

                if (confirmar == true) {
                    $('#modalEdicao').modal('hide')

                }


            }

        }

        /**
         * Carrega a lista de perfis
         *
         */
        function loadPerfis() {
            vm.objPerfilList = [];

            objFirebaseService.getAll(vm.nomeTabela)
                .then(function (objPerfilList) {
                    vm.objPerfilList = [].concat(objPerfilList);
                    angular.forEach(vm.objPerfilList, function (objPerfil) {
                        objPerfil.temasName = [];
                        angular.forEach(objPerfil.temas, function (tema) {
                            objFirebaseService.getRecord("temas", tema, function (snp) {
                                objPerfil.temasName.push(snp.$value);
                            });
                        });
                    });

                    vm.objPerfilList = vm.objPerfilList.reverse();
                    var count = vm.objPerfilList.length;
                    vm.filter_data = count;
                    vm.entire_user = count;

                    vm.loadTemas();
                });
        }

        /**
         * Carrega a lista de temas
         *
         */
        function loadTemas() {
            objFirebaseService.getAll('temas')
                .then(function (objTemaList) {
                    vm.lstTemas = objTemaList;
                });
        }

        /**
         * Page postion
         *
         * @param {number} page_number Número da página
         */
        function page_position(page_number) {
            vm.current_grid = page_number;
        }

        /**
         * Filtro
         *
         */
        function filter() {
            $timeout(function () {
                vm.filter_data = vm.searched.length;
            }, 20);
        }

        /**
         * Sort with
         *
         * @param {number} base
         */
        function sort_with(base) {
            vm.base = base;
            vm.reverse = !vm.reverse;
        };

        /**
         * Add área
         *
         */
        function addPerfil() {

            vm.tipoAtualizacao = "add";
            delete vm.objPerfil;
            vm.objPerfil = {};
        }

        /**
         * Edita área
         *
         * @param {object} value Objeto área
         */
        function edit(value) {

            vm.beforeEdit = value.nome;
            vm.tipoAtualizacao = 'edit';
            delete vm.objPerfil;
            vm.objPerfil = angular.copy(value);
        }

        function update(value) {

            var data = null;

            if (vm.tipoAtualizacao == 'add') {
                data = firebase.database.ServerValue.TIMESTAMP;
            }

            if (!value.nome) {
                alert('Você deve preencher corretamente todos os itens obrigatórios.');
                return false;
            }


            if (value.$id) {
                var key = value.$id
            } else {
                var key = vm.refPerfil.push().key;
            }

            var conteudo = {
                nome: value.nome,
                temas: value.temas ? value.temas : null,
                timestamp: value.timestamp ? value.timestamp : data
            };

            vm.refPerfil.child(key).update(conteudo);
            delete vm.objPerfil;
            $('#modalEdicao').modal('hide')
            vm.filter_data = vm.filter_data;

            $timeout(function () {
                document.location.reload()
            }, 200);


            alert('Ação realizada com sucesso');
        }

        /**
         * Deleta uma área
         *
         * @param {object} item Obejto a ser apagado
         * @param {*} e Evento
         */
        function deletePerfil(item, e) {
            var confirmar = confirm('Deseja excluir o item selecionado?');
            if (confirmar) {
                vm.refPerfil.child(item.$id).remove().then(function () {
                    angular.element(e.currentTarget).closest("tr").remove();
                    if (angular.element("#gridDados tbody tr").length <= 0) {
                        vm.filter_data = 0;
                        vm.entire_user = 0;
                        delete vm.objPerfilList;
                    } else {
                        $timeout(function () {
                            vm.filter_data = vm.filter_data - 1;
                            vm.entire_user = vm.entire_user - 1;
                        }, 100);
                    }
                });
            }
        }

        /***************************************************
         *** Private methods
         ***************************************************/

        /**
         * Pega o Id do usuário e senão tiver sucesso redireciona para login
         *
         * @returns Id do usuário
         */
        function getUserId() {
            var userId = sessionStorage.getItem('codUsuarioLogado');

            if (!userId) {
                document.location.href = '#/login';
                return;
            } else {
                return userId;
            }
        }

        /**
         * Evento ao mudar o estado da autenticação
         *
         */
        function onAuthStateChanged() {
            // any time auth state changes, add the user data to scope
            vm.auth.$onAuthStateChanged(function (firebaseUser) {
                if (!firebaseUser && vm.userId != undefined) {
                    document.location.href = '#/login';
                }
            });
        }

        /**
         * Atualiza notificações
         *
         */
        function atualizaNotificacao() {
            AtualizaNotificacao.notificacao();
        }

        /**
         * Seta o ref do firebase
         *
         */
        function setFirebaseRef() {
            vm.rootRef = firebase.database().ref();
            vm.refPerfil = vm.rootRef.child(vm.nomeTabela);
        }

        /**
         * Angular ready
         *
         */
        function angularReady() {
            angular.element(document).ready(function () {
                angular.element('.input-busca').focus();
                $timeout(function () {
                    angular.element('.input-busca').blur();
                }, 500);

            });
        }

        /**
         * Toggle para checkbox list de temas
         *
         * @param {*} value
         * @param {*} obj
         */
        function toggleSelection(value, obj) {
            if (!vm.objPerfil.temas) {
                vm.objPerfil.temas = [];
            }
            var index = vm.objPerfil.temas.indexOf(value);
            if (obj.currentTarget.checked) {
                if (index == -1) {
                    vm.objPerfil.temas.push(value);
                }
            } else {

                if (index != -1) {
                    vm.objPerfil.temas.splice(index, 1);
                }
            };
        }
    }

    angular.module('trh')
        .filter('beginning_data', function () {
            return function (input, begin) {
                if (input) {
                    begin = +begin;
                    return input.slice(begin);
                }

                return [];
            }
        });

})();

angular.module('trh')
  .controller('CadastroBanners', ['$scope', '$http', 'Auth', '$location', '$timeout', '$firebaseObject', '$firebaseArray', 'AtualizaNotificacao', '$state', function ($scope, $http, Auth, $location, $timeout, $firebaseObject, $firebaseArray, AtualizaNotificacao, $state) {

    var queryString = $location.search();

    var userId = sessionStorage.getItem("codUsuarioLogado");

    if (!userId) {
      document.location.href = "#/login";
      return;
    }

    $scope.auth = Auth;
    // any time auth state changes, add the user data to scope
    $scope.auth.$onAuthStateChanged(function (firebaseUser) {
      if (!firebaseUser && userId != undefined) {
        document.location.href = "#/login";
      }
    });
    AtualizaNotificacao.notificacao();

    var rootRef = firebase.database().ref();
    $scope.filter_data = 0;
    var items = [];
    var promises = [];
    var userId = sessionStorage.getItem("codUsuarioLogado");
    var nomeTabela = "banners";

    var promise_banners = firebase.database().ref(nomeTabela).once('value');
    promises.push(promise_banners);

    Promise.all(promises).then(function (resp) {
      var banners = resp[0].val();
      var result = {};

      var count = 0;
      for (var k in banners) {
        count++;
        result = {
          codigo: k,
          arquivo: banners[k]
        }
        console.log(result);
        items.push(result);
        $scope.filter_data = count;
        $scope.entire_user = count;
      }
      items = items.reverse();
      $scope.file = items;
    });

    $scope.current_grid = 1;
    $scope.data_limit = 100;

    var banner = {};

    $scope.page_position = function (page_number) {
      $scope.current_grid = page_number;
    };
    $scope.filter = function () {
      $timeout(function () {
        $scope.filter_data = $scope.searched.length;
      }, 20);
    };
    $scope.sort_with = function (base) {
      $scope.base = base;
      $scope.reverse = !$scope.reverse;
    };
    $scope.abreForm = function () {
      delete $scope.app;
      $scope.app = {};
    }
    $scope.edit = function (value) {
      $scope.tipoAtualizacao = "edit";
      delete $scope.app;
      $scope.app = value
    }
    $scope.update = function (value) {
      $scope.tipoAtualizacao = "update";
      var ref = firebase.storage().ref();
      var file = document.querySelector('#imagemConteudo').files[0];

      angular.element(".loading").show();
      var key = firebase.database().ref().child(nomeTabela).push().key;;

      //angular.element(".loading").show();

      var conteudo = {}
      conteudo[key] = null;
      firebase.database().ref().child(nomeTabela).update(conteudo)
        .then(function () {
          if (file != undefined) {
            var name = (+new Date()) + file.name;
            var metadata = {
              contentType: file.type
            };
            var task = ref.child(name).put(file, metadata);
            task
              .on(firebase.storage.TaskEvent.STATE_CHANGED, function (snapshot) {
                //snapshot.ref.getDownloadURL()
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
                switch (snapshot.state) {
                  case firebase.storage.TaskState.PAUSED: // or 'paused'
                    console.log('Upload is paused');
                    break;
                  case firebase.storage.TaskState.RUNNING: // or 'running'
                    console.log('Upload is running');
                    break;
                }
              }, function (error) {

                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                  case 'storage/unauthorized':
                    // User doesn't have permission to access the object
                    alert("O upload não foi concluído porque o seu usuário não está logado no sistema");
                    break;

                  case 'storage/canceled':
                    // User canceled the upload
                    alert("O usuário cancelou o upload");
                    break;

                  case 'storage/unknown':
                    // Unknown error occurred, inspect error.serverResponse
                    alert("Um erro desconhecido aconteceu durante o upload, tente novamente. Se persistir contate o administrador do sistema");
                    firebase.database().ref().child("log").child(key).update({
                      erro: error
                    });
                    break;
                }
              }, function () {
                task.snapshot.ref.getDownloadURL().then(function (url) {
                  banner[key] = url
                  firebase.database().ref().child(nomeTabela).update(banner).then(function () {
                    $scope.reset();
                  });
                });
              });
          } else {
            alert("Favor escolher um arquivo");
          }

        });

        alert('Ação realizada com sucesso');

    }
    $scope.delete = function (item, e) {
      var confirmar = confirm("Deseja excluir o item selecionado?");
      if (confirmar) {
        firebase.database().ref().child(nomeTabela).child(item.codigo).remove();
        angular.element(e.currentTarget).closest("tr").remove();
        if (angular.element("#gridDados tbody tr").length <= 0) {
          $scope.filter_data = 0;
          $scope.entire_user = 0;
          delete $scope.file;
        } else {
          $scope.filter_data = $scope.filter_data - 1;
          $scope.entire_user = $scope.entire_user - 1;
        }
      }
    }
    $scope.reset = function () {
      delete $scope.app;
      banner = {};
      angular.element(".close").trigger("click");
      //$scope.filter_data = $scope.filter_data + 1;
      //$scope.entire_user = $scope.entire_user + 1;
      angular.element(".loading").hide();
      location.reload();
    }
    angular.element(document).ready(function () {
      angular.element(".input-busca").focus();
      setTimeout(function () {
        angular.element(".input-busca").blur();
      }, 500)
    });

  }]).filter('beginning_data', function () {
    return function (input, begin) {
      if (input) {
        begin = +begin;
        return input.slice(begin);
      }
      return [];
    }
  });;

(function () {

    'use strict';

    angular.module('trh')
        .controller('CadastroAreasController', CadastroAreasController)

    CadastroAreasController.$inject = ['FirebaseService', 'Auth', '$timeout', 'AtualizaNotificacao', '$firebaseObject'];

    function CadastroAreasController(objFirebaseService, Auth, $timeout, AtualizaNotificacao, firebaseObject) {
        // View model
        var vm = this;

        /***************************************************
         *** Attributes
         ***************************************************/
        vm.objAreaList = [];
        vm.lstTemas = [];
        vm.objArea = {};
        vm.userId = null;
        vm.auth = Auth;
        vm.nomeTabela = 'areas';
        vm.rootRef = null;
        vm.refArea = null;

        vm.searched = [];
        vm.base = null;
        vm.reverse = null;
        vm.filter_data = 0;
        vm.entire_user = 0;
        vm.current_grid = 1;
        vm.data_limit = 100;
        vm.tipoAtualizacao = null;




        // Carrega as áreas
        vm.loadAreas = loadAreas;
        // Carrega a lista de temas
        vm.loadTemas = loadTemas;
        // Page position
        vm.page_position = page_position;
        // Filter
        vm.filter = filter;
        // Sort with
        vm.sort_with = sort_with;
        // Add uma nova área
        vm.addArea = addArea;
        // Edit uma área
        vm.edit = edit;
        // Atualiza/salva área
        vm.update = update;
        // Deleta uma área
        vm.deleteArea = deleteArea;
        // Toggle para checkbox list de temas
        vm.toggleSelection = toggleSelection;

        // Método para tratar o botão fechar
        vm.botaoFechar = botaoFechar;

        // Método para verificar se o registro é duplicado
        vm.verificaDuplicado = verificaDuplicado;




        /***************************************************
         *** Initialize
         ***************************************************/
        init();

        /**
         * Inicialização
         *
         */
        function init() {
            debugger;
            vm.userId = getUserId();
            setFirebaseRef();
            onAuthStateChanged();
            atualizaNotificacao();
            vm.loadAreas();
            angularReady();

        }

        /***************************************************
         *** Public methods
         ***************************************************/

        /**
         *
         *
         * @param {*} value
         */
        function verificaDuplicado(value) {

            debugger;

            if (!value.nome) {
                alert("Você deve preencher corretamente todos os itens obrigatórios")
                return;
            }

            var verificaArea = firebase.database().ref().child("areas");

            verificaArea.orderByChild('nome').equalTo(value.nome).limitToFirst(1).once('value', function (snapshot) {
                if (snapshot.val()) {
                    if (vm.tipoAtualizacao == 'add') {
                        alert('Já existe um item com os dados informados.');
                        return;
                    } else {
                        if (snapshot.val().nome == value.nome) {
                            alert('Já existe um item com os dados informados.');
                            return;
                        } else {
                            vm.update(value);
                        }
                    }
                } else {

                    vm.update(vm.objArea);
                }
            });


        }



        /**
         * Carrega a lista de áreas
         *
         */
        function loadAreas() {
            vm.objAreaList = [];

            objFirebaseService.getAll(vm.nomeTabela)
                .then(function (objAreaList) {
                    vm.objAreaList = [].concat(objAreaList);

                    angular.forEach(vm.objAreaList, function (objArea) {
                        objArea.temasName = [];
                        angular.forEach(objArea.temas, function (tema) {
                            objFirebaseService.getRecord("temas", tema, function (snp) {
                                if (snp && snp.$value)
                                    objArea.temasName.push(snp.$value);
                            });
                        });
                    });

                    vm.objAreaList = vm.objAreaList.reverse();
                    var count = vm.objAreaList.length;
                    vm.filter_data = count;
                    vm.entire_user = count;

                    vm.loadTemas();
                });
        }

        /**
         * Carrega a lista de temas
         *
         */
        function loadTemas() {
            objFirebaseService.getAll('temas')
                .then(function (objTemaList) {
                    vm.lstTemas = objTemaList;
                });
        }

        /**
         * Page postion
         *
         * @param {number} page_number Número da página
         */
        function page_position(page_number) {
            vm.current_grid = page_number;
        }

        /**
         * Filtro
         *
         */
        function filter() {
            $timeout(function () {
                vm.filter_data = vm.searched.length;
            }, 20);
        }

        /**
         * Sort with
         *
         * @param {number} base
         */
        function sort_with(base) {
            vm.base = base;
            vm.reverse = !vm.reverse;
        };

        /**
         * Add área
         *
         */
        function addArea() {

            vm.tipoAtualizacao = "add";
            delete vm.objArea;
            vm.objArea = {};
        }

        /**
         * Edita área
         *
         * @param {object} value Objeto área
         */
        function edit(value) {
            vm.beforeEdit = value.nome;
            vm.tipoAtualizacao = 'edit';
            delete vm.objArea;



            vm.objArea = angular.copy(value);

        }


        function botaoFechar(value) {

            vm.afterEdit = value.nome;

            if (vm.beforeEdit === vm.afterEdit) {
                $('#modalEdicao').modal('hide')

            } else {

                var confirmar = confirm("Existem itens pendentes de salvamento. Deseja encerrar e perder os dados não salvos?");

                if (confirmar == true) {
                    $('#modalEdicao').modal('hide')

                }


            }

        }


        function update(value) {
            debugger;

            var data = null;

            if (vm.tipoAtualizacao == 'add') {
                data = firebase.database.ServerValue.TIMESTAMP;
            }

            if (!value.nome) {
                alert('Você deve preencher corretamente todos os itens obrigatórios.');
                return false;
            }

            if (value.$id) {
                var key = value.$id
            } else {
                var key = vm.refArea.push().key;
            }

            var conteudo = {
                nome: value.nome,
                temas: value.temas ? value.temas : null,
                timestamp: value.timestamp ? value.timestamp : data
            };

            vm.refArea.child(key).update(conteudo).then(function () {
                alert('Ação realizada com sucesso')
            });
            delete vm.objArea;
            $('#modalEdicao').modal('hide');
            vm.filter_data = vm.filter_data;

            $timeout(function () {
                document.location.reload()
            }, 200);



        }

        /**
         * Deleta uma área
         *
         * @param {object} item Obejto a ser apagado
         * @param {*} e Evento
         */
        function deleteArea(item, e) {
            debugger;

            var confirmar = confirm('Deseja excluir o item selecionado?');
            if (confirmar) {
                vm.refArea.child(item.$id).remove().then(function () {
                    angular.element(e.currentTarget).closest("tr").remove();
                    if (angular.element("#gridDados tbody tr").length <= 0) {
                        vm.filter_data = 0;
                        vm.entire_user = 0;
                        delete vm.objAreaList;
                    } else {
                        $timeout(function () {
                            vm.filter_data = vm.filter_data - 1;
                            vm.entire_user = vm.entire_user - 1;
                        }, 100);
                    }
                });
            }
        }

        /***************************************************
         *** Private methods
         ***************************************************/

        /**
         * Pega o Id do usuário e senão tiver sucesso redireciona para login
         *
         * @returns Id do usuário
         */
        function getUserId() {
            var userId = sessionStorage.getItem('codUsuarioLogado');

            if (!userId) {
                document.location.href = '#/login';
                return;
            } else {
                return userId;
            }
        }

        /**
         * Evento ao mudar o estado da autenticação
         *
         */
        function onAuthStateChanged() {
            // any time auth state changes, add the user data to scope
            vm.auth.$onAuthStateChanged(function (firebaseUser) {
                if (!firebaseUser && vm.userId != undefined) {
                    document.location.href = '#/login';
                }
            });
        }

        /**
         * Atualiza notificações
         *
         */
        function atualizaNotificacao() {
            AtualizaNotificacao.notificacao();
        }

        /**
         * Seta o ref do firebase
         *
         */
        function setFirebaseRef() {
            vm.rootRef = firebase.database().ref();
            vm.refArea = vm.rootRef.child(vm.nomeTabela);
        }

        /**
         * Angular ready
         *
         */
        function angularReady() {
            angular.element(document).ready(function () {
                angular.element('.input-busca').focus();
                $timeout(function () {
                    angular.element('.input-busca').blur();
                }, 500);

            });
        }

        /**
         * Toggle para checkbox list de temas
         *
         * @param {*} value
         * @param {*} obj
         */
        function toggleSelection(value, obj) {
            if (!vm.objArea.temas) {
                vm.objArea.temas = [];
            }
            var index = vm.objArea.temas.indexOf(value);
            if (obj.currentTarget.checked) {
                if (index == -1) {
                    vm.objArea.temas.push(value);
                }
            } else {

                if (index != -1) {
                    vm.objArea.temas.splice(index, 1);
                }
            };
        }
    }

    angular.module('trh')
        .filter('beginning_data', function () {
            return function (input, begin) {
                if (input) {
                    begin = +begin;
                    return input.slice(begin);
                }

                return [];
            }
        });

})();

'use strict';

angular.module('trh')
    .controller('CardController', ['$scope', '$firebaseObject', '$state', '$location', 'FirebaseService', function ($scope, $firebaseObject, $state, $location, FirebaseService) {
        var userId = $location.search().id;

        var rootRef = firebase.database().ref();
        var usuariosConteudos = rootRef.child('usuarios-conteudos');

        $scope.idArea = null;
        $scope.idPerfil = null;
        $scope.lstAllTemas = [];


        $firebaseObject(rootRef.child('usuarios').child(userId)).$loaded(function (snap) {
            $scope.usuario = snap;
            var t = snap.temas;
            $scope.incluirUsuariosConteudos(userId, t);
            rootRef.child('areas').child($scope.usuario.area).on("value", function (snp) {
                if (snp) {
                    $scope.usuario["areaName"] = snp.val().nome;
                }
            });
            rootRef.child('cargos').child($scope.usuario.cargo).on("value", function (snp) {
                if (snp) {
                    $scope.usuario["cargoName"] = snp.val().nome;
                }
            });
        });
        $scope.concluidos = 0;
        $scope.total = 0;


        function initial() {
            return new Promise(function (resolve, reject) {
                var content = [];
                usuariosConteudos.child(userId).on("child_added", function (snapshot) {
                    rootRef.child('conteudos').child(snapshot.key).once("value").then(function (snapConteudo) {
                        if (snapConteudo.val() != null) {
                            $firebaseObject(rootRef.child('temas').child(snapshot.val().temaId)).$loaded().then(function (snap) {
                                if (snap.$value != null) {
                                    $scope.total++;
                                    if (snapshot.val().status === "concluído") {
                                        $scope.concluidos++;
                                    }

                                    content.push({
                                        codigo: snapshot.key,
                                        name: snapConteudo.val().name,
                                        imagem: snapConteudo.val().imagem,
                                        tipo: snapConteudo.val().tipo,
                                        description: snapConteudo.val().description,
                                        tema: snap.$value,
                                        video: snapConteudo.val().video,
                                        audio: snapConteudo.val().audio,
                                        arquivo: snapConteudo.val().arquivo,
                                        status: snapshot.val().status
                                    });

                                    var porcentagem = Math.round((($scope.concluidos * 100) / $scope.total)) + "%";
                                    $scope.porcentagem = porcentagem.split("%")[0];
                                    resolve($scope.porcentagem);
                                    $scope.file = content;
                                } else {
                                    firebase.database().ref().child("usuarios-conteudos").child(userId).child(snapshot.key).remove();
                                }
                            }); //temas
                        } else {
                            firebase.database().ref().child("usuarios-conteudos").child(userId).child(snapshot.key).remove();
                        }
                    }); //conteudos
                }); //usuarios-temas
            });
        }




        $scope.grafico = function () {
            c3.generate({
                bindto: '#grafico',
                data: {
                    columns: [
                        ['concluídos', $scope.porcentagem]
                    ],
                    type: 'gauge'
                },
                gauge: {
                    label: {
                        format: function (value, ratio) {
                            return value + "%";
                        },
                        show: true,
                    },
                    min: 0,
                    max: 100,
                    width: 39,
                    units: "concluídos"
                },
                color: {
                    pattern: ['#FF0000', '#F97600', '#F6C600', '#60B044'],
                    threshold: {
                        //unit: 'value', // percentage is default
                        //max: 200, // 100 is default
                        values: [30, 60, 90, 100]
                    }
                }
            });
        }

        $scope.init = function () {
            $scope.grafico();
        }

        $scope.incluirUsuariosConteudos = function (key, temas) {

            var promises = [];
            promises.push(rootRef.child('areas').child($scope.usuario.area).once("value"));
            promises.push(rootRef.child('cargos').child($scope.usuario.cargo).once("value"));

            Promise.all(promises)
                .then(function (objResponseList) {
                    if (objResponseList[0]) {
                        $scope.idArea = objResponseList[0].val();
                    }
                    if (objResponseList[1]) {
                        $scope.idPerfil = objResponseList[1].val();
                    }
                    $scope.lstAllTemas = [];
                    if (!$scope.idArea) {
                        $scope.idArea["temas"] = [];
                    }
                    if (!$scope.idPerfil) {
                        $scope.idPerfil["temas"] = [];
                    }

                    //$scope.lstAllTemas.concat($scope.idArea.temas).concat($scope.idPerfil.temas);
                    if (temas) {
                        temas = temas.concat($scope.idArea.temas ? $scope.idArea.temas : null).concat($scope.idPerfil.temas ? $scope.idPerfil.temas : null);
                    } else {
                        temas = [];
                        temas = temas.concat($scope.idArea.temas ? $scope.idArea.temas : null).concat($scope.idPerfil.temas ? $scope.idPerfil.temas : null);
                    }

                    $scope.usuario["temas"] = temas.filter(function (v, i, a) {
                        return a.indexOf(v) === i
                    });

                    var contentUsu = {
                        name: $scope.usuario.name,
                        email: $scope.usuario.email,
                        login: $scope.usuario.login.toLowerCase(),
                        password: $scope.usuario.password,
                        area: $scope.usuario.area ? $scope.usuario.area : '',
                        cargo: $scope.usuario.cargo ? $scope.usuario.cargo : '',
                        empresa: $scope.usuario.empresa ? $scope.usuario.empresa : '',
                        admin: $scope.usuario.admin,
                        foto: $scope.usuario.foto,
                        temas: $scope.usuario["temas"]
                    }
                    firebase.database().ref().child("usuarios").child(userId).update(contentUsu)
                    if (temas.length > 0) {
                        var count = 0;
                        firebase.database().ref().child("conteudos").on("child_added", function (snap) {
                            count++;

                            firebase.database().ref().child("usuarios-conteudos").child(key).child(snap.key).once("value", function (snp) {

                                if (snp.val() != null) {

                                    if (temas.indexOf(snp.val().temaId) == -1) {
                                        firebase.database().ref().child("usuarios-conteudos").child(key).child(snap.key).remove();
                                    } else {
                                        var content = {}
                                        //for (var i = 0; i < temas.length; i++) {
                                        if (snap.val().temas == snp.val().temaId) {
                                            content[snap.key] = {
                                                status: snp.val().status,
                                                temaId: snap.val().temas,
                                                comentario: snp.val().comentario != undefined ? snp.val().comentario : null,
                                                curtiuConteudo: snp.val().curtiuConteudo != undefined ? snp.val().curtiuConteudo : null
                                            }
                                            firebase.database().ref().child("usuarios-conteudos").child(key).update(content).then(function () {});;
                                        }
                                        //}
                                    }
                                } else {
                                    console.log("else");
                                    var content = {}
                                    if (temas.indexOf(snap.val().temas) != -1) {
                                        //for (var i = 0; i < temas.length; i++) {
                                        content[snap.key] = {
                                            status: "novo",
                                            temaId: snap.val().temas
                                        }
                                        firebase.database().ref().child("usuarios-conteudos").child(key).update(content).then(function () {});
                                        //}
                                    }
                                }

                            }).then(function () {
                                count--;
                                if (count <= 0) {
                                    var inicial = initial();
                                    inicial.then(function (result) {
                                        $scope.grafico();
                                    });
                                }
                            })
                        });
                    }
                });


        }

    }]);

angular.element(document).ready(function ($timeout) {

    angular.element("#side-menu li a").click(function () {
        angular.element("#side-menu li").removeClass("active");
        angular.element(this).closest("li").addClass("active");
    })

    // Full height of sidebar
    function fix_height() {
        var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
        angular.element(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

        var navbarHeigh = angular.element('nav.navbar-default').height();
        var wrapperHeigh = angular.element('#page-wrapper').height();

        if (navbarHeigh > wrapperHeigh) {
            angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
        }

        if (navbarHeigh < wrapperHeigh) {
            angular.element('#page-wrapper').css("min-height", angular.element(window).height() + "px");
        }

        if (angular.element('body').hasClass('fixed-nav')) {
            if (navbarHeigh > wrapperHeigh) {
                angular.element('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
            } else {
                angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
            }
        }

    }

    angular.element(window).bind("load resize", function () {
        if (!angular.element("body").hasClass('body-small')) {
            //fix_height();
        }
        angular.element("#side-menu").slimScroll({
            height: angular.element("body").innerHeight() - angular.element(".nav-header").innerHeight() - 60 + "px"
        });
    });

    // // Move right sidebar top after scroll
    // angular.element(window).scroll(function () {
    //     if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav')) {
    //         angular.element('#right-sidebar').addClass('sidebar-top');
    //     } else {
    //         angular.element('#right-sidebar').removeClass('sidebar-top');
    //     }
    // });

    $timeout(function () {
        //fix_height();
    }, 2000);

    // Minimalize menu when screen is less than 768px
    angular.element(window).bind("load resize", function () {
        if (angular.element(document).width() < 769) {
            angular.element('body').addClass('body-small')
        } else {
            angular.element('body').removeClass('body-small')
        }
    });



});

function handleChange(evt) {
    var f = document.querySelector('#imagemLogomarca').files[0]; // FileList object
    var reader = new FileReader();
    // Closure to capture the file information.
    reader.onload = (function (theFile) {
        return function (e) {
            var binaryData = e.target.result;
            //Converting Binary Data to base 64
            var base64String = window.btoa(binaryData);
            //showing file converted to base64
            document.getElementById('imagemPreview').src = "data:image/jpg;base64," + base64String;
        };
    })(f);
    // Read in the image file as a data URL.
    reader.readAsBinaryString(f);
};

(function() {
  'use strict';

  angular
    .module('trh')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function () {
    'use strict';

    angular
        .module('trh')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider, $ocLazyLoadProvider) {
        $ocLazyLoadProvider.config({
            // Set to true if you want to see what and when is dynamically loaded
            debug: false
        });
        $stateProvider

            .state('index', {
                abstract: true,
                url: "/index",
                templateUrl: "app/components/common/content.html"
            })
            // .state('card', {
            //   abstract: true,
            //   url: "/card",
            //   templateUrl: "app/components/common/cardContent.html"
            // })
            .state('cardUsuario', {
                url: "/cardUsuario",
                templateUrl: "app/card/card.html",
                data: {
                    pageTitle: 'Card Usuário'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([{
                                serie: true,
                                files: ['../../bower_components/c3/c3.min.css', '../../bower_components/d3/d3.min.js', '../../bower_components/c3/c3.min.js', '../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']
                            },
                            {
                                serie: true,
                                name: 'gridshore.c3js.chart',
                                files: ['../../bower_components/c3-angular/c3-angular.min.js']
                            }
                        ])
                    }]
                }
            })
            .state('cardRelatorio', {
                url: "/cardRelatorio",
                templateUrl: "app/cardRelatorioFeedback/card.html",
                data: {
                    pageTitle: 'Card Relatório'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([{
                                serie: true,
                                files: ['../../bower_components/c3/c3.min.css', '../../bower_components/d3/d3.min.js', '../../bower_components/c3/c3.min.js', '../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']
                            }
                        ])
                    }]
                }
            })
            .state('cardListaInsight', {
                url: "/cardListaInsight",
                templateUrl: "app/cardListaInsight/card.html",
                data: {
                    pageTitle: 'Card Relatório'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([{
                                serie: true,
                                files: ['../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']
                            }
                        ])
                    }]
                }
            })
            .state('login', {
                url: "/login",
                templateUrl: "app/login/login.html",
                data: {
                    pageTitle: 'Login',
                    specialClass: 'gray'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']);
                    }]
                }
            })
            .state('esqueceuSenha', {
                url: "/esqueceuSenha",
                templateUrl: "app/esqueceuSenha/esqueceuSenha.html",
                data: {
                    pageTitle: 'Esqueceu Senha',
                    specialClass: 'gray'
                }
            })
            .state('index.main', {
                url: "/main",
                templateUrl: "app/main/main.html",
                data: {
                    pageTitle: 'Página Principal'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([{
                                serie: true,
                                files: ['../../bower_components/c3/c3.min.css', '../../bower_components/d3/d3.min.js', '../../bower_components/c3/c3.min.js', '../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']
                            },
                            {
                                serie: true,
                                name: 'gridshore.c3js.chart',
                                files: ['../../bower_components/c3-angular/c3-angular.min.js']
                            }
                        ])
                    }]
                }
            })
            .state('index.temas', {
                url: "/temas",
                templateUrl: "app/temas/temas.html",
                data: {
                    pageTitle: 'Temas'
                }
            })
            .state('index.conteudos', {
                url: "/conteudos",
                templateUrl: "app/conteudos/conteudos.html",
                data: {
                    pageTitle: 'Conteúdos'
                }
            })
            .state('index.configurarAplicativo', {
                url: "/configurarAplicativo",
                templateUrl: "app/configurarAplicativo/configurarAplicativo.html",
                data: {
                    pageTitle: 'Configurar Aplicativo'
                }
                // ,
                // resolve: {
                //     loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                //         return $ocLazyLoad.load([{
                //                 files: ['../../bower_components/qrcode/lib/qrcode.min.js', '../../bower_components/angular-qr/angular-qr.min.js']
                //             }
                //         ])
                //     }]
                // }
            })
            .state('index.detalhes', {
                url: "/detalhes",
                templateUrl: "app/detalhes/detalhes.html",
                data: {
                    pageTitle: 'Detalhes'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['../../bower_components/switchery/dist/switchery.css', '../../bower_components/switchery/dist/switchery.js', '../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']);
                    }]
                }
            })
            .state('index.detalhesAudio', {
                url: "/detalhesAudio",
                templateUrl: "app/detalhesAudio/detalhesAudio.html",
                data: {
                    pageTitle: 'Áudio'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['../../bower_components/switchery/dist/switchery.css', '../../bower_components/switchery/dist/switchery.js', '../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']);
                    }]
                }
            })
            .state('index.detalhesArquivo', {
                url: "/detalhesArquivo",
                templateUrl: "app/detalhesArquivo/detalhesArquivo.html",
                data: {
                    pageTitle: 'Arquivo'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js', '../../bower_components/angular-pdf/pdf.js', '../../bower_components/angular-pdf/angular-pdf.min.js', '../../bower_components/angular-pdf/pdf.worker.js']);
                    }]
                }
            })
            ///Rotas área administraiva
            .state('index.cadastroBanners', {
                url: "/cadastroBanners",
                templateUrl: "app/cadastros/cadastroBanners.html",
                data: {
                    pageTitle: 'Cadastro Banners'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']);
                    }]
                }
            })
            .state('index.cadastroTemas', {
                url: "/cadastroTemas",
                templateUrl: "app/cadastros/cadastroTemas.html",
                data: {
                    pageTitle: 'Cadastro Temas'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']);
                    }]
                }
            })
            .state('index.cadastroEmpresas', {
                url: "/cadastroEmpresas",
                templateUrl: "app/cadastros/cadastroEmpresas.html",
                data: {
                    pageTitle: 'Cadastro Empresas'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']);
                    }]
                }
            })
            .state('index.cadastroAreas', {
                url: "/cadastroAreas",
                templateUrl: "app/cadastros/cadastroAreas.html",
                data: {
                    pageTitle: 'Cadastro Áreas'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']);
                    }]
                }
            })
            .state('index.cadastroCargos', {
                url: "/cadastroCargos",
                templateUrl: "app/cadastros/cadastroCargos.html",
                data: {
                    pageTitle: 'Cadastro Cargos'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']);
                    }]
                }
            })
            .state('index.cadastroConteudos', {
                url: "/cadastroConteudos",
                templateUrl: "app/cadastros/cadastroConteudos.html",
                data: {
                    pageTitle: 'Cadastro Conteúdos'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']);
                    }]
                }
            })
            .state('index.insightsConteudo', {
                url: "/insightsConteudo",
                templateUrl: "app/cadastros/insightsConteudo.html",
                data: {
                    pageTitle: 'Insights de Conteúdo'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']);
                    }]
                }
            })
            .state('index.cadastroUsuarios', {
                url: "/cadastroUsuarios",
                templateUrl: "app/cadastros/cadastroUsuarios.html",
                data: {
                    pageTitle: 'Cadastro Usuários'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']);
                    }]
                }
            })
            .state('index.enviarNotificacoes', {
                url: "/enviarNotificacoes",
                templateUrl: "app/cadastros/enviarNotificacoes.html",
                data: {
                    pageTitle: 'Enviar Notificações'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']);
                    }]
                }
            })
            /* Teste de inclusão de parâmetros */
            .state('index.parametros', {
                url: "/parametros",
                templateUrl: "app/cadastros/parametros.html",
                data: {
                    pageTitle: 'Parâmetros'
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['../../bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js']);
                    }]
                }
            });



        $urlRouterProvider.otherwise('/login');
    }

})();

'use strict';

//metisMenu and minimalize button
angular.module('trh')
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary hidden-sm hidden-md hidden-lg" href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        angular.element('#side-menu').hide();
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                            angular.element('#side-menu .nav-header').removeAttr('style');
                        }, 200);
                    } else {
                        angular.element('#side-menu').removeAttr('style');
                        angular.element('#side-menu .nav-header').animate({
                            height: "0"
                        }, 400, function () {
                            angular.element('#side-menu .nav-header').fadeOut(400);
                        })
                    }
                };
            }
        };
    }).directive('likedislike', function () {
        return {
            restrict: 'E',
            template: '<div class="ico-thumbs"><i class="fa fa-thumbs-up" ng-click="toggleLikeState(event)"></i><i class="fa fa-thumbs-down" ng-click="toggleLikeState(event)"></i></div>',
            scope: {
                conteudoid: '='
            },
            controller: function ($scope) {
                $scope.toggleLikeState = function (e) {
                    var value = $(event.target).hasClass("fa-thumbs-up") ? "liked" : "unliked";

                    $scope.userId = sessionStorage.getItem("codUsuarioLogado");

                    firebase.database().ref().child("usuarios-conteudos").child($scope.userId).child($scope.conteudoid).once('value', function (snap) {

                        //Primeiro acesso
                        if (snap.val().curtiuConteudo == undefined) {


                            if (value == 'unliked') {


                                value = 'naoCurtiu';
                                angular.element(".ico-thumbs").find(".fa-thumbs-down").addClass("ativo");
                                angular.element(".ico-thumbs").find(".fa-thumbs-up").removeClass("ativo");
                                $scope.updateConteudo(false);


                            } else {

                                value = 'curtiu';
                                angular.element(".ico-thumbs").find(".fa-thumbs-down").removeClass("ativo");
                                angular.element(".ico-thumbs").find(".fa-thumbs-up").addClass("ativo");
                                $scope.updateConteudo(true);

                            }

                        }

                        // Demais acessos
                        else if (value == 'unliked') {
                            //Se botão "dislike" ativo não executa.
                            if (!angular.element(".ico-thumbs").find(".fa-thumbs-down").hasClass("ativo")) {
                                value = 'naoCurtiu';
                                angular.element(".ico-thumbs").find(".fa-thumbs-down").addClass("ativo");
                                angular.element(".ico-thumbs").find(".fa-thumbs-up").removeClass("ativo");
                                $scope.updateConteudoNeg(false);
                            }
                        } else {
                            //Se botão "like" ativo não executa.
                            if (!angular.element(".ico-thumbs").find(".fa-thumbs-up").hasClass("ativo")) {
                                value = 'curtiu';
                                angular.element(".ico-thumbs").find(".fa-thumbs-down").removeClass("ativo");
                                angular.element(".ico-thumbs").find(".fa-thumbs-up").addClass("ativo");
                                $scope.updateConteudoNeg(true);
                            }

                        }

                        if (value == 'liked') {
                            value = 'curtiu';
                        }

                        var post = {};
                        post['curtiuConteudo'] = (value === 'curtiu');
                        $scope.update(post);


                    });

                }

                $scope.update = function (post) {
                    firebase.database().ref().child("usuarios-conteudos").child($scope.userId).child($scope.conteudoid).update(post);
                }

                $scope.updateConteudo = function (blnLiked) {
                    firebase.database().ref().child('conteudos').child($scope.conteudoid).once('value', function (snap) {
                        var postConteudo = {};

                        if (blnLiked) {
                            postConteudo['like'] = (snap.val().like) ? ++snap.val().like : 1
                        } else {
                            postConteudo['dislike'] = (snap.val().dislike) ? ++snap.val().dislike : 1
                        }

                        firebase.database().ref().child('conteudos').child(snap.key).update(postConteudo)

                    });


                }


                $scope.updateConteudoNeg = function (blnLiked) {

                    firebase.database().ref().child('conteudos').child($scope.conteudoid).once('value', function (snap) {
                        var postConteudo = {};

                        if (blnLiked) {
                            postConteudo['like'] = (snap.val().like) ? ++snap.val().like : 1
                            postConteudo['dislike'] = (snap.val().dislike) ? --snap.val().dislike : 1
                        } else {
                            postConteudo['dislike'] = (snap.val().dislike) ? ++snap.val().dislike : 1
                            postConteudo['like'] = (snap.val().like) ? --snap.val().like : 1

                        }

                        firebase.database().ref().child('conteudos').child(snap.key).update(postConteudo)

                    });


                }
            },
            link: function postlink(scope, element) {

                scope.userId = sessionStorage.getItem("codUsuarioLogado");

                firebase.database().ref().child("usuarios-conteudos").child(scope.userId).child(scope.conteudoid).once('value', function (snap) {


                    //Deixa os dois botões destivados
                    element.find(".fa").removeClass("ativo");

                    if (snap.val().curtiuConteudo != undefined) {
                        if (snap.val().curtiuConteudo) {
                            element.find(".fa-thumbs-up").addClass("ativo");
                        } else if (!snap.val().curtiuConteudo) {
                            element.find(".fa-thumbs-down").addClass("ativo");
                        }
                    }

                });
            }
        }
    }).directive('comentario', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/components/common/comentarios.html',
            scope: {
                conteudoid: '='
            },
            controller: function ($scope) {
                $scope.userId = sessionStorage.getItem("codUsuarioLogado");

                $scope.apagar = function (form) {
                    if (form == "") {
                        alert("Sem comentário para apagar");
                        return;
                    }
                    $scope.update(null, function () {
                        form = "";
                        $scope.comentario = form;
                        $('#chars').text("180");
                        $scope.$apply(function () {
                            $scope.comentario = form;
                        });
                    });
                }

                $scope.update = function (form, callback) {

                    if (form == "") {
                        alert("Você deve preencher corretamente todos os itens obrigatórios")
                        return;
                    }

                    var post = {};
                    post['comentario'] = form;
                    firebase.database().ref().child("usuarios-conteudos").child($scope.userId).child($scope.conteudoid).update(post, function () {
                        $('#modalComentario').modal("hide");
                        if (typeof callback == "function") {
                            callback();
                        }
                    });
                }

            },
            link: function postlink(scope, element) {

                $('#modalComentario').on('hidden.bs.modal', function (e) {
                    if (scope.comentario == "") {
                        $(".ico-comment").find(".fa-comment").removeClass("ativo");
                    } else {
                        $(".ico-comment").find(".fa-comment").addClass("ativo");
                    }
                });

                $('#modalComentario').on('show.bs.modal', function (e) {
                    var maxLength = 180;
                    $('textarea').on("keyup", function () {
                        var length = $(this).val().length;
                        var length = maxLength - length;
                        $('#chars').text(length);
                    });

                    var length = $('textarea').val().length;
                    var length = maxLength - length;
                    $('#chars').text(length);

                });



                scope.userId = sessionStorage.getItem("codUsuarioLogado");

                firebase.database().ref().child("usuarios-conteudos").child(scope.userId).child(scope.conteudoid).once('value', function (snap) {
                    firebase.database().ref().child("conteudos").child(scope.conteudoid).once("value", function (snapshot) {
                        scope.nomeConteudo = snapshot.val().name;
                    })


                    //Deixa o botão destivados
                    element.find(".fa-comment").removeClass("ativo");


                    if (snap.val().comentario) {
                        scope.comentario = snap.val().comentario;
                        element.find("#comentario").val(snap.val().comentario);
                        element.find(".fa-comment").addClass("ativo");
                    } else {
                        scope.comentario = "";
                        element.find(".fa-comment").removeClass("ativo");
                    }


                });
            }
        }
    });

(function () {

    'use strict';

    // Service de funções úteis
    angular.module('trh').service('utilsService', utilsService);

    utilsService.$inject = [];

    /**
     * Serviços de funções úteis
     *
     */
    function utilsService() {
        var objService = this;

        /***************************************************
         *** Attributes
         ***************************************************/

        // Constante para validar email
        var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        // Validar emails
        objService.validateEmail = validateEmail;

        /***************************************************
         *** Public Methods
         ***************************************************/

        /**
         * Validar um email
         *
         * @param {*} strEmail Email
         * @returns Verdadeiro se a string for um email válido
         */
        function validateEmail(strEmail) {
            return EMAIL_REGEX.test(strEmail);
        }
    }
})();

(function () {

    'use strict';

    // Service de importação de usuários
    angular.module('trh').service('ImportarUsuariosService', ImportarUsuariosService);

    ImportarUsuariosService.$inject = [];

    function ImportarUsuariosService() {
        var self = this;

        /***************************************************
        *** Attributes
        ***************************************************/

        /***************************************************
        *** Public Methods
        ***************************************************/

    }

})();

(function () {

    'use strict';

    angular.module('trh')
        .service('FirebaseService', FirebaseService);

        FirebaseService.$inject = ['$firebaseArray', '$firebaseObject'];

    /**
     * Serviço Firebase
     *
     * @param {object} $firebaseArray Objeto firebase array
     * @param {object} $firebaseObject Objeto firebase object
     */
    function FirebaseService($firebaseArray, $firebaseObject) {
        var self = this;
        var objDatabase = firebase.database();

        /***************************************************
        *** Attributes
        ***************************************************/
        self.objFirebase = {};
        self.getRef = getRef;
        self.load = load;
        self.getAll = getAll;
        self.getRecord = getRecord;
        self.add = add;
        self.addWithUid = addWithUid;
        self.removeByData = removeByData;
        self.removeByIndex = removeByIndex;
        self.update = update;
        self.generateId = generateId;

        /***************************************************
        *** Public methods
        ***************************************************/

        /**
         * Obtém o ref do firebase
         *
         * @param {string} strCollection Nome da collection
         * @returns Ref firebase
         */
        function getRef(strCollection) {
            if (strCollection) {
                if (self.objFirebase[strCollection]) {
                    return self.objFirebase[strCollection];
                } else {
                    self.objFirebase[strCollection] = $firebaseArray(objDatabase.ref(strCollection).orderByChild("timestamp"));
                    return self.objFirebase[strCollection];
                }
            } else {
                return $firebaseArray(objDatabase.ref().orderByChild("timestamp"));
            }
        }

        /**
         * Carrega a lista da collection
         *
         * @param {string} strCollection Nome da collection
         * @returns Promise
         */
        function load(strCollection) {
            var ref = self.getRef(strCollection);
            return ref.$loaded();
        }

        /**
         * Obtém a collection inteira
         *
         * @param {string} strCollection Nome da collection
         * @returns Promise
         */
        function getAll(strCollection) {
            return self.load(strCollection);
        }

        /**
         * Recupera um registro na collection
         *
         * @param {string} strCollection Nome da collection
         * @param {string} key Chave da collection
         * @param {function} callback Função de retorno
         */
        function getRecord(strCollection, key, callback) {
            var ref = self.getRef(strCollection);
            ref.$loaded()
                .then(function () {
                    if (angular.isFunction(callback)) {
                        callback(ref.$getRecord(key));
                    }
                })
        }

        /**
         * Adiciona um novo nó na collection
         *
         * @param {string} strCollection Nome da collection
         * @param {object} newData Objeto a ser incluído
         * @returns Promise
         */
        function add(strCollection, newData) {
            var ref = self.getRef(strCollection);
            return ref.$add(newData);
        }

        /**
         * Adiciona um novo nó na collection
         *
         * @param {string} strCollection Nome da collection
         * @param {object} newData Objeto a ser incluído
         * @param {string} uid Id
         * @returns Promise
         */
        function addWithUid(strCollection, newData, uid) {
            var ref = firebase.database().ref();
            return ref.child(strCollection).child(uid)
                .update(newData);
        }

        /**
         * Remove um registro pelo próprio registro
         *
         * @param {string} strCollection Nome da collection
         * @param {object} data Objeto da colection que deseja remover
         * @returns Promise
         */
        function removeByData(strCollection, data) {
            var ref = self.getRef(strCollection);
            return ref.$remove(data);
        }

        /**
         * Remove um registro pelo próprio registro
         *
         * @param {string} strCollection Nome da collection
         * @param {number} index Index onde está o objeto da colection que deseja remover
         * @returns Promise
         */
        function removeByIndex(strCollection, index) {
            var ref = self.getRef(strCollection);
            var item = ref[index];
            return ref.$remove(item);
        }

        /**
         * Atualiza um registro pelo próprio registro
         *
         * @param {string} strCollection Nome da collection
         * @param {object} data Objeto da colection que deseja atualizar
         * @returns Promise
         */
        function update(strCollection, data) {
            var ref = self.getRef(strCollection);
            return ref.$save(data);
        }

        /**
         * Gera id pelo ref Firebase
         *
         * @param {object} strCollection Nome da collection
         * @returns
         */
        function generateId(strCollection) {
            var rootRef = firebase.database().ref();
            var ref = rootRef.child(strCollection);
            return ref.push().key;
        }

        /***************************************************
        *** Private methods
        ***************************************************/
    }

})();

(function () {

    'use strict';

    // Service de notificação
    angular.module('trh').service('AtualizaNotificacao', AtualizaNotificacao);

    AtualizaNotificacao.$inject = ['$rootScope', '$firebaseObject', '$firebaseArray'];

    /**
     * Service de notificação
     *
     * @param {object} $rootScope Escopo angular principal
     * @param {object} $firebaseObject Objeto firebase
     * @param {object} $firebaseArray Objeto firebase array
     */
    function AtualizaNotificacao($rootScope, $firebaseObject, $firebaseArray) {

        this.notificacao = notificacao;

        function notificacao() {
            if (sessionStorage.getItem("codUsuarioLogado") != undefined) {
                var rootRef = firebase.database().ref();
                var list = [];
                var usuariosConteudos = rootRef.child('usuarios-conteudos');
                var total = 0;
                usuariosConteudos.child(sessionStorage.getItem("codUsuarioLogado")).on("child_added", function (snapshot) {
                    //conteudos.child(snapshot.key).once("value").then(function (snapConteudo) {
                    //if(snapConteudo.val() != null) {
                    $firebaseObject(rootRef.child('temas').child(snapshot.val().temaId)).$loaded().then(function (snap) {
                        if (snap.$value != null) {
                            if (snapshot.val().status === "novo") {
                                total++;
                                $rootScope.novos = total;

                                if (snapshot.val().temaId == snap.$id) {
                                    list.push({
                                        nome: snap.$value,
                                        id: snap.$id
                                    });
                                    $rootScope.arrayConteudo = list;
                                }
                            }
                        }
                    }); //temas
                    //}
                    //});//conteudos
                }); //usuarios-conteudos

                // $firebaseArray(usuariosConteudos.child(sessionStorage.getItem("codUsuarioLogado"))).$loaded().then(function (snapshot) {
                //   var conta = 0;
                //   snapshot.forEach(function (item, ix) {
                //     //$firebaseObject(temas.child(item.temaId)).$loaded().then(function (snap) {
                //       if (item.status === "novo") {
                //         conta++;
                //         console.log(item.temaId);
                //         var tema = $firebaseObject(temas.child(item.temaId));
                //         console.log(tema);
                //         tema.$loaded().then(function (itemTema) {
                //           if (itemTema.$id == item.temaId) {
                //             list.push({
                //               nome: itemTema.$value,
                //               id: itemTema.$id
                //             });
                //           }
                //           $rootScope.arrayConteudo = list;
                //         });
                //         $rootScope.novos = conta;
                //       } else {
                //         $rootScope.novos = conta;
                //       }
                //     //});
                //   });

                // });
                usuariosConteudos.child(sessionStorage.getItem("codUsuarioLogado")).on("child_changed", function (snapshot) {
                    notificacao();
                });
            }
        }
    }



})();

(function () {

    'user strict';

    // Factory de autenticação
    angular.module('trh').factory('Auth', Auth);

    Auth.$inject = ['$firebaseAuth'];

    /**
     * Factory para autenticação
     *
     * @param {object} $firebaseAuth Autenticação do firebase
     * @returns
     */
    function Auth ($firebaseAuth) {
        return $firebaseAuth();
    }

})();

angular.module("trh").run(["$templateCache", function($templateCache) {$templateCache.put("app/cadastros/cadastroAreas.html","<div ng-controller=\"CadastroAreasController as vm\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Administração - Áreas</h2></div><div class=\"wrapper wrapper-content animated fadeInUp clearfix\"><div class=\"ibox\"><div class=\"ibox-content\"><div><div class=\"\"><div class=\"col-md-12\"><div class=\"row\"><a ng-click=\"vm.addArea()\" class=\"btn btn-small btn-primary pull-right\" data-toggle=\"modal\" data-target=\"#modalEdicao\">Adicionar Áreas</a></div></div><div class=\"row\"><div class=\"col-sm-6 pull-right\"><label>Busca:</label> <input type=\"text\" ng-model=\"search\" ng-change=\"vm.filter()\" placeholder=\"busca\" class=\"form-control input-busca\"></div></div><br><div class=\"row\"><div class=\"col-md-12\" ng-show=\"vm.filter_data > 0\"><table id=\"gridDados\" class=\"table table-striped table-bordered\"><thead><th>Nome&nbsp; <a ng-click=\"vm.sort_with(\'nome\');\"><i class=\"fa fa-sort\"></i></a></th><th>Temas&nbsp;</th><th class=\"width-10\">Editar</th><th class=\"width-10\">Apagar</th></thead><tbody><tr ng-repeat=\"data in vm.searched = (vm.objAreaList | filter:search | orderBy : vm.base :vm.reverse) | beginning_data:(vm.current_grid-1)*vm.data_limit | limitTo:vm.data_limit\"><td>{{data.nome}}</td><td><span ng-repeat=\"temaName in data.temasName\">&bull; {{temaName}}&nbsp;&nbsp;</span></td><td class=\"hidden\">{{data.codigo}}</td><td><a ng-click=\"vm.edit(data)\" class=\"btn btn-small btn-primary\" data-toggle=\"modal\" data-target=\"#modalEdicao\">Editar</a></td><td><a ng-click=\"vm.deleteArea(data, $event)\" class=\"btn btn-small btn-danger\">Apagar</a></td></tr></tbody></table></div><div class=\"col-md-12\" ng-show=\"vm.filter_data == 0\"><div class=\"col-md-12\"><h4>Nenhum item foi localizado</h4></div></div><div class=\"col-md-12\"><div class=\"col-md-6 pull-left\" ng-show=\"vm.filter_data > 0\"><h5>{{ vm.filter_data }} de {{ vm.entire_user}} registros</h5></div><div class=\"col-md-6\" ng-show=\"vm.filter_data > 0\"><div uib-pagination=\"\" ng-model=\"vm.current_grid\" ng-change=\"vm.page_position(page)\" total-items=\"vm.filter_data\" items-per-page=\"vm.data_limit\" class=\"pagination-small pull-right\" previous-text=\"&laquo;\" next-text=\"&raquo;\"></div></div></div></div></div></div></div></div></div><div class=\"modal fade\" id=\"modalEdicao\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalEdicao\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><form name=\"formCadastro\" ng-model=\"formCadastro\" novalidate=\"\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.botaoFechar(vm.objArea)\" aria-label=\"Fechar\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" ng-if=\"vm.tipoAtualizacao === \'edit\'\">Editar Área</h4><h4 class=\"modal-title\" ng-if=\"vm.tipoAtualizacao !== \'edit\'\">Adicionar Área</h4></div><div class=\"modal-body\"><label>* Nome</label><div class=\"form-group\"><input type=\"text\" class=\"form-control\" name=\"campoCodigo\" ng-model=\"vm.objArea.nome\" required=\"\" placeholder=\"Nome\" maxlength=\"50\"></div><label>Temas</label><div class=\"form-group\"><div class=\"form-check-list\"><label ng-model=\"vm.objArea.temas\" ng-repeat=\"objTema in vm.lstTemas\"><input type=\"checkbox\" value=\"{{objTema.$id}}\" ng-checked=\"vm.objArea.temas.indexOf(objTema.$id) > -1\" ng-click=\"vm.toggleSelection(objTema.$id, $event)\"> {{objTema.$value}}</label></div></div><div class=\"form-group\"><input type=\"hidden\" ng-model=\"vm.objArea.codigo\"></div></div><div class=\"modal-footer\"><button ng-click=\"vm.botaoFechar(vm.objArea)\" type=\"button\" class=\"btn btn-default\">Fechar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.verificaDuplicado(vm.objArea)\">Salvar</button></div></form></div></div></div></div>");
$templateCache.put("app/cadastros/cadastroBanners.html","<div ng-controller=\"CadastroBanners as controller\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Administração - Banners</h2></div><div class=\"wrapper wrapper-content animated fadeInUp clearfix\"><div class=\"ibox\"><div class=\"ibox-content\"><div><div class=\"\"><div class=\"col-md-12\"><div class=\"row\"><a ng-click=\"abreForm()\" class=\"btn btn-small btn-primary pull-right\" data-toggle=\"modal\" data-target=\"#modalEdicao\">Adicionar Banners</a></div></div><div class=\"row\"><div class=\"col-sm-6 pull-right hidden\"><label>Busca:</label> <input type=\"text\" ng-model=\"search\" ng-change=\"filter()\" placeholder=\"busca\" class=\"form-control input-busca\"></div></div><br><div class=\"row\"><div class=\"col-md-12\" ng-show=\"filter_data > 0\"><table id=\"gridDados\" class=\"table table-striped table-bordered\"><thead><th>Arquivo&nbsp;</th><th class=\"width-10\">Apagar</th></thead><tbody><tr ng-repeat=\"data in searched = (file | filter:search | orderBy : base :reverse) | beginning_data:(current_grid-1)*data_limit | limitTo:data_limit\"><td><a href=\"{{data.arquivo}}\" target=\"blank\"><img style=\"width: 200px;\" src=\"{{data.arquivo}}\"></a> <input type=\"hidden\" value=\"{{data.arquivo}}\"></td><td><a ng-click=\"delete(data, $event)\" class=\"btn btn-small btn-danger\">Apagar</a></td></tr></tbody></table></div><div class=\"col-md-12\" ng-show=\"filter_data == 0\"><div class=\"col-md-12\"><h4>Nenhum item foi localizado</h4></div></div><div class=\"col-md-12\"><div class=\"col-md-6 pull-left\" ng-show=\"filter_data > 0\"><h5>{{ filter_data }} de {{ entire_user}} registros</h5></div><div class=\"col-md-6\" ng-show=\"filter_data > 0\"><div uib-pagination=\"\" ng-model=\"current_grid\" ng-change=\"page_position(page)\" total-items=\"filter_data\" items-per-page=\"data_limit\" class=\"pagination-small pull-right\" previous-text=\"&laquo;\" next-text=\"&raquo;\"></div></div></div></div></div></div></div></div></div><div class=\"modal fade\" id=\"modalEdicao\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalEdicao\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Fechar\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Adicionar Banners</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Imagem (375x250px)</label> <input id=\"imagemConteudo\" name=\"imagemConteudo\" type=\"file\" class=\"form-control form-control-file\" accept=\"image/*\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Fechar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"update(app)\">Salvar</button></div></div></div></div></div></div>");
$templateCache.put("app/cadastros/cadastroCargos.html","<div ng-controller=\"CadastroPerfisController as vm\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Administração - Perfis</h2></div><div class=\"wrapper wrapper-content animated fadeInUp clearfix\"><div class=\"ibox\"><div class=\"ibox-content\"><div><div class=\"\"><div class=\"col-md-12\"><div class=\"row\"><a ng-click=\"vm.addPerfil()\" class=\"btn btn-small btn-primary pull-right\" data-toggle=\"modal\" data-target=\"#modalEdicao\">Adicionar Perfis</a></div></div><div class=\"row\"><div class=\"col-sm-6 pull-right\"><label>Busca:</label> <input type=\"text\" ng-model=\"search\" ng-change=\"vm.filter()\" placeholder=\"busca\" class=\"form-control input-busca\"></div></div><br><div class=\"row\"><div class=\"col-md-12\" ng-show=\"vm.filter_data > 0\"><table id=\"gridDados\" class=\"table table-striped table-bordered\"><thead><th>Nome&nbsp; <a ng-click=\"vm.sort_with(\'nome\');\"><i class=\"fa fa-sort\"></i></a></th><th>Temas</th><th class=\"hidden\">&nbsp;</th><th class=\"width-10\">Editar</th><th class=\"width-10\">Apagar</th></thead><tbody><tr ng-repeat=\"data in vm.searched = (vm.objPerfilList | filter:search | orderBy : vm.base :vm.reverse) | beginning_data:(vm.current_grid-1)*vm.data_limit | limitTo:vm.data_limit\"><td>{{ data.nome }}</td><td><span ng-repeat=\"temaName in data.temasName\">&bull; {{temaName}}&nbsp;&nbsp;</span></td><td class=\"hidden\">{{ data.codigo }}</td><td><a ng-click=\"vm.edit(data)\" class=\"btn btn-small btn-primary\" data-toggle=\"modal\" data-target=\"#modalEdicao\">Editar</a></td><td><a ng-click=\"vm.deletePerfil(data, $event)\" class=\"btn btn-small btn-danger\">Apagar</a></td></tr></tbody></table></div><div class=\"col-md-12\" ng-show=\"vm.filter_data == 0\"><div class=\"col-md-12\"><h4>Nenhum item foi localizado</h4></div></div><div class=\"col-md-12\"><div class=\"col-md-6 pull-left\" ng-show=\"vm.filter_data > 0\"><h5>{{ vm.filter_data }} de {{ vm.entire_user}} registros</h5></div><div class=\"col-md-6\" ng-show=\"vm.filter_data > 0\"><div uib-pagination=\"\" ng-model=\"vm.current_grid\" ng-change=\"vm.page_position(page)\" total-items=\"vm.filter_data\" items-per-page=\"vm.data_limit\" class=\"pagination-small pull-right\" previous-text=\"&laquo;\" next-text=\"&raquo;\"></div></div></div></div></div></div></div></div></div><div class=\"modal fade\" id=\"modalEdicao\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalEdicao\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><form name=\"formCadastro\" ng-model=\"formCadastro\" novalidate=\"\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.botaoFechar(vm.objPerfil)\" aria-label=\"Fechar\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" ng-if=\"vm.tipoAtualizacao === \'edit\'\">Editar Perfil</h4><h4 class=\"modal-title\" ng-if=\"vm.tipoAtualizacao !== \'edit\'\">Adicionar Perfil</h4></div><div class=\"modal-body\"><label>* Nome</label><div class=\"form-group\"><input type=\"text\" class=\"form-control\" name=\"campoCodigo\" ng-model=\"vm.objPerfil.nome\" required=\"\" placeholder=\"Nome\" maxlength=\"50\"><div ng-show=\"formCadastro.vm.objPerfil.nome.$invalid && formCadastro.vm.objPerfil.nome.$dirty\"><small class=\"text-danger\" ng-show=\"formCadastro.vm.objPerfil.nome.$error.required\">O preenchimento do campo é obrigatório</small></div></div><label>Temas</label><div class=\"form-group\"><div class=\"form-check-list\"><label ng-model=\"vm.objPerfil.temas\" ng-repeat=\"objTema in vm.lstTemas\"><input type=\"checkbox\" value=\"{{objTema.$id}}\" ng-checked=\"vm.objPerfil.temas.indexOf(objTema.$id) > -1\" ng-click=\"vm.toggleSelection(objTema.$id, $event)\"> {{objTema.$value}}</label></div></div><div class=\"form-group\"><input type=\"hidden\" ng-model=\"vm.objPerfil.codigo\"></div></div><div class=\"modal-footer\"><button ng-click=\"vm.botaoFechar(vm.objPerfil)\" type=\"button\" class=\"btn btn-default\">Fechar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.verificaDuplicado(vm.objPerfil)\">Salvar</button></div></form></div></div></div></div>");
$templateCache.put("app/cadastros/cadastroConteudos.html","<div ng-controller=\"CadastroConteudos as controller\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Administração - Conteúdos</h2></div><div class=\"wrapper wrapper-content animated fadeInUp clearfix\"><div class=\"ibox\"><div class=\"ibox-content\"><div><div class=\"\"><div class=\"col-md-12\"><div class=\"row\"><a ng-click=\"abreForm()\" class=\"btn btn-small btn-primary pull-right\" data-toggle=\"modal\" data-target=\"#modalEdicao\">Adicionar Conteúdo</a></div></div><div class=\"row\"><div class=\"col-sm-6 pull-right\"><label>Busca:</label> <input type=\"text\" ng-model=\"search\" ng-change=\"filter()\" placeholder=\"busca\" class=\"form-control input-busca\"></div></div><br><div class=\"row\"><div class=\"col-md-12 table-responsive\" ng-show=\"filter_data > 0\"><table id=\"gridDados\" class=\"table table-striped table-bordered\"><thead><th>Imagem</th><th style=\"white-space: nowrap;\">Nome&nbsp; <a ng-click=\"sort_with(\'name\');\"><i class=\"fa fa-sort\"></i></a></th><th style=\"white-space: nowrap;\">Descrição&nbsp; <a ng-click=\"sort_with(\'description\');\"><i class=\"fa fa-sort\"></i></a></th><th style=\"white-space: nowrap;\">Tema&nbsp; <a ng-click=\"sort_with(\'tema\');\"><i class=\"fa fa-sort\"></i></a></th><th style=\"white-space: nowrap;\">Mídia&nbsp; <a ng-click=\"sort_with(\'tipo\');\"><i class=\"fa fa-sort\"></i></a></th><th class=\"hidden\">&nbsp;</th><th style=\"white-space: nowrap;\">Relatório</th><th class=\"width-10\">Editar</th><th class=\"width-10\">Apagar</th></thead><tbody><tr ng-repeat=\"data in searched = (file | filter:search | orderBy : base :reverse) | beginning_data:(current_grid-1)*data_limit | limitTo:data_limit\"><td><img style=\"width: 60px; height: 60px;\" src=\"{{data.imagem}}\"> <input type=\"hidden\" value=\"{{data.imagem}}\"></td><td>{{data.name}}</td><td>{{data.description}}</td><td>{{data.tema}} <input type=\"hidden\" value=\"{{data.temaKey}}\"></td><td style=\"white-space: nowrap;\" ng-if=\"data.tipo == \'video\' || data.tipo == \'urlvideo\'\"><a href=\"http://youtube.com/watch?v={{data.video}}\" style=\"cursor: pointer;\" target=\"_blank\">Vídeo <i class=\"fa fa-external-link\"></i></a></td><td style=\"white-space: nowrap;\" ng-if=\"data.tipo == \'audio\'\"><a style=\"cursor: pointer;\" href=\"{{data.audio}}\" target=\"_blank\">Áudio <i class=\"fa fa-external-link\"></i></a></td><td style=\"white-space: nowrap;\" ng-if=\"data.tipo == \'arquivo\'\"><a style=\"cursor: pointer;\" href=\"{{data.arquivo}}\" target=\"_blank\">Arquivo <i class=\"fa fa-external-link\"></i></a></td><td class=\"hidden\">{{data.codigo}}</td><td class=\"hidden\">{{data.timestamp}}</td><td><a ng-click=\"relatorio(data)\" class=\"btn btn-small btn-primary btn-outline\" data-toggle=\"modal\" data-target=\"#modalRelatorio\">Relatório Feedback</a><br><strong>Aceitação:</strong> {{data.like+data.dislike > 0 ? ((data.like/(data.like+data.dislike))*100).toFixed(1) + \"%\" : \"Sem Feedback\"}}</td><td><a ng-click=\"edit(data)\" class=\"btn btn-small btn-primary\" data-toggle=\"modal\" data-target=\"#modalEdicao\">Editar</a></td><td><a ng-click=\"delete(data, $event)\" class=\"btn btn-small btn-danger\">Apagar</a></td></tr></tbody></table></div><div class=\"col-md-12\" ng-show=\"filter_data == 0\"><div class=\"col-md-12\"><h4>Nenhum item foi localizado</h4></div></div><div class=\"col-md-12\"><div class=\"col-md-6 pull-left\" ng-show=\"filter_data > 0\"><h5>{{ filter_data }} de {{ entire_user}} registros</h5></div><div class=\"col-md-6\" ng-show=\"filter_data > 0\"><div uib-pagination=\"\" ng-model=\"current_grid\" ng-change=\"page_position(page)\" total-items=\"filter_data\" items-per-page=\"data_limit\" class=\"pagination-small pull-right\" previous-text=\"&laquo;\" next-text=\"&raquo;\"></div></div></div></div></div></div></div></div></div><div class=\"modal fade\" id=\"modalEdicao\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalEdicao\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"botaoFechar(app)\" aria-label=\"Fechar\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" ng-if=\"tipoAtualizacao === \'edit\'\">Editar Conteúdo</h4><h4 class=\"modal-title\" ng-if=\"tipoAtualizacao !== \'edit\'\">Adicionar Conteúdo</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>* Nome</label> <input id=\"title\" type=\"text\" maxlength=\"150\" class=\"form-control\" ng-model=\"app.name\" placeholder=\"Nome\"></div><div class=\"form-group\"><label>* Descrição</label> <textarea id=\"description\" class=\"form-control\" ng-model=\"app.description\" placeholder=\"Descrição\">\r\n                        </textarea></div><div class=\"form-group\"><label>Ícone (tamanho máximo 200x200px)</label> <input id=\"imagemConteudo\" name=\"imagemConteudo\" type=\"file\" class=\"form-control\" accept=\"image/*\"> <input id=\"imagemAtual\" type=\"hidden\" ng-model=\"app.imagem\"></div><div class=\"form-group\"><label>* Tipo de mídia</label><select class=\"form-control\" id=\"cbTipo\" ng-model=\"app.tipo\"><option value=\"video\">Vídeo</option><option value=\"urlvideo\">Link do Vídeo no YouTube</option><option value=\"arquivo\">Arquivo</option><option value=\"audio\">Áudio</option></select></div><div class=\"form-group\"><label>* Tema do conteúdo</label><select class=\"form-control\" id=\"cbTipo\" ng-model=\"app.temaKey\" ng-options=\"key as value for (key , value) in cbTemas\"></select></div><div class=\"form-group\" ng-show=\"app.tipo == \'arquivo\' || app.tipo == \'audio\'\"><label ng-if=\"tipoAtualizacao != \'edit\'\" style=\"text-transform: capitalize;\">{{\'* \'.concat (app.tipo)}}</label> <label ng-if=\"tipoAtualizacao == \'edit\'\" style=\"text-transform: capitalize;\">{{app.tipo}}</label> <input id=\"midia\" type=\"file\" name=\"midia\" class=\"form-control\" accept=\"image/*, audio/*, application/pdf\"></div><div ng-show=\"app.tipo == \'urlvideo\'\"><label>* Link do Vídeo no YouTube</label> <input id=\"urlVideo\" type=\"text\" maxlength=\"150\" ng-value=\"tipoAtualizacao == \'edit\' && app.video ? \'https://youtube.com/watch?v=\' + app.video : \'\'\" class=\"form-control\" placeholder=\"Link do Vídeo\"></div><div class=\"form-group\" ng-show=\"app.tipo == \'video\'\"><fieldset id=\"camposYoutube\"><span id=\"signinButton\" style=\"margin-bottom: 8px; display: block;\"><span class=\"g-signin2\" data-onsuccess=\"onSignIn\" data-onfailure=\"onSignInFailure\" data-client_id=\"{{dataClientId}}\" data-cookiepolicy=\"single_host_origin\" data-scope=\"https://www.googleapis.com/auth/youtube.upload https://www.googleapis.com/auth/youtube\"></span></span><div class=\"post-sign-in\"><div class=\"form-group\"><p>Você está logado em sua conta do google:</p><img id=\"channel-thumbnail\"> <span id=\"channel-name\"></span></div><div class=\"form-group\"><p>Escolha o vídeo e faça o upload:<br>Utilize os formatos mostrados a seguir caso você não saiba qual usar para salvar seus vídeos ou se receber uma mensagem de erro:<br>.MOV, .MPEG4, .MP4, .AVI, .WMV, .MPEGPS, .FLV, 3GPP, WebM, DNxHR, ProRes, CineForm, HEVC (h265).</p></div><div class=\"form-group\"><input type=\"file\" id=\"file\" class=\"form-group\" accept=\"video/mp4,video/x-m4v,video/*\"> <button class=\"btn btn-primary\" id=\"button\">Upload Vídeo</button><div class=\"during-upload\"><p><span id=\"percent-transferred\"></span>% pronto ( <span id=\"bytes-transferred\"></span>/ <span id=\"total-bytes\"></span> bytes)</p><progress id=\"upload-progress\" max=\"1\" value=\"0\"></progress></div><div class=\"post-upload form-group\"><p>Vídeo enviado com o id <input type=\"text\" class=\"form-control\" disabled=\"\" id=\"video-id\"></p><ul id=\"post-upload-status\"></ul><div id=\"player\"></div></div></div></div></fieldset></div><div class=\"form-group\"><input id=\"codigoConteudo\" type=\"hidden\" ng-model=\"app.codigo\"></div></div><div class=\"modal-footer\"><button ng-click=\"botaoFechar(app)\" type=\"button\" class=\"btn btn-default\">Fechar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"update(app)\">Salvar</button></div></div></div></div><div class=\"modal fade\" id=\"modalRelatorio\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalRelatorio\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Fechar\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Relatório</h4></div><div class=\"modal-body p-z\"><iframe src=\"//about:blank\" style=\"width: 100%; height: 600px; border: none\"></iframe></div></div></div></div></div>");
$templateCache.put("app/cadastros/cadastroEmpresas.html","<div ng-controller=\"CadastroEmpresas as vm\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Administração - Unidades</h2></div><div class=\"wrapper wrapper-content animated fadeInUp clearfix\"><div class=\"ibox\"><div class=\"ibox-content\"><div><div class=\"\"><div class=\"col-md-12\"><div class=\"row\"><a ng-click=\"vm.addNovaUnidade()\" class=\"btn btn-small btn-primary pull-right\" data-toggle=\"modal\" data-target=\"#modalEdicao\">Adicionar Unidades</a></div></div><div class=\"row\"><div class=\"col-sm-6 pull-right\"><label>Busca:</label> <input type=\"text\" ng-model=\"search\" ng-change=\"vm.filter()\" placeholder=\"busca\" class=\"form-control input-busca\"></div></div><br><div class=\"row\"><div class=\"col-md-12\" ng-show=\"vm.filter_data > 0\"><table id=\"gridDados\" class=\"table table-striped table-bordered\"><thead><th style=\"width: 100px\">Logomarca</th><th>Nome&nbsp; <a ng-click=\"vm.sort_with(\'valor\');\"><i class=\"fa fa-sort\"></i></a></th><th class=\"hidden\">&nbsp;</th><th class=\"width-10\">Editar</th><th class=\"width-10\">Apagar</th></thead><tbody><tr ng-repeat=\"data in vm.searched = (vm.objEmpresaList | filter:search | orderBy : vm.base :vm.reverse) | beginning_data:(vm.current_grid-1)*vm.data_limit | limitTo:vm.data_limit\"><td style=\"text-align: center;\"><img style=\"max-width: 209px; max-height: 80px\" src=\"{{data.foto}}\"></td><td>{{data.nome}}</td><td class=\"hidden\">{{data.codigo}}</td><td><a ng-click=\"vm.edit(data)\" class=\"btn btn-small btn-primary\" data-toggle=\"modal\" data-target=\"#modalEdicao\">Editar</a></td><td><a ng-click=\"vm.deleteUnidade(data, $event)\" class=\"btn btn-small btn-danger\">Apagar</a></td></tr></tbody></table></div><div class=\"col-md-12\" ng-show=\"vm.filter_data == 0\"><div class=\"col-md-12\"><h4>Nenhum item foi localizado</h4></div></div><div class=\"col-md-12\"><div class=\"col-md-6 pull-left\" ng-show=\"vm.filter_data > 0\"><h5>{{ vm.filter_data }} de {{ vm.entire_user}} registros</h5></div><div class=\"col-md-6\" ng-show=\"filter_data > 0\"><div uib-pagination=\"\" ng-model=\"vm.current_grid\" ng-change=\"vm.page_position(page)\" total-items=\"vm.filter_data\" items-per-page=\"vm.data_limit\" class=\"pagination-small pull-right\" previous-text=\"&laquo;\" next-text=\"&raquo;\"></div></div></div></div></div></div></div></div></div><div class=\"modal fade\" id=\"modalEdicao\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalEdicao\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.botaoFechar(vm.app)\" aria-label=\"Fechar\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" ng-if=\"vm.tipoAtualizacao === \'edit\'\">Editar Unidade</h4><h4 class=\"modal-title\" ng-if=\"vm.tipoAtualizacao !== \'edit\'\">Adicionar Unidade</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>* Nome</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.app.nome\" placeholder=\"Nome\" maxlength=\"50\"></div><div class=\"form-group\"><input type=\"checkbox\" ng-model=\"vm.app.semLogomarca\" ng-click=\"vm.toggleSemLogomarca($event)\"> Sem logomarca</div><div class=\"form-group\" id=\"formGroupimagem\" ng-show=\"!vm.semLogomarca\"><label>Logomarca</label> <label>Imagem (150x80px)</label><br><input id=\"imagemConteudo\" name=\"imagemConteudo\" type=\"file\" class=\"form-control form-control-file\" accept=\"image/*\"></div><div class=\"form-group\"><input type=\"hidden\" ng-model=\"vm.app.codigo\"></div><div class=\"modal-footer\"><button ng-click=\"vm.botaoFechar(vm.app)\" type=\"button\" class=\"btn btn-default\">Fechar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.verificaDuplicado(vm.app)\">Salvar</button></div></div></div></div></div></div>");
$templateCache.put("app/cadastros/cadastroTemas.html","<div ng-controller=\"CadastroTemas as controller\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Administração - Temas</h2></div><div class=\"wrapper wrapper-content animated fadeInUp clearfix\"><div class=\"ibox\"><div class=\"ibox-content\"><div><div class=\"\"><div class=\"col-md-12\"><div class=\"row\"><a ng-click=\"abreForm()\" class=\"btn btn-small btn-primary pull-right\" data-toggle=\"modal\" data-target=\"#modalEdicao\">Adicionar Temas</a></div></div><div class=\"row\"><div class=\"col-sm-6 pull-right\"><label>Busca:</label> <input type=\"text\" ng-model=\"search\" ng-change=\"filter()\" placeholder=\"busca\" class=\"form-control input-busca\"></div></div><br><div class=\"row\"><div class=\"col-md-12\" ng-show=\"filter_data > 0\"><table class=\"table table-striped table-bordered\"><thead><th>Nome&nbsp; <a ng-click=\"sort_with(\'valor\');\"><i class=\"fa fa-sort\"></i></a></th><th class=\"hidden\">&nbsp;</th><th class=\"width-10\">Editar</th><th class=\"width-10\">Apagar</th></thead><tbody><tr ng-repeat=\"data in searched = (file | filter:search | orderBy : base :reverse) | beginning_data:(current_grid-1)*data_limit | limitTo:data_limit\"><td>{{data.valor}}</td><td class=\"hidden\">{{data.codigo}}</td><td><a ng-click=\"edit(data)\" class=\"btn btn-small btn-primary\" data-toggle=\"modal\" data-target=\"#modalEdicao\">Editar</a></td><td><a ng-click=\"delete(data, $event)\" class=\"btn btn-small btn-danger\">Apagar</a></td></tr></tbody></table></div><div class=\"col-md-12\" ng-show=\"filter_data == 0\"><div class=\"col-md-12\"><h4>Nenhum item foi localizado</h4></div></div><div class=\"col-md-12\"><div class=\"col-md-6 pull-left\" ng-show=\"filter_data > 0\"><h5>{{ filter_data }} de {{ entire_user}} registros</h5></div><div class=\"col-md-6\" ng-show=\"filter_data > 0\"><div uib-pagination=\"\" ng-model=\"current_grid\" ng-change=\"page_position(page)\" total-items=\"filter_data\" items-per-page=\"data_limit\" class=\"pagination-small pull-right\" previous-text=\"&laquo;\" next-text=\"&raquo;\"></div></div></div></div></div></div></div></div></div><div class=\"modal fade\" id=\"modalEdicao\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalEdicao\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"botaoFechar(app)\" aria-label=\"Fechar\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" ng-if=\"tipoAtualizacao === \'edit\'\">Editar Tema</h4><h4 class=\"modal-title\" ng-if=\"tipoAtualizacao !== \'edit\'\">Adicionar Tema</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>* Nome</label> <input type=\"text\" class=\"form-control\" ng-model=\"app.valor\" placeholder=\"Nome\" maxlength=\"50\"></div><div class=\"form-group\"><input type=\"hidden\" ng-model=\"app.codigo\"></div></div><div class=\"modal-footer\"><button ng-click=\"botaoFechar(app)\" type=\"button\" class=\"btn btn-default\">Fechar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"verificaDuplicado(app)\">Salvar</button></div></div></div></div></div>");
$templateCache.put("app/cadastros/cadastroUsuarios.html","<div id=\"formUsuarios\" ng-controller=\"CadastroUsuarios as vm\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Administração - Usuários</h2></div><div class=\"wrapper wrapper-content animated fadeInUp clearfix\"><div class=\"ibox\"><div class=\"ibox-content\"><div><div><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-12 text-right\" style=\"padding: 0;\"><a ng-click=\"vm.addUsuario()\" class=\"btn btn-small btn-primary\" data-toggle=\"modal\" data-target=\"#modalEdicao\">Adicionar Usuários</a> <a ng-click=\"vm.openImportarUsuarios()\" class=\"btn btn-small btn-primary\" data-toggle=\"modal\" data-target=\"#modalImportarUsuarios\">Importar Usuários</a></div></div></div><div class=\"row\"><div class=\"col-sm-6 pull-right\"><label for=\"search\">Busca:</label> <input id=\"search\" name=\"search\" type=\"text\" ng-model=\"search\" ng-change=\"vm.filter()\" placeholder=\"busca\" class=\"form-control input-busca\"></div></div><br><div class=\"row\"><div class=\"col-md-12 table-responsive\" ng-show=\"vm.filter_data > 0\"><table id=\"gridDados\" class=\"table table-striped table-bordered\"><thead><th style=\"width: 0;\">Foto</th><th style=\"white-space: nowrap;\">Nome&nbsp; <a ng-click=\"vm.sort_with(\'name\');\"><i class=\"fa fa-sort\"></i></a></th><th style=\"white-space: nowrap;\">Login&nbsp; <a ng-click=\"vm.sort_with(\'username\');\"><i class=\"fa fa-sort\"></i></a></th><th style=\"white-space: nowrap;\">Email&nbsp; <a ng-click=\"vm.sort_with(\'email\');\"><i class=\"fa fa-sort\"></i></a></th><th class=\"hidden\">&nbsp;</th><th class=\"hidden\">&nbsp;</th><th style=\"white-space: nowrap;\">Área&nbsp; <a ng-click=\"vm.sort_with(\'objArea.nome\');\"><i class=\"fa fa-sort\"></i></a></th><th style=\"white-space: nowrap;\">Perfil&nbsp; <a ng-click=\"vm.sort_with(\'objCargo.nome\');\"><i class=\"fa fa-sort\"></i></a></th><th style=\"white-space: nowrap;\">Unidade&nbsp; <a ng-click=\"vm.sort_with(\'objEmpresa.nome\');\"><i class=\"fa fa-sort\"></i></a></th><th style=\"white-space: nowrap;\">Administrador&nbsp; <a ng-click=\"vm.sort_with(\'admin\');\"><i class=\"fa fa-sort\"></i></a></th><th style=\"width: 0;\">Relatório</th><th class=\"hidden\">&nbsp;</th><th style=\"width: 0;\">Editar</th><th style=\"width: 0;\">Desabilitar / Habilitar</th></thead><tbody><tr ng-repeat=\"data in vm.searched = (vm.file | filter:search | orderBy : vm.base :vm.reverse) | beginning_data:(vm.current_grid -1)*vm.data_limit | limitTo:vm.data_limit\"><td><img style=\"width: 40px;\" src=\"{{data.foto}}\"> <input type=\"hidden\" value=\"{{data.foto}}\"></td><td>{{data.name}}</td><td>{{data.login}}</td><td>{{data.email}}</td><td class=\"hidden\">{{data.password}}</td><td class=\"hidden\">{{data.temas}}</td><td>{{(data.objArea) ? data.objArea.nome : \'\'}}</td><td>{{(data.objCargo) ? data.objCargo.nome : \'\'}}</td><td>{{(data.objEmpresa) ? data.objEmpresa.nome : \'\'}}</td><td>{{data.admin ? \'Sim\' : \'Não\'}}</td><td><a ng-click=\"vm.relatorio(data)\" class=\"btn btn-small btn-primary btn-outline\" data-toggle=\"modal\" data-target=\"#modalRelatorio\">Ver Relatório</a></td><td class=\"hidden\">{{data.codigo}}</td><td class=\"hidden\">{{data.timestamp}}</td><td><a ng-click=\"vm.edit(data)\" class=\"btn btn-small btn-primary\" data-toggle=\"modal\" data-target=\"#modalEdicao\">Editar</a></td><td><a ng-click=\"vm.desabilitarUser(data, $event)\" class=\"btn btn-small btn-danger bt-desabilitar\" ng-if=\"!data.permanente && !data.desabilitado\">Desabilitar</a> <a ng-click=\"vm.habilitarUser(data, $event)\" class=\"btn btn-small btn-info bt-habilitar\" ng-if=\"!data.permanente && data.desabilitado\">Habilitar</a></td></tr></tbody></table></div><div class=\"col-md-12\" ng-show=\"vm.filter_data == 0\"><div class=\"col-md-12\"><h4>Nenhum item foi localizado</h4></div></div><div class=\"col-md-12\"><div class=\"col-md-6 pull-left\" ng-show=\"vm.filter_data > 0\"><h5>{{ vm.filter_data }} de {{ vm.entire_user}} registros</h5></div><div class=\"col-md-6\" ng-show=\"filter_data > 0\"><div uib-pagination=\"\" ng-model=\"vm.current_grid\" ng-change=\"vm.page_position(page)\" total-items=\"vm.filter_data\" items-per-page=\"vm.data_limit\" class=\"pagination-small pull-right\" previous-text=\"&laquo;\" next-text=\"&raquo;\"></div></div></div></div></div></div></div></div></div><div class=\"modal fade\" id=\"modalEdicao\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalEdicao\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.botaoFechar(vm.app)\" aria-label=\"Fechar\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\" ng-if=\"vm.tipoAtualizacao === \'edit\'\">Editar Usuário</h4><h4 class=\"modal-title\" id=\"myModalLabel\" ng-if=\"vm.tipoAtualizacao !== \'edit\'\">Adicionar Usuários</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>* Nome</label> <input id=\"name\" type=\"text\" class=\"form-control\" ng-model=\"vm.app.name\" placeholder=\"Nome\" maxlength=\"65\"></div><div class=\"form-group\"><label>* Login</label> <input id=\"login\" type=\"text\" class=\"form-control\" ng-model=\"vm.app.login\" placeholder=\"Nome de Usuário\" maxlength=\"50\"></div><div class=\"form-group\"><label>* E-mail</label> <input id=\"email\" type=\"text\" class=\"form-control\" ng-model=\"vm.app.email\" placeholder=\"Email\" maxlength=\"255\"></div><div class=\"form-group\"><label>* Senha</label> <input id=\"password\" type=\"password\" autocomplete=\"new-password\" class=\"form-control\" ng-model=\"vm.app.password\" placeholder=\"Senha\" maxlength=\"50\"> <small>Mínimo de 6 caracteres</small></div><div class=\"form-group\"><label>Foto (60x60 pixels)</label> <input id=\"imagemConteudo\" name=\"imagemConteudo\" type=\"file\" class=\"form-control\" accept=\"image/*\"> <input id=\"imagemAtual\" type=\"hidden\" ng-model=\"vm.app.foto\"></div><div class=\"form-group\"><label>Área</label><select class=\"form-control\" id=\"cbArea\" ng-model=\"vm.app.area\" ng-change=\"vm.listaTemasCargoPerfil(vm.app)\" ng-options=\"key as value.nome for (key , value) in vm.lstArea\"></select></div><div class=\"form-group\"><label>Perfil</label><select class=\"form-control\" id=\"cbCargo\" ng-model=\"vm.app.cargo\" ng-change=\"vm.listaTemasCargoPerfil(vm.app)\" ng-options=\"key as value.nome for (key , value) in vm.lstCargo\"></select></div><div class=\"form-group\"><label>Unidade</label><select class=\"form-control\" id=\"cbEmpresa\" ng-model=\"vm.app.empresa\" ng-options=\"key as value.nome for (key , value) in vm.lstEmpresa\"></select></div><div class=\"form-group\"><label>Temas Associados</label><br><p><smal>Os temas marcados e desabilitados já foram associados no cadastro de Área e/ou Perfil.</smal></p><div id=\"selectTemas\" class=\"form-check-list\"><label ng-model=\"vm.app.temas\" ng-repeat=\"(valor, temaNome) in vm.lstTemas\"><input type=\"checkbox\" value=\"{{valor}}\" ng-checked=\"vm.app.temas.indexOf(valor) > -1 || vm.lstAllTemas.indexOf(valor) > -1\" ng-disabled=\"vm.lstAllTemas.indexOf(valor) > -1\" ng-click=\"vm.toggleSelection(valor, $event)\"> {{temaNome}}</label></div></div><div class=\"form-group\"><input id=\"codigoConteudo\" type=\"hidden\" ng-model=\"vm.app.codigo\"></div></div><div class=\"modal-footer\"><button ng-click=\"vm.botaoFechar(vm.app)\" type=\"button\" class=\"btn btn-default\">Fechar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.beforeUpdate(vm.app)\">Salvar</button></div></div></div></div><div class=\"modal fade\" id=\"modalRelatorio\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalRelatorio\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Fechar\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Relatório</h4></div><div class=\"modal-body p-z\"><iframe src=\"//about:blank\" style=\"width: 100%; height: 600px; border: none\"></iframe></div></div></div></div></div>");
$templateCache.put("app/cadastros/enviarNotificacoes.html","<div ng-controller=\"EnviarNotificacoes as controller\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Administração - Notificações</h2></div><div class=\"wrapper wrapper-content animated fadeInUp clearfix\"><div class=\"ibox col-md-6 fn\" style=\"margin: 0 auto;float: none;\"><div class=\"ibox-title\"><h5>Enviar Notificações</h5></div><div class=\"ibox-content\"><form name=\"formCadastro\" novalidate=\"\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" id=\"title\" name=\"title\" ng-model=\"app.title\" required=\"\" placeholder=\"* Título\"><div ng-show=\"formCadastro.app.title.$invalid\"><small class=\"text-danger\" ng-show=\"formCadastro.app.title.$error.required\">O preenchimento do campo é obrigatório</small></div></div><div class=\"form-group\"><textarea rows=\"10\" class=\"form-control\" id=\"body\" name=\"body\" ng-model=\"app.body\" required=\"\" placeholder=\"* Texto da mensagem\"></textarea><div ng-show=\"formCadastro.app.body.$invalid\"><small class=\"text-danger\" ng-show=\"formCadastro.app.body.$error.required\">O preenchimento do campo é obrigatório</small></div></div><button id=\"sendButton\" type=\"button\" class=\"btn btn-primary\" ng-click=\"enviar(app, formCadastro.$valid)\"><span id=\"sendButtonText\">Enviar</span></button><div><small>*Todos os campos são de preenchimento obrigatório</small></div></form></div></div></div></div>");
$templateCache.put("app/cadastros/importar-usuarios.modal.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancelar()\" aria-label=\"Fechar\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Importar Usuários</h4></div><div class=\"modal-body\"><div class=\"form-group\"><p>Download do formulário padrão para importação:<u><a href=\"assets/files/Formulario_Padrao.xlsx\">Formulário_Padrão</a></u></p><p>As colunas <strong>\"Nome, Email, Login\"</strong> são de preenchimento obrigatório. <strong>\"Área, Perfil, Unidade\",</strong> caso não tenham sido cadastrados no sistema, serão criados no momento da importação.</p><label>* Selecionar formulário padrão para importação</label> <input id=\"excel\" name=\"excel\" type=\"file\" class=\"form-control\" onchange=\"angular.element(this).scope().loadFile(this.files)\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"></div><div class=\"form-group\"><label>* Senha padrão</label> <input id=\"senhaPadrao\" name=\"senhaPadrao\" type=\"text\" ng-model=\"vm.senhaPadrao\" class=\"form-control\"> <small>Mínimo de 6 caracteres</small></div><div ng-if=\"vm.log.countSuccess > -1 || vm.log.errorList.length > 0\"><div class=\"form-group bg-success\" ng-style=\"{\'padding\': \'6px\'}\"><p class=\"bg-success\" ng-if=\"vm.log.countSuccess > -1\"><strong>{{vm.log.countSuccess}}</strong> usuário(s) importado(s) com sucesso.</p></div><label ng-if=\"vm.log.errorList.length > 0\">Usuários não importados:</label><div class=\"form-group bg-warning\" style=\"max-height: 255px; overflow: auto; padding: 6px;\" ng-if=\"vm.log.errorList.length > 0\"><ul><li ng-repeat=\"msgError in vm.log.errorList track by $index\" ng-if=\"msgError && msgError.length > 0\">{{msgError}}</li></ul></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancelar()\">Fechar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.importar()\">Importar</button></div>");
$templateCache.put("app/cadastros/insightsConteudo.html","<div ng-controller=\"InsightsConteudos as controller\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Administração - Insights de Conteúdo</h2></div><div class=\"wrapper wrapper-content animated fadeInUp clearfix\"><div class=\"ibox\"><div class=\"ibox-content\"><div><div class=\"\"><div class=\"row\"><div class=\"col-sm-6 pull-right\"><label>Busca:</label> <input type=\"text\" ng-model=\"search\" ng-change=\"filter()\" placeholder=\"busca\" class=\"form-control input-busca\"></div><div class=\"col-sm-6 pull-left\"><h3><strong>Total de Usuários Cadastrados no Sistema: <span style=\"color: green\">{{totalUsuarios}}</span></strong></h3></div></div><br><div class=\"row\"><div class=\"col-md-12 table-responsive\" ng-show=\"filter_data > 0\"><table id=\"gridDados\" class=\"table table-striped table-bordered\"><thead><th>Imagem</th><th style=\"white-space: nowrap;\">Nome&nbsp; <a ng-click=\"sort_with(\'name\');\"><i class=\"fa fa-sort\"></i></a></th><th style=\"white-space: nowrap;\">Descrição&nbsp; <a ng-click=\"sort_with(\'description\');\"><i class=\"fa fa-sort\"></i></a></th><th style=\"white-space: nowrap;\">Tema&nbsp; <a ng-click=\"sort_with(\'tema\');\"><i class=\"fa fa-sort\"></i></a></th><th style=\"white-space: nowrap;\">Mídia <a ng-click=\"sort_with(\'tipo\');\"><i class=\"fa fa-sort\"></i></a></th><th>Usuários por<br>Conteúdo</th><th>Conteúdo<br>Em Andamento</th><th>Conteúdo<br>Concluído</th><th class=\"hidden\">&nbsp;</th></thead><tbody><tr ng-repeat=\"data in searched = (file | filter:search | orderBy : base :reverse) | beginning_data:(current_grid-1)*data_limit | limitTo:data_limit\"><td><img style=\"width: 60px; height: 60px;\" ng-src=\"{{data.imagem}}\"> <input type=\"hidden\" value=\"{{data.imagem}}\"></td><td>{{data.name}}</td><td>{{data.description}}</td><td>{{data.tema}} <input type=\"hidden\" value=\"{{data.temaKey}}\"></td><td style=\"white-space: nowrap;\" ng-if=\"data.tipo == \'video\' || data.tipo == \'urlvideo\'\"><a href=\"http://youtube.com/watch?v={{data.video}}\" style=\"cursor: pointer;\" target=\"_blank\">Vídeo <i class=\"fa fa-external-link\"></i></a></td><td style=\"white-space: nowrap;\" ng-if=\"data.tipo == \'audio\'\"><a style=\"cursor: pointer;\" href=\"{{data.audio}}\" target=\"_blank\">Áudio <i class=\"fa fa-external-link\"></i></a></td><td style=\"white-space: nowrap;\" ng-if=\"data.tipo == \'arquivo\'\"><a style=\"cursor: pointer;\" href=\"{{data.arquivo}}\" target=\"_blank\">Arquivo <i class=\"fa fa-external-link\"></i></a></td><td style=\"white-space: nowrap;\">{{(((data.totalUsuariosComConteudo * 100)/totalUsuarios) | number:2) * 1}} %<br>(<a ng-click=\"relatorio(data)\" data-toggle=\"modal\" data-target=\"#modalRelatorio\">{{data.totalUsuariosComConteudo}} Usuário (s) <i class=\"fa fa-external-link\" style=\"vertical-align: middle;\"></i></a>)<div class=\"item-progress\"><div class=\"item-barra\" style=\"width: {{(((data.totalUsuariosComConteudo * 100)/totalUsuarios) | number:2) * 1}}%; background-color: green\"></div></div></td><td style=\"white-space: nowrap;\">{{(((data.numEmAndamento * 100)/data.totalUsuariosComConteudo) | number:2) * 1}} %<br>({{data.numEmAndamento}} Conteúdo (s))<div class=\"item-progress\"><div class=\"item-barra\" style=\"width: {{(((data.numEmAndamento * 100)/data.totalUsuariosComConteudo) | number:2) * 1}}%; background-color: green\"></div></div></td><td style=\"white-space: nowrap;\">{{(((data.numConcluido * 100)/data.totalUsuariosComConteudo) | number:2) * 1}} %<br>({{data.numConcluido}} Conteúdo (s))<div class=\"item-progress\"><div class=\"item-barra\" style=\"width: {{(((data.numConcluido * 100)/data.totalUsuariosComConteudo) | number:2) * 1}}%; background-color: green\"></div></div></td><td class=\"hidden\">{{data.codigo}}</td></tr></tbody></table></div><div class=\"col-md-12\" ng-show=\"filter_data == 0\"><div class=\"col-md-12\"><h4>Nenhum item foi localizado</h4></div></div><div class=\"col-md-12\"><div class=\"col-md-6 pull-left\" ng-show=\"filter_data > 0\"><h5>{{ filter_data }} de {{ entire_user}} registros</h5></div><div class=\"col-md-6\" ng-show=\"filter_data > 0\"><div uib-pagination=\"\" ng-model=\"current_grid\" ng-change=\"page_position(page)\" total-items=\"filter_data\" items-per-page=\"data_limit\" class=\"pagination-small pull-right\" previous-text=\"&laquo;\" next-text=\"&raquo;\"></div></div></div></div></div></div></div></div></div><div class=\"modal fade\" id=\"modalRelatorio\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalRelatorio\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Fechar\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Relatório</h4></div><div class=\"modal-body p-z\"><iframe src=\"//about:blank\" style=\"width: 100%; height: 600px; border: none\"></iframe></div></div></div></div></div>");
$templateCache.put("app/cadastros/parametros.html","<div ng-controller=\"CadastroLogomarcas as controller\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Cadastro - Logomarca</h2></div><div class=\"ibox col-xs-12 col-sm-8 col-md-10 col-lg-6\" style=\"margin: 0 auto; float: none;\"><div class=\"ibox-content\"><div class=\"form-group\"><p>Utilizar imagem no formato <strong>PNG</strong> com fundo transparente, para melhor exibição.</p><p>Caso não seja incluída a logomarca, será exibida a padrão.</p><br><label>*Selecionar logomarca, recomenda-se o formato 209x80px ou superior.</label> <input id=\"imagemLogomarca\" name=\"imagemLogomarca\" type=\"file\" onchange=\"handleChange(this)\" class=\"form-control form-control-file\" accept=\"image/*\"></div><label>Pré-visualização</label><div class=\"tela-logo\"><img id=\"imagemPreview\" class=\"obj-param\" src=\"{{ objParametro }}\"></div><div class=\"but-cad\"><a ng-disaled=\"btnDeleteDisabled\" ng-click=\"delete()\" class=\"btn btn-small btn-danger\" style=\"margin-right:10px;\">Apagar</a> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"update()\">Salvar</button></div></div></div></div>");
$templateCache.put("app/card/card.html","<div id=\"wrapper\"><div class=\"gray-bg {{$state.current.name}}\" style=\"min-height: 600px;\"><div class=\"wrapper wrapper-content animated fadeInUp clearfix\" ng-controller=\"CardController as card\" ng-init=\"init();\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"widget-head-color-box navy-bg p-lg text-center\"><div class=\"m-b-md\"><h2 class=\"font-bold no-margins\">{{ usuario.name}}</h2></div><img alt=\"image\" ng-if=\"usuario.foto\" class=\"img-circle circle-border m-b-none\" src=\"{{usuario.foto}}\"> <img alt=\"image\" ng-if=\"!usuario.foto\" class=\"img-circle circle-border m-b-none\" src=\"../assets/images/profile_empty.jpg\"></div><div class=\"widget-text-box\"><div class=\"text-area\"><strong>Área:</strong> {{usuario.areaName}}</div><div class=\"text-perfil\"><strong>Perfil:</strong> {{usuario.cargoName}}</div></div></div><div class=\"col-sm-8\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"widget style1 lazur-bg\"><div class=\"row m-n\"><div class=\"col-xs-4 p-z\"><i class=\"fa fa-book fa-5x\"></i></div><div class=\"col-xs-8 p-z text-right\"><span>Total de Conteúdos</span><h2 class=\"font-bold\">{{total}}</h2></div></div></div></div><div class=\"col-sm-6\"><div class=\"widget style1 lazur-bg\"><div class=\"row m-n\"><div class=\"col-xs-4 p-z\"><i class=\"fa fa-check fa-5x\"></i></div><div class=\"col-xs-8 p-z text-right\"><span>Total Concluídos</span><h2 class=\"font-bold\">{{concluidos}}</h2></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Porcentagem de conclusão</h5></div><div class=\"ibox-content\"><div id=\"msgVazio\" ng-if=\"total <= 0\">Sem dados de progresso</div><div id=\"grafico\"></div></div></div></div></div></div></div></div><div class=\"col-md-12\" ng-show=\"file.length > 0\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Conteúdos Associados</h5></div><div class=\"ibox-content\"><table id=\"gridDados\" class=\"table table-striped table-bordered grid-card\"><thead><th>Imagem</th><th>Nome</th><th>Description</th><th>Tema</th><th>Tipo</th><th>Mídia</th><th>Status</th><th class=\"hidden\"></th></thead><tbody><tr ng-repeat=\"data in file\"><td><img style=\"width: 60px; height: 60px;\" src=\"{{data.imagem}}\"> <input type=\"hidden\" value=\"{{data.imagem}}\"></td><td style=\"word-break: break-word;\">{{data.name}}</td><td>{{data.description}}</td><td style=\"word-break: normal;\">{{data.tema}} <input type=\"hidden\" value=\"{{data.temaKey}}\"></td><td style=\"white-space: nowrap;\">{{data.tipo}}</td><td style=\"white-space: nowrap;\" ng-if=\"data.tipo == \'video\' || data.tipo == \'urlvideo\'\"><a href=\"http://youtube.com/watch?v={{data.video}}\" style=\"cursor: pointer;\" target=\"_blank\">Vídeo <i class=\"fa fa-external-link\"></i></a></td><td style=\"white-space: nowrap;\" ng-if=\"data.audio\"><a style=\"cursor: pointer;\" href=\"{{data.audio}}\" target=\"_blank\">Áudio <i class=\"fa fa-external-link\"></i></a></td><td style=\"white-space: nowrap;\" ng-if=\"data.arquivo\"><a style=\"cursor: pointer;\" href=\"{{data.arquivo}}\" target=\"_blank\">Arquivo <i class=\"fa fa-external-link\"></i></a></td><td style=\"white-space: nowrap;\"><div class=\"text-center blue-bg simple_tag\" ng-if=\"data.status == \'novo\'\"><i class=\"fa fa-plus\"></i> Novo</div><div class=\"text-center yellow-bg simple_tag\" ng-if=\"data.status == \'Em andamento\'\"><i class=\"fa fa-hourglass-half\"></i> Em andamento</div><div class=\"text-center green-bg simple_tag\" ng-if=\"data.status == \'concluído\'\"><i class=\"fa fa-check\" ng-if=\"data.status == \'concluído\'\"></i> Concluído</div></td><td class=\"hidden\">{{data.codigo}}</td></tr></tbody></table></div></div></div><div class=\"col-md-12\" ng-show=\"file.length == 0\"><div class=\"col-md-12\"><h4>Sem Registros</h4></div></div></div></div></div>");
$templateCache.put("app/cardListaInsight/card.html","<div id=\"wrapper\"><div class=\"gray-bg {{$state.current.name}}\" style=\"min-height: 600px;\"><div class=\"wrapper wrapper-content animated fadeInUp clearfix\" ng-controller=\"CardControllerListaInsight as vm\"><div class=\"col-md-12\" ng-show=\"vm.file2.length > 0\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 style=\"width: 90%;\">Nome do Conteúdo: {{vm.conteudo.name}} ({{vm.file2.length}} Usuário(s))</h5><i class=\"fa fa-print bt-exportPDF\" ng-click=\"vm.exportPDF($event)\"></i></div><div class=\"ibox-content\"><table id=\"gridDados\" class=\"table table-striped table-bordered grid-card\"><thead><th style=\"white-space: nowrap;\">Imagem</th><th style=\"white-space: nowrap;\">Nome</th><th style=\"white-space: nowrap;\">Email</th><th style=\"white-space: nowrap;\">Empresa</th><th style=\"white-space: nowrap;\">Área</th><th style=\"white-space: nowrap;\">Perfil</th><th style=\"white-space: nowrap;\">Status Conteúdo</th><th class=\"hidden\"></th></thead><tbody><tr ng-repeat=\"data in vm.file2\"><td style=\"width: 1%;\"><img style=\"width: 60px; height: 60px;\" ng-src=\"{{data.foto}}\"></td><td style=\"word-break: normal;\">{{data.nome}}</td><td style=\"word-break: break-word;\">{{data.email}}</td><td style=\"word-break: break-word;\">{{data.empresa}}</td><td style=\"word-break: break-word;\">{{data.area}}</td><td style=\"word-break: break-word;\">{{data.cargo}}</td><td style=\"word-break: break-word;\" ng-bind-html=\"data.status\"></td><td class=\"hidden\">{{data.codigo}}</td></tr></tbody></table></div></div></div><div class=\"col-md-12\" ng-show=\"vm.file2.length == 0\"><div class=\"col-md-12\"><h4>{{vm.msgVazio}}</h4></div></div></div></div></div>");
$templateCache.put("app/cardRelatorioFeedback/card.html","<div id=\"wrapper\"><div class=\"gray-bg {{$state.current.name}}\" style=\"min-height: 600px;\"><div class=\"wrapper wrapper-content animated fadeInUp clearfix\" ng-controller=\"CardControllerFeedback as vm\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"widget style1 lazur-bg\"><div class=\"row m-n\"><div class=\"col-xs-4\"><i class=\"fa fa-thumbs-up fa-5x\"></i></div><div class=\"col-xs-8 text-right\"><span>Total de Likes</span><h2 class=\"font-bold\">{{vm.conteudo.like || 0}}</h2></div></div></div></div><div class=\"col-sm-6\"><div class=\"widget style1 lazur-bg\"><div class=\"row m-n\"><div class=\"col-xs-4\"><i class=\"fa fa-thumbs-down fa-5x\"></i></div><div class=\"col-xs-8 text-right\"><span>Total de Dislikes</span><h2 class=\"font-bold\">{{vm.conteudo.dislike || 0}}</h2></div></div></div></div></div></div></div></div><div class=\"col-md-12\" ng-show=\"vm.file.length > 0\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Feedback dos Usuários</h5></div><div class=\"ibox-content\"><table id=\"gridDados\" class=\"table table-striped table-bordered grid-card\"><thead><th>Imagem</th><th>Nome</th><th>Comentário</th><th>Like / Dislike</th><th class=\"hidden\"></th></thead><tbody><tr ng-repeat=\"data in vm.file\"><td style=\"width: 1%;\"><img style=\"width: 60px; height: 60px;\" src=\"{{data.foto}}\"></td><td style=\"word-break: normal;\">{{data.nome}}</td><td style=\"word-break: break-word;\">{{data.comentario}}</td><td style=\"text-align: center; width: 100px;\"><div class=\"ico-thumbs\"><i class=\"fa fa-thumbs-up {{ data.curtiu == true ? \'ativo\' : \'\' }}\"></i><i class=\"fa fa-thumbs-down {{ data.curtiu == false ? \'ativo\' : \'\' }}\"></i></div></td><td class=\"hidden\">{{data.codigo}}</td></tr></tbody></table></div></div></div><div class=\"col-md-12\" ng-show=\"vm.file.length == 0\"><div class=\"col-md-12\"><h4>Sem Registros de Feedback</h4></div></div></div></div></div>");
$templateCache.put("app/configurarAplicativo/configurarAplicativo.html","<div ng-controller=\"ConfigAppController as config\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Configurações - Configurar Aplicativo</h2></div><div class=\"wrapper wrapper-content animated fadeInUp clearfix conteudo-wrapper\"><div class=\"ibox col-md-6\" style=\"margin: 0 auto; float: none\"><div class=\"ibox-content\"><div class=\"row\" style=\"text-align: center\"><div class=\"col-md-10\" style=\"margin: 0 auto; float: none\"><p>Acesse o aplicativo, clique no botão \"Configurar com QRCode\", e aponte a câmera para o QR Code abaixo para que as configurações de acesso à sua conta sejam feitas automaticamente.</p></div><qr type-number=\"8\" correction-level=\"\'M\'\" size=\"200\" text=\"valorQrCode\" image=\"true\"></qr></div></div></div></div></div>");
$templateCache.put("app/conteudos/conteudos.html","<div ng-controller=\"ConteudosController as conteudos\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Conteúdos - Lista</h2></div><h4>Tema: {{titulo}}</h4><div class=\"wrapper wrapper-content animated fadeInUp clearfix conteudos-wrapper\"><div class=\"ibox pull-left float-e-margins\" ng-repeat=\"conteudo in conteudos | filter: {status: \'novo\'}\"><div class=\"ibox-title\"><h5 title=\"{{conteudo.nome}}\">{{conteudo.nome}}</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 m-b-sm\"><div class=\"col-xs-3 p-z\"><img style=\"width: 60px; height: 60px;\" ng-src=\"{{conteudo.imagem}}\" class=\"img-conteudo\"></div><div class=\"col-xs-9\"><p class=\"small\">{{conteudo.descricao}}</p></div></div><div class=\"col-xs-12 info-group\"><div class=\"col-xs-4 p-z\"><span class=\"text-navy\"><i class=\"fa fa-check\" ng-show=\"{{conteudo.isConcluido}}\"></i> <small ng-if=\"conteudo.status !== \'novo\'\">{{conteudo.status}}</small> <span ng-if=\"conteudo.status === \'novo\'\" class=\"label label-info\">NOVO</span></span></div><div class=\"col-xs-8 p-z\"><button ng-click=\"IrParaConteudo($event)\" data-codigo=\"{{conteudo.cod}}\" data-tipo=\"{{conteudo.tipo}}\" type=\"button\" class=\"btn btn-xs btn-success pull-right\"><strong>Visualizar</strong></button></div></div></div></div></div><div class=\"ibox pull-left float-e-margins\" ng-repeat=\"conteudo in conteudos | filter: {status: \'Em andamento\'}\"><div class=\"ibox-title\"><h5 title=\"{{conteudo.nome}}\">{{conteudo.nome}}</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 m-b-sm\"><div class=\"col-xs-3 p-z\"><img style=\"width: 60px; height: 60px;\" ng-src=\"{{conteudo.imagem}}\" class=\"img-conteudo\"></div><div class=\"col-xs-9\"><p class=\"small\">{{conteudo.descricao}}</p></div></div><div class=\"col-xs-12 info-group\"><div class=\"col-xs-4 p-z\"><span class=\"text-navy\"><i class=\"fa fa-check\" ng-show=\"{{conteudo.isConcluido}}\"></i> <small ng-if=\"conteudo.status !== \'novo\'\">{{conteudo.status}}</small> <span ng-if=\"conteudo.status === \'novo\'\" class=\"label label-info\">NOVO</span></span></div><div class=\"col-xs-8 p-z\"><button ng-click=\"IrParaConteudo($event)\" data-codigo=\"{{conteudo.cod}}\" data-tipo=\"{{conteudo.tipo}}\" type=\"button\" class=\"btn btn-xs btn-success pull-right\"><strong>Visualizar</strong></button></div></div></div></div></div><div class=\"ibox pull-left float-e-margins\" ng-repeat=\"conteudo in conteudos | filter: {status: \'concluído\'}\"><div class=\"ibox-title\"><h5 title=\"{{conteudo.nome}}\">{{conteudo.nome}}</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 m-b-sm\"><div class=\"col-xs-3 p-z\"><img style=\"width: 60px; height: 60px;\" ng-src=\"{{conteudo.imagem}}\" class=\"img-conteudo\"></div><div class=\"col-xs-9\"><p class=\"small\">{{conteudo.descricao}}</p></div></div><div class=\"col-xs-12 info-group\"><div class=\"col-xs-4 p-z\"><span class=\"text-navy\"><i class=\"fa fa-check\" ng-show=\"{{conteudo.isConcluido}}\"></i> <small ng-if=\"conteudo.status !== \'novo\'\">{{conteudo.status}}</small> <span ng-if=\"conteudo.status === \'novo\'\" class=\"label label-info\">NOVO</span></span></div><div class=\"col-xs-8 p-z\"><button ng-click=\"IrParaConteudo($event)\" data-codigo=\"{{conteudo.cod}}\" data-tipo=\"{{conteudo.tipo}}\" type=\"button\" class=\"btn btn-xs btn-success pull-right\"><strong>Visualizar</strong></button></div></div></div></div></div></div></div>");
$templateCache.put("app/detalhes/detalhes.html","<div ng-controller=\"DetalhesController as detalhes\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Conteúdos - Detalhe</h2></div><h4>Conteúdo: {{titulo}}</h4><div class=\"wrapper wrapper-content animated fadeInUp clearfix conteudo-wrapper\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-6 m-b-sm\"><div id=\"videoPlaceholder\"></div><likedislike conteudoid=\"codigo\"></likedislike><comentario conteudoid=\"codigo\"></comentario></div><div class=\"col-md-6 m-b-sm\"><p><input type=\"checkbox\" class=\"js-switch\"></p><p>Declaro que li, ouvi e vi todo o conteúdo deste vídeo e estou ciente que esta informação será enviada para o administrador dessa empresa para processo e documentação</p><p><b>Tema:</b></p><p>{{tema}}</p></div></div></div></div><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 m-b-sm\"><p><b>Descrição</b></p><p>{{descricao}}</p></div></div></div></div></div></div>");
$templateCache.put("app/detalhesArquivo/detalhesArquivo.html","<div ng-controller=\"DetalhesArquivoController as detalhes\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Conteúdo - Detalhe</h2></div><h4>Conteúdo: {{titulo}}</h4><p><b>Descrição</b></p><p>{{descricao}}</p><div class=\"wrapper wrapper-content animated fadeInUp clearfix conteudo-wrapper\"><div class=\"wrapper-pdf\"><ng-pdf template-url=\"app/components/common/viewer.html\" canvasid=\"pdf\" scale=\"page-fit\" page=\"1\"></ng-pdf></div></div></div>");
$templateCache.put("app/detalhesAudio/detalhesAudio.html","<div ng-controller=\"DetalhesAudioController as detalhes\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Conteúdos - Detalhe</h2></div><h4>Conteúdo: {{titulo}}</h4><div class=\"wrapper wrapper-content animated fadeInUp clearfix conteudo-wrapper\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-6 m-b-sm\"><video id=\"audioPlaceholder\" class=\"tag-video-audio\" controls=\"\" autoplay=\"\" src=\"{{audio}}\" type=\"audio/mpeg\"></video><likedislike conteudoid=\"codigo\"></likedislike><comentario conteudoid=\"codigo\"></comentario></div><div class=\"col-md-6 m-b-sm\"><p><input type=\"checkbox\" class=\"js-switch\"></p><p>Declaro que li, ouvi e vi todo o conteúdo deste áudio e estou ciente que esta informação será enviada para o administrador dessa empresa para processo e documentação</p><p><b>Tema:</b></p><p>{{tema}}</p></div></div></div></div><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 m-b-sm\"><p><b>Descrição</b></p><p>{{descricao}}</p></div></div></div></div></div></div>");
$templateCache.put("app/esqueceuSenha/esqueceuSenha.html","<div class=\"login-page\"><div class=\"middle-box text-center loginscreen animated fadeInDown\" ng-controller=\"EsqueceuSenhaController as login\"><div><div><h1 class=\"titulo-esqueceu-senha\">Esqueceu a Senha?</h1></div><p class=\"text-white\">Use seu e-mail para solicitar nova senha.</p><form class=\"m-t\" role=\"form\" action=\"#\"><div class=\"form-group\"><input ng-model=\"email\" type=\"email\" class=\"form-control\" placeholder=\"E-mail\" required=\"\"></div><button type=\"button\" ng-click=\"enviaEmail($event)\" class=\"btn btn-info block full-width m-b\">Enviar</button> <a ui-sref=\"login\" class=\"text-white\"><small>Voltar para login?</small></a></form><p class=\"m-t text-white\"><small>Ábaris Ouview &copy; 2019</small></p></div></div></div>");
$templateCache.put("app/login/login.html","<div class=\"login-page animated fadeInDown\" ng-controller=\"LoginController as vm\" ng-cloak=\"\"><div class=\"middle-box loginscreen\"><div><div id=\"logo-login\"><div><h1 class=\"logo-name\"><img ng-src=\"{{ vm.objParametros.logomarca }}\"></h1></div><div class=\"\"><h2 class=\"logo-2nd\" ng-show=\"vm.temlogocliente\"><img src=\"../../assets/images/logo-login.png\"></h2></div></div><form class=\"m-t\" role=\"form\" action=\"#\"><div class=\"form-group\"><input ng-model=\"vm.objLogin.login\" type=\"text\" class=\"form-control\" placeholder=\"Usuário ou e-mail\" required=\"\"></div><div class=\"form-group\"><input ng-model=\"vm.objLogin.password\" type=\"password\" class=\"form-control\" placeholder=\"Senha\" required=\"\"></div><button type=\"button\" ng-click=\"vm.signIn($event)\" class=\"btn btn-info block full-width m-b\">Entrar</button></form><div class=\"text-center\"><a ui-sref=\"esqueceuSenha\" class=\"text-white\"><small>Esqueceu a senha?</small></a></div><p id=\"versao\" class=\"m-t text-white text-center\"><small>Ábaris Ouview &copy; 2019 - Stoque Soluções Tecnológicas Ltda. Versão: <span id=\"lblVersao\"></span></small></p></div></div><div class=\"modal fade\" id=\"modalTrocaSenha\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalTrocaSenha\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Fechar\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Insira uma nova senha para ter acesso ao sistema</h4></div><div class=\"modal-body\"><form name=\"formTrocaSenha\" ng-model=\"formTrocaSenha\" novalidate=\"\"><div class=\"form-group\"><input type=\"password\" class=\"form-control\" name=\"password\" ng-model=\"vm.objTrocaSenha.password\" required=\"\" placeholder=\"Nova Senha\"><div ng-show=\"formTrocaSenha.vm.objTrocaSenha.password.$invalid && formTrocaSenha.vm.objTrocaSenha.password.$dirty\"><small class=\"text-danger\" ng-show=\"formTrocaSenha.vm.objTrocaSenha.password.$error.required\">O preenchimento do campo é obrigatório</small></div></div><div class=\"form-group\"><input type=\"password\" class=\"form-control\" name=\"passwordConfirm\" ng-model=\"vm.objTrocaSenha.passwordConfirm\" required=\"\" placeholder=\"Confirmar Senha\"><div ng-show=\"formTrocaSenha.vm.objTrocaSenha.passwordConfirm.$invalid && formTrocaSenha.vm.objTrocaSenha.passwordConfirm.$dirty\"><small class=\"text-danger\" ng-show=\"formTrocaSenha.vm.objTrocaSenha.passwordConfirm.$error.required\">O preenchimento do campo é obrigatório</small></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Fechar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.atualizaSenha()\">Salvar</button></div></div></div></div></div>");
$templateCache.put("app/main/main.html","<div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Home</h2></div><div class=\"wrapper wrapper-content animated fadeInUp clearfix\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"row\"><div class=\"col-lg-4\"><div class=\"widget-head-color-box navy-bg p-lg text-center\"><div class=\"m-b-md\"><h2 class=\"font-bold no-margins\" style=\"word-break: break-word;\">{{ main.objUsuario.name}}</h2></div><img alt=\"image\" ng-if=\"main.objUsuario.foto\" class=\"img-circle circle-border m-b-md\" src=\"{{main.objUsuario.foto}}\"> <img alt=\"image\" ng-if=\"!main.objUsuario.foto\" class=\"img-circle circle-border m-b-md\" src=\"../assets/images/profile_empty.jpg\"><div><span>{{main.total}} Conteúdo (s)</span> | <span>{{main.concluidos}} Concluído (s)</span></div><div><a class=\"alterar-senha\" href=\"javascript:;\" data-toggle=\"modal\" data-target=\"#modalAlterarSenha\">Alterar Senha</a></div></div><div class=\"widget-text-box\"><div class=\"text-area\"><strong>Área:</strong> {{main.areaPerfil}}</div><div class=\"text-perfil\"><strong>Perfil:</strong> {{main.cargoPerfil}}</div></div></div><div class=\"col-lg-8\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"widget style1 navy-bg cursor-pointer\" ng-click=\"main.IrParaConteudos()\"><div class=\"row\"><div class=\"col-xs-4\"><i class=\"fa fa-book fa-5x\"></i></div><div class=\"col-xs-8 text-right\"><span>Ir para:</span><h2 class=\"font-bold\">Conteúdos</h2></div></div></div></div><div class=\"col-md-6\"><div class=\"widget style1 navy-bg cursor-pointer\" ng-click=\"main.IrParaNotificacoes($event)\"><div class=\"row\"><div class=\"col-xs-4\"><i class=\"fa fa-bell fa-5x\"></i> <span class=\"badge badge-danger badge-absolute\">{{novos}}</span></div><div class=\"col-xs-8 text-right\"><span>Ir para:</span><h2 class=\"font-bold\">Notificações</h2></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\" ng-if=\"main.banners.imagens.length\"><div class=\"ibox\"><div class=\"ibox-content\"><div id=\"carousel-example-generic\" class=\"carousel slide\" data-ride=\"carousel\"><div class=\"carousel-inner\" role=\"listbox\"><div class=\"item active\" ng-repeat=\"banner in main.banners.imagens\" ng-if=\"$first\"><img src=\"{{banner}}\"></div><div class=\"item\" ng-repeat=\"banner in main.banners.imagens\" ng-if=\"!$first\"><img src=\"{{banner}}\"></div></div><ol class=\"carousel-indicators\"><li data-target=\"#carousel-example-generic\" ng-repeat=\"banner in main.banners.imagens\" data-slide-to=\"{{$index}}\" ng-if=\"$first\" class=\"active\"></li><li data-target=\"#carousel-example-generic\" ng-repeat=\"banner in main.banners.imagens\" data-slide-to=\"{{$index}}\" ng-if=\"!$first\"></li></ol></div></div></div></div><div class=\"col-md-6\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Porcentagem de conclusão</h5></div><div class=\"ibox-content\"><div id=\"msgVazio\" ng-if=\"main.total <= 0\">Sem dados de progresso</div><div id=\"grafico\"></div></div></div></div></div></div></div></div></div></div><div class=\"modal fade\" id=\"modalAlterarSenha\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalAlterarSenha\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Fechar\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Alterar Senha</h4></div><div class=\"modal-body\"><div class=\"form-group\"><input id=\"senhaAtual\" type=\"text\" class=\"form-control\" ng-model=\"formSenha.senhaAtual\" placeholder=\"Senha Atual\"></div><div class=\"form-group\"><input id=\"novaSenha\" type=\"text\" class=\"form-control\" ng-model=\"formSenha.novaSenha\" placeholder=\"Nova Senha\"> <small>Mínimo de 6 caracteres</small></div><div class=\"form-group\" style=\"margin-bottom: 0;\"><input id=\"confirmaSenha\" type=\"text\" class=\"form-control\" ng-model=\"formSenha.confirmaSenha\" placeholder=\"Confirmar Senha\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Fechar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"main.updateSenha(formSenha)\">Salvar</button></div></div></div></div>");
$templateCache.put("app/temas/temas.html","<div ng-controller=\"TemasController as temas\"><div class=\"row dashboard-header ng-scope\"><h2 class=\"ng-binding\">Conteúdos - Lista</h2></div><h4>Temas</h4><div class=\"wrapper wrapper-content animated fadeInUp clearfix temas-wrapper\"><div class=\"ibox pull-left\" ng-repeat=\"tema in temas\"><div class=\"ibox-content\" data-codigo=\"{{tema.cod}}\" ng-click=\"IrParaConteudo($event)\"><h3 title=\"Segurança no trabalho\">{{tema.nome}}</h3><p class=\"item-percent\">{{tema.porcentagem}}</p><div class=\"item-progress\"><div class=\"item-barra\" style=\"width: {{tema.porcentagem}}; background-color: {{tema.color}}\"></div></div><p class=\"small\">{{tema.concluidos}} de {{tema.total}} finalizados</p></div></div></div></div>");
$templateCache.put("app/components/common/cardContent.html","<div id=\"wrapper\"><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ui-view=\"\"></div></div></div>");
$templateCache.put("app/components/common/comentarios.html","<div class=\"ico-comment\"><i class=\"fa fa-comment\" data-toggle=\"modal\" data-target=\"#modalComentario\"></i></div><div class=\"modal fade\" id=\"modalComentario\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalComentario\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Fechar\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Comentário do Conteúdo {{nomeConteudo}}</h4></div><div class=\"modal-body\"><div class=\"form-group\"><textarea id=\"comentario\" rows=\"10\" maxlength=\"180\" class=\"form-control\" ng-model=\"comentario\" placeholder=\"Digite aqui seu comentário\"></textarea> <span>Caracteres restantes:</span>&nbsp;<span id=\"chars\">180</span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Fechar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"apagar(comentario)\">Apagar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"update(comentario)\">Salvar</button></div></div></div></div>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\" ng-controller=\"MainController as main\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\">&nbsp;</div><div><strong>Copyright</strong> &copy; Ábaris Ouview</div></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div><div class=\"sidebar-collapse\"><div class=\"nav-header\"><div class=\"logo-abaris\" ng-if=\"main.objEmpresa.foto\"><a ui-sref=\"index.main\"><img alt=\"image\" class=\"\" ng-src=\"{{main.objEmpresa.foto}}\"></a></div><div class=\"profile-element\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"lbl-usuario block m-t-xs\"><strong class=\"font-bold\">{{main.objUsuario.name}}</strong></span></span></a> <img alt=\"image\" ng-if=\"main.objUsuario.foto\" class=\"img-circle\" ng-src=\"{{main.objUsuario.foto}}\"> <img alt=\"image\" ng-if=\"!main.objUsuario.foto\" class=\"img-circle\" src=\"../assets/images/profile_empty.jpg\"></div></div><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\" style=\"display: block;\"><li ui-sref-active=\"active\"><a ui-sref=\"index.main\"><i class=\"fa fa-home\"></i> <span class=\"nav-label\">Home</span></a></li><li ui-sref-active=\"active\" ng-class=\"{active: $state.includes(\'index.conteudos\') || $state.includes(\'index.detalhes\') || $state.includes(\'index.detalhesAudio\')}\"><a ui-sref=\"index.temas\"><i class=\"fa fa-book\"></i> <span class=\"nav-label\">Conteúdos</span></a></li><li ui-sref-active=\"active\" ng-class=\"{active: $state.includes(\'index.configurarAplicativo\')}\"><a href=\"\"><i class=\"fa fa-cog\"></i> <span class=\"nav-label\">Configurações</span></a><ul class=\"sidebar-menu nav nav-second-level collapse in\"><li ui-sref-active=\"active\"><a ui-sref=\"index.configurarAplicativo\"><i class=\"fa fa-mobile\"></i> <span class=\"nav-label\">Configurar Aplicativo</span></a></li></ul></li><li ui-sref-active=\"active\" ng-class=\"\"><a href=\"\"><i class=\"fa fa-user\"></i> <span class=\"nav-label\">Perfil</span></a><ul class=\"sidebar-menu nav nav-second-level collapse in\"><li ui-sref-active=\"active\"><a data-toggle=\"modal\" data-target=\"#modalEditarPerfil\"><i class=\"fa fa-pencil\"></i> <span class=\"nav-label\">Editar Perfil</span></a></li></ul></li><li ng-class=\"{active: $state.includes(\'index.cadastroUsuarios\') || $state.includes(\'index.cadastroConteudos\') || $state.includes(\'index.cadastroTemas\') || $state.includes(\'index.cadastroEmpresas\') || $state.includes(\'index.cadastroCargos\') || $state.includes(\'index.cadastroAreas\') || $state.includes(\'index.cadastroBanners\') || $state.includes(\'index.enviarNotificacoes\')}\" ng-if=\"main.objUsuario.admin === true\"><a href=\"\"><i class=\"fa fa-cog\"></i> <span class=\"nav-label\">Administração</span></a><ul class=\"sidebar-menu nav nav-second-level collapse in\"><li class=\"treeview\"><a href=\"\"><i class=\"fa fa-user\"></i><spam class=\"nav-label\">Usuários</spam><span class=\"pull-right-container\"></span></a><ul class=\"treeview-menu\"><li ui-sref-active=\"active\"><a ui-sref=\"index.cadastroEmpresas\"><i class=\"fa fa-book\"></i> <span class=\"nav-label\">Unidades</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.cadastroAreas\"><i class=\"fa fa-book\"></i> <span class=\"nav-label\">Áreas</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.cadastroCargos\"><i class=\"fa fa-book\"></i> <span class=\"nav-label\">Perfil</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.cadastroUsuarios\"><i class=\"fa fa-book\"></i> <span class=\"nav-label\">Usuários</span></a></li></ul></li><li class=\"treeview\"><a href=\"\"><i class=\"fa fa-folder\"></i><spam class=\"nav-label\">Conteúdos</spam><span class=\"pull-right-container\"></span></a><ul class=\"treeview-menu\"><li ui-sref-active=\"active\"><a ui-sref=\"index.cadastroTemas\"><i class=\"fa fa-book\"></i> <span class=\"nav-label\">Temas</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.cadastroConteudos\"><i class=\"fa fa-book\"></i> <span class=\"nav-label\">Conteúdos</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.insightsConteudo\"><i class=\"fa fa-book\"></i> <span class=\"nav-label\">Insights de &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Conteúdo</span></a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"index.cadastroBanners\"><i class=\"fa fa-book\"></i> <span class=\"nav-label\">Banners</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.enviarNotificacoes\"><i class=\"fa fa-bell\"></i> <span class=\"nav-label\">Enviar Notificações</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.parametros\"><i class=\"fa fa-bell\"></i> <span class=\"nav-label\">Parâmetros</span></a></li></ul></li></ul><div class=\"m-t-sm\"><img style=\"width: 100px\" alt=\"image\" class=\"m-r-sm\" src=\"../assets/images/logo.png\"></div></div></div></nav><div class=\"modal fade\" id=\"modalEditarPerfil\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modalEditarPerfil\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"main.fecharModal()\" aria-label=\"Fechar\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Atualizar foto do perfil</h4></div><div class=\"modal-body\"><div class=\"file-upload\"><div class=\"image-upload-wrap\"><input class=\"file-upload-input\" type=\"file\" onchange=\"angular.element(this).scope().main.alterarFoto(this);\" accept=\"images/*\"><div class=\"drag-text\"><img src=\"../assets/images/photo icon.png\"><h3>Solte a foto aqui, ou clique para escolher</h3></div></div><div class=\"image-crop-wrap\" ng-show=\"main.myCroppedImage\"><ui-cropper class=\"image-crop\" image=\"main.myImage\" area-type=\"circle\" chargement=\"\'Loading\'\" result-image=\"main.myCroppedImage\" canvas-scalemode=\"true\" allow-crop-resize-on-corners=\"false\" disable-keyboard-access=\"false\" init-max-area=\"true\"></ui-cropper><div class=\"image-view\"><img src=\"{{main.myCroppedImage}}\"></div></div><div class=\"file-upload-content\"><div class=\"image-title-wrap\"><button type=\"button\" ng-click=\"main.removeUpload()\" class=\"btn btn-danger\">Remover <span class=\"image-title\"></span></button></div></div></div><div class=\"form-group\" style=\"margin-bottom: 0;\"><label for=\"nomePerfil\" class=\"nomePerfil\">* Editar nome de perfil</label> <input id=\"nomePerfil\" type=\"text\" class=\"form-control\" maxlength=\"65\" ng-model=\"main.nomePerfil\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"main.fecharModal()\">Fechar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"main.updatePerfil()\">Salvar</button></div></div></div></div>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row\"><nav class=\"navbar navbar-fixed-top\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span></div><ul class=\"nav navbar-top-links navbar-right\"><li class=\"dropdown\" uib-dropdown=\"\"><a id=\"btNotificacoes\" class=\"count-info dropdown-toggle\" href=\"\" uib-dropdown-toggle=\"\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bell\"></i> <span class=\"label label-danger\">{{novos}}</span></a><ul class=\"dropdown-alerts dropdown-menu\" uib-dropdown-menu=\"\"><li ng-repeat=\"item in arrayConteudo\"><a href=\"#/index/conteudos?cod={{item.id}}\"><div>Novo conteúdo em {{item.nome}}</div></a></li><li class=\"divider\"></li><li><div class=\"text-center link-block\"><a ui-sref=\"index.temas\"><strong>Ver todos os temas</strong> <i class=\"fa fa-angle-right\"></i></a></div></li></ul></li><li><a href=\"#\" ng-click=\"main.LogOut()\"><i class=\"fa fa-sign-out\"></i> Log out</a></li></ul></nav></div>");
$templateCache.put("app/components/common/viewer.html","<nav ng-class=\"getNavStyle(scroll)\"><i ng-click=\"goPrevious()\" class=\"fa fa-chevron-left\" title=\"Página anterior\"></i> <i ng-click=\"goNext()\" class=\"fa fa-chevron-right\" title=\"Próxima página\"></i><span>Página:</span> <input type=\"text\" min=\"1\" ng-model=\"pageNum\" style=\"width: 50px\"> <span>/ {{pageCount}}</span> <span class=\"separador-toolbar\"></span> <i ng-click=\"zoomIn()\" class=\"fa fa-search-plus\" title=\"Mais Zoom\"></i> <button title=\"Ajustar à tela\" ng-click=\"fit()\"><span>100%</span></button> <i ng-click=\"zoomOut()\" class=\"fa fa-search-minus\" title=\"Menos Zoom\"></i> <span class=\"separador-toolbar\"></span> &nbsp;&nbsp; <span>URL do Documento:</span> <input type=\"text\" ng-model=\"pdfUrl\"> <a href=\"{{pdfUrl}}\" target=\"_blank\" class=\"fa fa-download\" title=\"Download\"></a> <span class=\"separador-toolbar\"></span><div class=\"fr\"><likedislike conteudoid=\"codigo\"></likedislike><comentario conteudoid=\"codigo\"></comentario></div></nav><hr>{{loading}}<canvas id=\"pdf\" class=\"rotate0\"></canvas><hr><nav class=\"pdf-controls\"><i ng-click=\"goPrevious()\" class=\"fa fa-chevron-left\"></i> <i ng-click=\"goNext()\" class=\"fa fa-chevron-right\"></i> <span>Page:</span> <input type=\"text\" min=\"1\" ng-model=\"pageNum\" style=\"width: 50px\"> <span>/ {{pageCount}}</span></nav>");}]);